(function($) {

var uploader = (function()
{
	var doc = $(document);
	var win = $(window);
	var htmlBody = $("html, body");
	var body = $('body');

	var speed = 200;

	var resize = function()
	{
		win.resize($.throttle(100, function()
		{
			$('.drop-open').removeClass('drop-open');
		}));
	}

	var scroll = {

		to : function(position)
		{
			var max = doc.height() - win.height();
			htmlBody.stop().animate({ scrollTop : position > max ? max : position }, speed / 2);
		},
		top : function()
		{
			this.to(0);
		},
		obj : function(obj, offset)
		{
			var min = win.scrollTop();
			var top = obj.offset().top;

			if (top + offset < min + 81 || top + obj.height() > min + win.height())
			{
				scroll.to(top - 81 + offset);
			}
		},
		difference : function(obj, action)
		{
			var top = win.scrollTop();
			var pos = obj.offset().top;

			action();

			var diff = pos - obj.offset().top;
			if (diff !== 0)
			{
				win.scrollTop(top - diff);
			}
		}

	};

	var detect = {
		isWebkit: function()
		{
			return /webkit/.test(this.opts.userAgent);
		},
		isFirefox: function()
		{
			return this.opts.userAgent.indexOf('firefox') > -1;
		},
		isIe: function(v)
		{
						if (document.documentMode || /Edge/.test(navigator.userAgent))
						{
								return 'edge';
						}

			var ie;
			ie = RegExp('msie' + (!isNaN(v)?('\\s'+v):''), 'i').test(navigator.userAgent);

			if (!ie)
			{
				ie = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);
			}

			return ie;
		},
		isMobile: function()
		{
			return /(iPhone|iPad|BlackBerry|Android)/.test(navigator.userAgent);
		},
		isDesktop: function()
		{
			return !/(iPhone|iPad|iPad|BlackBerry|Android)/.test(navigator.userAgent);
		},
		isIpad: function()
		{
			return /iPad/.test(navigator.userAgent);
		}
	}

	var overlay = {

		obj : $('.overlay'),

		show : function()
		{
			this.obj.addClass('show');
		},
		hide : function()
		{
			this.obj.addClass('hide');
			window.setTimeout(this.remove.bind(this), speed);
		},
		remove : function()
		{
			this.obj.removeClass('show hide');
		}

	};

	var loading = {

		start : function()
		{
			body.addClass('loading');
		},
		stop : function()
		{
			body.removeClass('loading');
		}

	};

	var slides = {

		overlay : $('.slides-overlay'),

		init : function()
		{
			this.slides = $('.slides');
			this.content = $('.slide-content');

			if (this.slides.length)
			{
				this.launch();
			}
			else if (this.content.length)
			{
				this.build();
				this.next();
			}
		},
		launch : function()
		{
			this.slide = $('.slide');
			var action = this.slide.find('.btn:not(.action)');

			if (!this.content.length)
			{
				action.click(this.close.bind(this));
			}
			else
			{
				action.click(function()
				{
					this.next();
				}
				.bind(this));
			}
		},
		build : function()
		{
			this.slides = $('<div class="slides">');
			this.central = $('<div class="central">');
			this.slide = $('<div class="slide">');

			this.central.append(this.slide);
			this.slides.append(this.central);
		},
		show : function(content)
		{
			this.slide.html(content.html());
			this.slides.css('top', win.scrollTop());

			content.remove();

			var action = this.slide.find('.btn:not(.action)');

			if (!this.content.length)
			{
				action.click(this.close.bind(this));
			}
			else {
				action.click(function()
				{
					this.next();
				}
				.bind(this));
			}

			this.overlay.addClass('show');
			body.append(this.slides);

			window.setTimeout(function()
			{
				this.overlay.css('transition', 'opacity .3s');
			}
			.bind(this), 20);
		},
		next : function()
		{
			var content = this.content.slice(0,1);
			this.content = this.content.slice(1);
			this.show(content);
		},
		close : function()
		{
			this.slides.remove();
			this.overlay.addClass('hide');
			window.setTimeout(this.remove.bind(this), speed);
		},
		remove : function()
		{
			this.overlay.removeClass('show hide');
		},
		reset : function()
		{
			$('.slides').remove();
		}
	};

	var popups = {
		init : function()
		{
			var popups = $('[data-popup]');
			popups.each(function(i, obj) {
				var popup = $(obj);

				var header = popup.data('popup-header');
				var message = popup.data('popup-message');
				var url = popup.attr('href');

				popup.click(function(e) {
					e.preventDefault();

					var slide = '<div class="slide-content">'
						+ '<svg viewBox="0 0 97 89" class="icon icon-warning"> <path d="M94.478,69.866c-5.581-9.561-29.38-51.956-35.752-62.901 c-5.499-9.447-14.641-9.105-19.893-0.06c-3.677,6.332-31.285,54.61-36.549,63.873C-2.979,80.041,1.244,89,10.944,89h76.164 C96.461,89,99.77,78.933,94.478,69.866z M49.331,78.124c-3.619,0-6.554-2.937-6.554-6.561c0-3.622,2.935-6.559,6.554-6.559 c3.62,0,6.555,2.937,6.555,6.559C55.886,75.188,52.951,78.124,49.331,78.124z M55.893,29.503 c-0.52,8.153-1.324,16.459-1.716,21.393c-0.392,4.935-1.197,8.831-4.864,8.831s-4.408-2.608-4.92-9.009 c-0.512-6.4-1.015-12.883-1.43-21.131c-0.416-8.249,1.315-11.771,6.573-11.771C54.794,17.815,56.412,21.35,55.893,29.503z"/></svg>'
						+ '<h3>' + header + '</h3>'
						+ '<p>' + message + '</p>'
						+ '<a class="btn btn-lg btn-red" href="javascript:;">No - Cancel</a>'
						+ '<a class="btn btn-lg btn-green action" href="' + url + '">Yes - Continue</a>'
						+ '</div>';

					body.append(slide);
					slides.init();
				});
			});
		}
	}

	var dropdowns = function() {
		var toggles = $('.drop-toggle');
		toggles.each(function(i, obj)
		{
			var toggle = $(obj);
			var menu = toggle.next();

			var toggleWidth = toggle.outerWidth();
			var menuWidth = menu.outerWidth();

			if (typeof toggle.attr('data-initiated') == 'undefined')
			{
				toggle.css('width', toggleWidth + 1 + 'px');
			}

			if (menuWidth > toggleWidth)
			{
				window.setTimeout(function()
				{
					toggle.css('width', menuWidth + 1 + 'px');
				}
				, 20);
			}

			if (typeof toggle.attr('data-initiated') == 'undefined')
			{
				toggle.attr('data-initiated', 'true');

				toggle.click(function()
				{
					toggle.toggleClass('drop-open');
				});

				var links = menu.find('a');
				links.each(function(i, link)
				{
					var link = $(link);
					link.click(function()
					{
						toggle.find('span').text(link.text());
						toggle.toggleClass('drop-open');
					});
				});
			}
		});
	}

	$.Redactor.prototype.bufferbuttons = function()
	{
		return {

			init: function()
			{
				var undo = this.button.add('undo', 'Undo');
				var redo = this.button.add('redo', 'Redo');

				this.button.addCallback(undo, this.buffer.undo);
				this.button.addCallback(redo, this.buffer.redo);

				this.button.setIcon(undo, '<i class="re-icon-undo"></i>');
				this.button.setIcon(redo, '<i class="re-icon-redo"></i>');
			}

		};
	};

	$.Redactor.prototype.video = function()
	{
		return {

			reUrlYoutube: /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig,
			reUrlVimeo: /https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/,

			langs: {
				en: {
					"video": "Insert Video",
					"video-html-code": "Paste a Youtube or Vimeo link in the box below."
				}
			},

			getTemplate: function()
			{
				return String()
					+ '<div class="modal-section" id="redactor-modal-video-insert">'
						+ '<div class="redactor-modal-hint">' + this.lang.get('video-html-code') + '</div>'
						+ '<section>'
							+ '<label>Link</label>'
							+ '<input type="text" id="redactor-insert-video-area" />'
						+ '</section>'
						+ '<section class="footer">'
							+ '<button id="redactor-modal-button-action" class="btn btn-lg btn-green">Insert</button>'
							+ '<button id="redactor-modal-button-cancel" class="btn btn-lg btn-grey">Cancel</button>'
						+ '</section>'
					+ '</div>';
			},
			init: function()
			{
				var button = this.button.addBefore('link', 'video', this.lang.get('video'));
				this.button.setIcon(button, '<i class="re-icon-video"></i>');
				this.button.addCallback(button, this.video.show);
			},
			show: function()
			{
				this.modal.addTemplate('video', this.video.getTemplate());
				this.modal.load('video', this.lang.get('video'), 500);

				this.modal.getActionButton().text(this.lang.get('insert')).on('click', this.video.insert);
				this.modal.show();

				if (this.detect.isDesktop())
				{
					setTimeout(function() {
						$('#redactor-insert-video-area').focus();
					}, 1);
				}
			},
			insert: function()
			{
				var data = $('#redactor-insert-video-area').val();
				var matches = data.match(/<iframe|<video/gi);

				this.opts.videoContainerClass = (typeof this.opts.videoContainerClass === 'undefined') ? 'video-container' : this.opts.videoContainerClass;
				var iframeStart = '<div class="' + this.opts.videoContainerClass + '"><iframe style="width: 500px; height: 281px;" src="',
					iframeEnd = '" frameborder="0" allowfullscreen></iframe></div>';

				if (matches && matches.length !== 0)
				{
					var allowed = ['iframe', 'video'];
					var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;

					data = data.replace(tags, function ($0, $1) {
						return (allowed.indexOf($1.toLowerCase()) === -1) ? '' : $0;
					});


					if (data.match(this.video.reUrlYoutube))
					{
						data = data.replace(this.video.reUrlYoutube, iframeStart + '//www.youtube.com/embed/$1' + iframeEnd);
					}
					else if (data.match(this.video.reUrlVimeo))
					{
						data = iframeStart + data.replace(this.video.reUrlVimeo, '//player.vimeo.com/video/$2/?h=') + iframeEnd;
					}
					else
					{
						data = '<div class="' + this.opts.videoContainerClass + '">' + data + '</div>';
					}
				}else if (data.match(this.video.reUrlYoutube)){
					data = data.replace(this.video.reUrlYoutube, iframeStart + '//www.youtube.com/embed/$1' + iframeEnd);
				}else if (data.match(this.video.reUrlVimeo)){
					data = iframeStart + data.replace(this.video.reUrlVimeo, '//player.vimeo.com/video/$2/?h=') + iframeEnd;
				}

				this.modal.close();
				this.placeholder.hide();

				this.buffer.set();

				this.air.collapsed();
				this.insert.html(data);
			},
			keyup: function(e)
			{
				var key = e.which;
				var $block = $(this.selection.block());

				return this.video.moveCursorOutside(key, $block);
			},
			keydown: function(e)
			{
				var key = e.which;
				var $block = $(this.selection.block());

				if (!this.video.moveCursorOutside(key, $block))
				{
					return false;
				}

				if (key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE)
				{
					var $block = $(this.selection.block());
					var $prev = $block.prev('.video-container');

					if ($prev.length)
					{
						var sel = this.selection.get();
						var range = this.selection.range(sel);

						if (range.endOffset === 0)
						{
							$prev.remove();
							return false;
						}
					}
				}

				return true;
			},
			moveCursorOutside: function(key, $block)
			{
				if (typeof $block[0] !== 'undefined' && $block[0].tagName === 'DIV' && $block.hasClass('video-container'))
				{
					var marker = this.marker.get();
					if (key === this.keyCode.DOWN || key === this.keyCode.RIGHT)
					{
						var $next = $block.next();
						if ($next.length)
						{
							$next.prepend(marker);
						}
						else
						{
							var $p = $('<p>');
							$p.append(marker);
							$block.after($p);
						}
					}
					else
					{
						var $prev = $block.prev();
						if ($prev.length)
						{
							$prev.append(marker);
						}
						else
						{
							var $p = $('<p>');
							$p.append(marker);
							$block.before($p);
						}

					}

					this.selection.restore();
					return false;
				}
				return true;
			}

		};
	};

	$.Redactor.prototype.definedlinks = function()
	{
		return {
			init: function()
			{
				this.modal.addCallback('link', $.proxy(this.definedlinks.load, this));
			},
			load: function()
			{
				var $section = $('<section />');
				var $select = $('<select id="redactor-defined-links" />');

				$section.append($select);
				$('.redactor-modal-tab').prepend($section);

				this.definedlinks.storage = {};

				$.each(config.links, function(i, obj)
				{
					$select.append($('<option>').val(i).html(obj.name));
				}
				.bind(this));

				$select.on('change', $.proxy(this.definedlinks.select, this));
			},
			select: function(e)
			{
				var link = config.links[$(e.target).val()];
				var text = $.trim($('#redactor-link-url-text').val());

				if (link.url)
				{
					$('#redactor-link-url').val(link.url);
				}

				if (text === '')
				{
					$('#redactor-link-url-text').val(link.name);
				}
			}

		};
	};

	$.Redactor.prototype.insertCode = function() {
		return {

			init: function()
			{
				var button = this.button.addBefore('link', 'insertCode', this.lang.get('insertCode'));

				this.button.setIcon(button, '<i class="re-icon-html"></i>');
				this.button.addCallback(button, this.insertCode.show);

				this.modal.addTemplate('insertCode', this.insertCode.getTemplate());
			},
			show: function()
			{
				this.modal.load('insertCode', 'Insert Widget Code', 700);

				this.modal.getActionButton().on('click', this.insertCode.insert);
				this.modal.show();
			},
			getTemplate: function()
			{
				return String()
					+ '<div class="modal-section" id="redactor-modal-insert-code">'
						+ '<div class="redactor-modal-hint">Paste your widget code into the box below.</div>'
						+ '<section>'
							+ '<textarea id="insert-code-box" rows="6"></textarea>'
						+ '</section>'
						+ '<section class="footer">'
							+ '<button id="redactor-modal-button-action" class="btn btn-lg btn-green">Insert</button>'
							+ '<button id="redactor-modal-button-cancel" class="btn btn-lg btn-grey">Cancel</button>'
						+ '</section>'
					+ '</div>';
			},
			insert: function()
			{
				ajaxRequest(
					config.code.url,
					{
						code : $('#insert-code-box').val()
					},
					this.insertCode.processResponse.bind(this),
					'insert your code'
				);
			},
			processResponse: function(data)
			{
				if (data.success !== undefined)
				{
					this.selection.restore();
					this.placeholder.hide();

					var $block = $(this.selection.block());
					var $code = $('<p class="widget-code">');

					$code.attr('data-id', data.id);
					$code.html(data.code);

					var $outer = $block.parentsUntil('.redactor-styles').last();
					if ($outer.length)
					{
						$block = $outer;
					}

					if (!this.utils.isEmpty($block.html()))
					{
						this.modal.close();
						this.buffer.set();

						$block.after($code);
						loading.stop();

						return;
					}

					this.modal.close();
					this.buffer.set();

					$block.replaceWith($code);

					var marker = this.marker.get();
					var $p = $('<p>');

					$p.append(marker);
					$code.after($p);

					this.selection.restore();
				}
				else
				{
					this.modal.close();
					this.placeholder.hide();
				}

				loading.stop();
			},
			keyup: function(e)
			{
				var key = e.which;
				var $block = $(this.selection.block());

				if ($block.hasClass('widget-code'))
				{
					var marker = this.marker.get();

					if (key === this.keyCode.DOWN || key === this.keyCode.RIGHT)
					{
						var $next = $block.next();

						if ($next.length)
						{
							$next.prepend(marker);
						}
						else
						{
							var $p = $('<p>');
							$p.append(marker);
							$block.after($p);
						}
					}
					else
					{
						var $prev = $block.prev();

						if ($prev.length)
						{
							$prev.append(marker);
						}
						else
						{
							var $p = $('<p>');
							$p.append(marker);
							$block.before($p);
						}
					}

					this.selection.restore();

					return false;
				}

				return true;
			},
			keydown: function(e)
			{
				var key = e.which;
				if (key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE)
				{
					var $block = $(this.selection.block());
					var $prev = $block.prev('.widget-code');

					if ($prev.length)
					{
						var sel = this.selection.get();
						var range = this.selection.range(sel);

						if (range.endOffset === 0)
						{
							this.buffer.set();
							$prev.remove();
							this.code.sync();

							return false;
						}
					}
				}

				return true;
			},
			click: function(e)
			{
				var $block = $(this.selection.block());
				if ($block.hasClass('widget-code'))
				{
					var marker = this.marker.get();
					var $next = $block.next();

					if ($next.length)
					{
						$next.prepend(marker);
					}
					else
					{
						var $p = $('<p>');
						$p.append(marker);
						$block.after($p);
					}

					this.selection.restore();
				}

				return true;
			}

		};
	};

	$.Redactor.prototype.uploadFile = function()
	{
		return {

			init: function ()
			{
				var button = this.button.addBefore('link', 'uploadFile', 'Upload File');

				this.button.addCallback(button, this.uploadFile.uploadCallback);
				this.button.setIcon(button, '<i class="re-icon-file"></i>');

				this.modal.addTemplate('uploadFile', String()
					+ '<div class="redactor-modal-tab" data-title="Upload">'
						+ '<section>'
							+ '<label>Name</label>'
							+ '<input type="text" id="redactor-file-name" aria-label="Name" placeholder="( optional )" />'
						+ '</section>'
						+ '<section>'
							+ '<div id="upload-single" class="upload">'
								+ '<a id="add-file" href="javascript:;">'
									+ '<span class="click">Click</span> or drag your file here to upload...'
								+ '</a>'
								+ '<div class="progress"><div class="bar"></div></div>'
							+ '</div>'
						+ '</section>'
						+ '<section class="footer">'
							+ '<button id="redactor-modal-button-cancel" class="btn btn-lg btn-grey">' + this.lang.get('cancel') + '</button>'
						+ '</section>'
					+ '</div>');

				this.modal.addTemplate('deleteFile', String()
					+ '<div class="redactor-modal-tab redactor-modal-file">'
						+ '<section class="hint">Are you sure you want to delete the following file?</section>'
						+ '<section>'
							+ '<a class="item" href="#"></a>'
						+ '</section>'
						+ '<section class="footer">'
							+ '<button class="btn btn-lg btn-grey action-cancel">No - Cancel</button>'
							+ '<button class="btn btn-lg btn-red action-delete">Yes - Delete</button>'
						+ '</section>'
					+ '</div>');

				this.uploadFile.editableFiles();
			},
			uploadCallback: function(buttonName)
			{
				this.modal.load('uploadFile', this.lang.get('file'), 600);

				this.uploadFile.browse = $('#add-file');
				this.uploadFile.container = $('#upload-single');
				this.uploadFile.name = $('#redactor-file-name');

				var progress = $('.progress');
				var bar = $('.progress .bar');

				this.uploadFile.browse.click(function()
				{
					this.uploadFile.container.next('.error-message').remove();
				}
				.bind(this));

				var uploaderConfig = {
					runtimes : 'html5',
					browse_button : 'add-file',
					container: 'upload-single',
					max_file_size : '100mb',
					multipart_params : { _csrf : config.token },
					chunk_size : 204800,
					multi_selection : false,
					url: config.file.url,
					filters: {
						max_file_size: "100mb",
						prevent_duplicates: true
					},
					headers:{
						'X-UPLOAD-FILE': 'yes'
					},
					max_retries:0
				}

				if (detect.isDesktop()) {
					uploaderConfig.drop_element = 'add-file';
				}

				var up = new plupload.Uploader(uploaderConfig);

				up.init();

				up.bind('Error', function(up, data)
				{
					up.stop();

					if (data.code == plupload.HTTP_ERROR){
						switch (data.status){
							case 403: // Forbidden

								function retry(){
									data.file.status = plupload.QUEUED;
									up.start();
								}

								accessDenied(retry, 'upload files');

								return;

							break;
						}
					}

					this.uploadFile.handleError(up, data.file, data.message);
				}
				.bind(this));

				up.bind('FilesAdded', function(up, files)
				{
					this.uploadFile.browse.html('Loading (<span class="loading">0</span>%)');

					up.settings.multipart_params.filename = this.uploadFile.name.val();
					up.start();

					progress.addClass('show');

				},
				this);

				up.bind('BeforeUpload', function(up, file)
				{
					up.settings.multipart_params.token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
				}
				.bind(this));

				up.bind('FilesRemoved', function(up, files)
				{
					bar.css({ width : '0%' });
					window.setTimeout(function()
					{
						progress.removeClass('show');
					}
					.bind(this), speed * 3);
				});

				up.bind('ChunkUploaded', function(up, file, data)
				{
					var response = $.parseJSON(data.response);

					if (response.accessDenied){
						function retry(){}
						accessDenied(retry, 'upload files');

						this.uploadFile.handleError(up, file, 'The upload failed due to session timeout. Please try again.');
					}
					else if (response.error)
					{
						this.uploadFile.handleError(up, file, response.error);
					}
				},
				this);

				up.bind('FileUploaded', function(up, file, data)
				{
					var response = $.parseJSON(data.response);

					if (response.accessDenied){
						function retry(){}
						accessDenied(retry, 'upload files');

						this.uploadFile.handleError(up, file, 'The upload failed due to session timeout. Please try again.');
					}
					else if (response.error)
					{
						this.uploadFile.handleError(up, file, response.error);
					}
					else
					{
						this.uploadFile.insertFile(response);
					}
				},
				this);

				up.bind('UploadProgress', function(up, file)
				{
					this.uploadFile.browse.children('.loading').text(up.total.percent);
					bar.css({ width : up.total.percent+'%' });
				},
				this);

				this.modal.show();
			},
			handleError : function(up, file, error)
			{
				up.stop();
				up.removeFile(file.id);

				this.uploadFile.browse.html('<span class="error">' + error.message + '</span>');

				window.setTimeout(function()
				{
					this.uploadFile.browse.children('.error').css({ opacity : 0 });
					window.setTimeout(function()
					{
						this.uploadFile.browse.html('<span class="click">Click</span> or drag your file here to upload...')
					}
					.bind(this), speed);
				}
				.bind(this), 4000);
			},
			insertFile: function(file)
			{
				this.selection.restore();
				this.placeholder.hide();

				var $block = $(this.selection.block());
				var $div = $('<div class="file">');
				var $link = $('<div class="file-box">' + file.name + '</div>');

				var $outer = $block.parentsUntil('.redactor-styles').last();
				if ($outer.length) {
					$block = $outer;
				}

				$div.attr('data-file', file.id);
				$div.append($link).data('editable', false);

				var $linkBox = $('<div>');
				$linkBox.append($div);

				var html = $linkBox.html();
				this.buffer.set();
				this.insert.html(html);

				var $box = $(this.selection.current()).closest('.file');
				this.uploadFile.markerBelow($box);

				this.uploadFile.editableFiles();

				this.modal.close();
			},
			editableFiles: function()
			{
				var $files = $(this.core.editor()).find('.file');
				$files.each(function(i, file)
				{
					var $file = $(file);

					if (!$file.data('editable'))
					{
						$file.data('editable', true);
						$file.on('click touchstart', function()
						{
							this.modal.load('deleteFile', 'Delete a File', 500);

							var $item = $('.redactor-modal-file .item');
							$item.html($file.children().html());
							$item.attr('href', config.download.url + '/' + $file.data('file'));

							var $cancel = $('.redactor-modal-file .action-cancel');
							$cancel.click(function()
							{
								this.modal.close();
							}
							.bind(this));

							var $delete = $('.redactor-modal-file .action-delete');
							$delete.click(function()
							{
								this.buffer.set();
								$file.remove();
								this.code.sync();
								this.modal.close();
								this.selection.restore();
							}
							.bind(this));

							this.modal.show();
						}
						.bind(this));
					}
				}
				.bind(this));
			},
			keyup: function(e)
			{
				var key = e.which;
				var $block = $(this.selection.block());

				if (typeof $block[0] !== 'undefined' && ($block.hasClass('file') || $block.hasClass('file-box')))
				{
					var $file = $block.closest('.file');

					if (key === this.keyCode.DOWN || key === this.keyCode.RIGHT)
					{
						this.uploadFile.markerBelow($file);
					}
					else
					{
						this.uploadFile.markerAbove($file);
					}

					return false;
				}

				return true;
			},
			markerAbove: function($file)
			{
				var marker = this.marker.get();

				var $prev = this.uploadFile.previousBlock($file);
				if ($prev.length)
				{
					$prev.append(marker);
				}
				else
				{
					var $p = $('<p>');
					$p.append(marker);
					$file.before($p);
				}

				this.selection.restore();
			},
			markerBelow: function($file)
			{
				var marker = this.marker.get();

				var $next = this.uploadFile.nextBlock($file);
				if ($next.length)
				{
					$next.prepend(marker);
				}
				else
				{
					var $p = $('<p>');
					$p.append(marker);
					$file.after($p);
				}

				this.selection.restore();
			},
			previousBlock: function($file)
			{
				var $prev = $file.prev();
				if ($prev.length && $prev.hasClass('file')) {
					return this.uploadFile.previousBlock($prev);
				}
				return $prev;
			},
			nextBlock: function($file)
			{
				var $next = $file.next();
				if ($next.length && $next.hasClass('file')) {
					return this.uploadFile.nextBlock($next);
				}
				return $next;
			},
			keydown: function(e)
			{
				var key = e.which;
				if (key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE)
				{
					var $block = $(this.selection.block());
					var $prev = $block.prev('.file');

					if ($prev.length)
					{
						var sel = this.selection.get();
						var range = this.selection.range(sel);

						if (range.endOffset === 0)
						{
							this.buffer.set();
							$prev.remove();
							this.code.sync();
							return false;
						}
					}
				}

				return true;
			},
			click: function(e)
			{
				var $block = $(this.selection.block());
				if (typeof $block[0] !== 'undefined' && ($block.hasClass('file') || $block.hasClass('file-box')))
				{
					this.selection.restore();
					var $file = $block.closest('.file');

					this.uploadFile.markerBelow($file);
				}

				return true;
			}
		};
	};

	$.Redactor.prototype.uploadImage = function()
	{
		return {

			init: function ()
			{
				var dropdown = {};

				dropdown.upload = {

					title: 'Upload Images',
					func: this.uploadImage.uploadCallback

				};

				var disabled = (typeof(config.temp) !== "undefined" && config.temp.gallery.count > 0) ? false : true;
				dropdown.gallery = {

					title: 'Insert Gallery Image',
					func: this.uploadImage.galleryCallback,
					disabled: disabled

				};

				dropdown.insert = {

					title: 'Insert Getty Image',
					func: this.uploadImage.insertCallback

				};

				dropdown.insertPixabay = {

					title: 'Insert Pixabay Image',
					func: this.uploadImage.insertPixabayCallback

				};

				var button = this.button.addBefore('link', 'uploadImage', 'Upload Images');

				this.button.addDropdown(button, dropdown);
				this.button.setIcon(button, '<i class="re-icon-image"></i>');

				this.modal.addTemplate('uploadImage', String()
					+ '<div class="redactor-modal-tab redactor-upload-multiple">'
						+ '<p class="hint">Add your images to the upload queue and hit the start button.</p>'
						+ '<div id="multiple-uploads">'
							+ '<div class="actions">'
								+ '<a id="add-file" class="btn btn-lg btn-blue" href="javascript:;">Add Files</a>'
								+ '<a class="btn btn-lg btn-purple-dark" href="javascript:;">Start Upload</a>'
							+ '</div>'
							+ '<div class="upload-queue">'
								+ '<div class="empty muted">Your upload queue is empty</div>'
								+ '<div class="headers muted"><div class="filename">Filename</div><div class="size">Size</div><div class="status">Status</div></div>'
							+ '</div>'
							+ '<div class="progress">'
								+ '<div class="bar"></div>'
							+ '</div>'
						+ '</div>'
						+ '<div class="buttons">'
							+ '<a id="redactor-modal-button-cancel" class="btn btn-lg btn-grey" href="javascript:;">Cancel</a>'
						+ '</div>'
					+ '</div>');

				this.modal.addCallback('uploadImage', function()
				{
					this.$modalBox.off('click');
				});

				this.modal.addTemplate('editImage', String()
					+ '<div class="redactor-modal-tab" data-title="Edit">'
						+ '<section class="redactor-modal-image">'
							+ '<div class="thumb"></div>'
							+ '<div class="options">'
								+ '<div class="note">'
									+ 'Add a note about this image for our design team.'
								+ '</div>'
								+ '<section class="name">'
									+ '<label>Name</label>'
								+ '</section>'
								+ '<section class="notes">'
									+ '<label>Note</label>'
								+ '</section>'
								+ '<div class="buttons">'
									+ '<button id="redactor-modal-button-action" class="btn btn-lg btn-green">Save</button>'
									+ '<button id="redactor-modal-button-cancel" class="btn btn-lg btn-grey">Cancel</button>'
									+ '<button id="redactor-modal-button-delete" class="btn btn-lg btn-red">Delete</button>'
								+ '</div>'
							+ '</div>'
						+ '</section>'
					+ '</div>');

				if (typeof(config.temp) !== "undefined")
				{
					var template 	= '<div class="redactor-modal-tab redactor-upload-multiple">'
													+ '<p class="hint">Select an image from your gallery below.</p>'
												+ '<div class="redactor-modal-gallery">';

					for (var i = 0; i < config.temp.gallery.images.length; i++)
					{
						var note = config.temp.gallery.images[i].note;
						var template_note = note ? '<span>' + note + '</span>' : '';
						template += '<div class="redactor-modal-gallery-image">'
												+ '<div class="redactor-modal-gallery-frame" data-id="' + config.temp.gallery.images[i].id + '" data-name="' + config.temp.gallery.images[i].name + '" data-note="' + config.temp.gallery.images[i].note + '" data-src="' + config.temp.gallery.images[i].src + '">'
													+ '<h6>' + config.temp.gallery.images[i].name + '</h6>'
													+ '<img src="' + config.temp.gallery.images[i].src + '">'
													+ template_note
												+ '</div>'
											+ '</div>';
					}

					template += '</div>'
											+ '<div class="buttons">'
												+ '<a id="redactor-modal-button-cancel" class="btn btn-lg btn-grey" href="javascript:;">Cancel</a>'
											+ '</div>'
										+ '</div>';

					this.modal.addTemplate('galleryImages', String() + template);
					this.modal.addCallback('galleryImages', function()
					{
						setTimeout($.proxy(this.modal.buildWidth, this), 30);
					});
				}

				this.uploadImage.editableImages();
			},
			uploadCallback: function(buttonName)
			{
				this.modal.load('uploadImage', 'Upload Your Images', 800);

				this.uploadImage.slides = $('<div class="slides slide-gallery-uploads">');
				this.uploadImage.central = $('<div class="central">');

				this.uploadImage.slides.append(this.uploadImage.central);
				$('body').append(this.uploadImage.slides);

				this.uploadImage.start = this.$modal.find('.actions').children('a').eq(1);
				this.uploadImage.queue = this.$modal.find('.upload-queue');
				this.uploadImage.progress = this.$modal.find('.progress');
				this.uploadImage.bar = this.uploadImage.progress.find('.bar');
				this.uploadImage.cancel = this.$modal.find('#redactor-modal-button-cancel');

				this.uploadImage.files = {};

				this.uploadImage.uploader = new plupload.Uploader(
				{
					runtimes : 'html5',
					browse_button : 'add-file',
					container: 'multiple-uploads',
					max_file_size : '10mb',
					multipart_params : { _csrf : config.token },
					chunk_size : 204800,
					multi_selection : true,
					url: config.upload.url,
					filters: {

						mime_types : [{ title : "Choose the image file you would like to upload", extensions : config.upload.filetypes }],
						max_file_size: "20mb",
						prevent_duplicates: true

					},
					headers:{
						'X-UPLOAD-FILE': 'yes'
					},
					max_retries: 0
				});

				this.uploadImage.uploader.init();

				this.uploadImage.uploader.bind('Error', function(up, data)
				{
					up.stop();

					if (data.code == plupload.HTTP_ERROR){
						switch (data.status){
							case 403: // Forbidden

								function retry(){
									data.file.status = plupload.QUEUED;
									up.start();
								}

								accessDenied(retry, 'upload files');

								return;

							break;
						}
					}

					$('#'+data.file.id).find('.status').removeClass('uploading').addClass('warning');

					this.uploadImage.log.push({ code : 'default', file : data.file });
					if (typeof this.uploadImage.warning === 'undefined')
					{
						this.uploadImage.showError();
					}
				}
				.bind(this));

				this.uploadImage.uploader.bind('FilesAdded', function(up, files)
				{
					plupload.each(files, function(file)
					{
						var item = $('<div id="' + file.id + '" class="item">'
								+ '<div class="filename">' + file.name + '</div>'
								+ '<div class="size">' + this.uploadImage.formatFileSize(file.size) + '</div>'
							+ '</div>');

						var status = $('<div class="status">'
								+ '<div></div>'
								+ '<svg focusable="false" role="presentation" viewBox="0 0 19 19" class="icon icon-tick"><path d="M0.331,11.117l6.829,6.072L18.67,4.344l-2.838-2.533L6.824,11.886 L2.816,8.337L0.331,11.117z"/></svg>'
								+ '<svg viewBox="0 0 97 89" class="icon icon-warning"><path d="M94.478,69.866c-5.581-9.561-29.38-51.956-35.752-62.901 c-5.499-9.447-14.641-9.105-19.893-0.06c-3.677,6.332-31.285,54.61-36.549,63.873C-2.979,80.041,1.244,89,10.944,89h76.164 C96.461,89,99.77,78.933,94.478,69.866z M49.331,78.124c-3.619,0-6.554-2.937-6.554-6.561c0-3.622,2.935-6.559,6.554-6.559 c3.62,0,6.555,2.937,6.555,6.559C55.886,75.188,52.951,78.124,49.331,78.124z M55.893,29.503 c-0.52,8.153-1.324,16.459-1.716,21.393c-0.392,4.935-1.197,8.831-4.864,8.831s-4.408-2.608-4.92-9.009 c-0.512-6.4-1.015-12.883-1.43-21.131c-0.416-8.249,1.315-11.771,6.573-11.771C54.794,17.815,56.412,21.35,55.893,29.503z"/></svg>'
							+ '</div>');

						var remove = $('<a class="delete" href="javascript:;">'
								+ '<svg viewBox="0 0 20 20" class="icon icon-cross"><polygon points="15.606,0 10,5.606 4.394,0 0,4.394 5.606,10 0,15.606 4.394,20 10,14.394 15.606,20 20,15.606 14.394,10 20,4.394 "/></svg>'
							+ '</a>');

						remove.on('click', function()
						{
							this.uploadImage.uploader.removeFile(file.id);
							item.remove();
							this.uploadImage.updateQueue();
						}
						.bind(this));

						item.append(status);
						status.append(remove);

						this.uploadImage.queue.append(item);
						this.uploadImage.updateQueue();
					}
					.bind(this));
				}
				.bind(this));

				this.uploadImage.uploader.bind('BeforeUpload', function(up, file)
				{
					this.uploadImage.uploader.settings.multipart_params.token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
					$('#'+file.id).find('.status').removeClass('warning').addClass('uploading');
					this.uploadImage.progress.addClass('show');
				}
				.bind(this));

				this.uploadImage.uploader.bind('ChunkUploaded', function(up, file, data)
				{
					var response = $.parseJSON(data.response);

					if (response.accessDenied){
						this.uploadImage.uploader.stop();

						$('#'+file.id).find('.status').removeClass('uploading').addClass('warning');

						function retry(){

							this.uploadImage.log.push({ code : 'accessDenied', file : file });
							if (typeof this.uploadImage.warning === 'undefined')
							{
								this.uploadImage.showError();
							}

						}

						accessDenied(retry.bind(this), 'upload images');
					}
					else if (response.error)
					{
						$('#'+error.file.id).find('.status').removeClass('uploading').addClass('warning');

						this.uploadImage.log.push({ code : response.error.code, file : file });
						if (typeof this.uploadImage.warning === 'undefined')
						{
							this.uploadImage.showError();
						}
					}
				}
				.bind(this));

				this.uploadImage.uploader.bind('FileUploaded', function(up, file, data)
				{
					var response = $.parseJSON(data.response);

					if (response.accessDenied){
						this.uploadImage.uploader.stop();

						$('#'+file.id).find('.status').removeClass('uploading').addClass('warning');

						function retry(){

							this.uploadImage.log.push({ code : 'accessDenied', file : file });
							if (typeof this.uploadImage.warning === 'undefined')
							{
								this.uploadImage.showError();
							}

						}

						accessDenied(retry.bind(this), 'upload images');
					}
					else if (response.error)
					{
						this.uploadImage.log.push({ code : response.error.code, file : file });
						if (typeof this.uploadImage.warning === 'undefined')
						{
							this.uploadImage.showError();
						}
					}
					else
					{
						//this.uploadImage.uploader.removeFile(file.id);

						$('#'+file.id).find('.status').removeClass('uploading').addClass('complete');
						this.uploadImage.insertImage(response.id, response.path + 'thumb/' + response.id, 'data-image');
					}
				}
				.bind(this));

				this.uploadImage.uploader.bind('UploadProgress', function(up, file)
				{
					this.uploadImage.bar.css({ width : up.total.percent+'%' });
				}
				.bind(this));

				this.uploadImage.uploader.bind('UploadComplete', function(up, file)
				{
					this.uploadImage.bar.css({ width : '0%' });
					this.uploadImage.progress.removeClass('show');
					this.uploadImage.cancel.html('Continue').removeClass('btn-grey').addClass('btn-green');
				}
				.bind(this));

				this.uploadImage.cancel.on('click', function()
				{
					this.uploadImage.slides.remove();
				}
				.bind(this));

				this.uploadImage.start.on('click', function()
				{
					this.uploadImage.uploader.start();
				}
				.bind(this));

				this.modal.show();
			},
			formatFileSize : function(bytes,decimalPoint)
			{
				if(bytes == 0) return '0 Bytes';

				var k = 1000,
					dm = decimalPoint || 2,
					sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
					i = Math.floor(Math.log(bytes) / Math.log(k));

				return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
			},
			updateQueue : function()
			{
				if (this.uploadImage.uploader.files.length)
				{
					this.uploadImage.queue.addClass('items');
				}
				else
				{
					this.uploadImage.queue.removeClass('items');
				}
			},
			showError : function()
			{
				if (this.uploadImage.log.length)
				{
					var error = this.uploadImage.log.shift();
					$('#'+error.file.id).find('.status').removeClass('uploading').addClass('warning');

					if (typeof this.uploadImage.warning !== 'undefined')
					{
						this.uploadImage.warning.remove();
						delete this.uploadImage.warning;
					}

					this.uploadImage.warning = $('<div class="slide slide-error">');

					if (!this.uploadImage.errors.hasOwnProperty(error.code))
					{
						error.code = 'default';
					}

					this.uploadImage.warning.html('<svg viewBox="0 0 97 89" class="icon icon-warning"><path d="M94.478,69.866c-5.581-9.561-29.38-51.956-35.752-62.901 c-5.499-9.447-14.641-9.105-19.893-0.06c-3.677,6.332-31.285,54.61-36.549,63.873C-2.979,80.041,1.244,89,10.944,89h76.164 C96.461,89,99.77,78.933,94.478,69.866z M49.331,78.124c-3.619,0-6.554-2.937-6.554-6.561c0-3.622,2.935-6.559,6.554-6.559 c3.62,0,6.555,2.937,6.555,6.559C55.886,75.188,52.951,78.124,49.331,78.124z M55.893,29.503 c-0.52,8.153-1.324,16.459-1.716,21.393c-0.392,4.935-1.197,8.831-4.864,8.831s-4.408-2.608-4.92-9.009 c-0.512-6.4-1.015-12.883-1.43-21.131c-0.416-8.249,1.315-11.771,6.573-11.771C54.794,17.815,56.412,21.35,55.893,29.503z"/></svg>'
						+ '<h3>Oops! ' + this.uploadImage.errors[error.code].title + '</h3>'
						+ '<p>' + this.uploadImage.errors[error.code].message + '</p>'
						+ '<div class="error-item">' + error.file.name + '</div>'
						+ '<p class="muted">' + this.uploadImage.errors[error.code].advice + '</p>');

					var close = $('<a class="btn btn-lg btn-v8" href="javascript:;">Continue</a>');

					close.on('click', function()
					{
						this.uploadImage.showError();
					}
					.bind(this));

					this.uploadImage.warning.append(close);

					this.$modal.css('display', 'none');
					this.uploadImage.slides.css('z-index', 2000);
					this.uploadImage.central.append(this.uploadImage.warning);
				}
				else
				{
					this.uploadImage.warning.remove();
					delete this.uploadImage.warning;

					this.uploadImage.slides.css('z-index', 250);
					this.$modal.css('display', 'block');
				}
			},
			insertImage: function(id, url, tag, close)
			{
				this.selection.restore();
				this.placeholder.hide();

				var $block = $(this.selection.block());
				var $figure = $('<figure>');
				var $img = $('<img>');

				var $outer = $block.parentsUntil('.redactor-styles').last();
				if ($outer.length) {
					$block = $outer;
				}

				$img.attr('src', url);
				$img.attr(tag, id);

				$figure.append($img).data('editable', false);

				var $gallery = $block.prev('.redactor-gallery');
				if ($gallery.length)
				{
					this.buffer.set();
					$gallery.append($figure);

					if (close)
					{
						this.uploadImage.closeModal();
					}

					return;
				}

				var $gallery = $block.next('.redactor-gallery');
				if ($gallery.length)
				{
					this.buffer.set();
					$gallery.prepend($figure);

					if (close)
					{
						this.uploadImage.closeModal();
					}

					return;
				}

				if (!this.utils.isEmpty($block.html()))
				{
					var $gallery = $('<div class="redactor-gallery">');
					$gallery.append($figure);
					this.buffer.set();
					$block.after($gallery);

					if (close)
					{
						this.uploadImage.closeModal();
					}

					return;
				}

				var $galleryBox = $('<div>');
				var $gallery = $('<div class="redactor-gallery">');

				$gallery.append($figure);
				$galleryBox.append($gallery);

				var html = $galleryBox.html();
				this.buffer.set();
				this.insert.html(html);

				var $gallery = $(this.selection.current()).closest('.redactor-gallery');
				var marker = this.marker.get();
				var $p = $('<p>');

				$p.append(marker);
				$gallery.after($p);

				this.selection.restore();

				if (close)
				{
					this.uploadImage.closeModal();
				}
			},
			editableImages: function()
			{
				var $figures = $(this.core.editor()).find('figure');
				$figures.each(function(i, figure)
				{
					var $figure = $(figure);
					if (!$figure.data('editable'))
					{
						$figure.data('editable', true);
						$figure.on('click touchstart', function()
						{
							this.modal.load('editImage', 'Edit Image', 600);

							var $thumbBox = $('.redactor-modal-image .thumb');
							var $img = $figure.find('img');

							var $thumb = $('<img>');
							$thumb.attr('src', $img.attr('src'));

							$thumbBox.append($thumb);

							var figcaption = $figure.children('figcaption').eq(0).text();
							var name = figcaption.substring(0, figcaption.lastIndexOf(" - "));
							if (figcaption.indexOf(" - ") >= 0)
								var notes = figcaption.substring(figcaption.lastIndexOf(" - ") + 3, figcaption.length);
							else
								var notes = figcaption;

							var $textbox_names = $('<input type="text" />');
							$textbox_names.val(name);

							var $options_name = $('.redactor-modal-image .options .name');
							$options_name.append($textbox_names);

							var $textbox_notes = $('<input type="text" />');

							$textbox_notes.val(notes);

							var $options_notes = $('.redactor-modal-image .options .notes');
							$options_notes.append($textbox_notes);

							var $save = $('.redactor-modal-image #redactor-modal-button-action');
							$save.click(function()
							{
								this.uploadImage.saveImage($figure, $textbox_names, $textbox_notes);
							}
							.bind(this));

							var $save = $('.redactor-modal-image #redactor-modal-button-delete');
							$save.click(function()
							{
								this.uploadImage.deleteImage($figure);
							}
							.bind(this));

							this.modal.show();
							$textbox_names.focus();
						}
						.bind(this));
					}
				}
				.bind(this));
			},
			saveImage: function($figure, $textbox_names, $textbox_notes)
			{
				var note = $textbox_notes.val().trim();
				var name = $textbox_names.val().trim();
				$figure.children('figcaption').remove();

				if (name !== '' || note !== '')
				{
					var $figcaption = $('<figcaption>');
					$figcaption.html(name + ' - ' + note);
					$figure.append($figcaption);
				}

				this.modal.close();
			},
			deleteImage: function($figure)
			{
				this.buffer.set();

				var $siblings = $figure.siblings();
				var $gallery = $figure.parent();
				$figure.remove();

				if (!$siblings.length)
				{
					$gallery.remove();
				}

				this.modal.close();
				this.selection.restore();
			},
			keyup: function(e)
			{
				var key = e.which;
				var $block = $(this.selection.block());

				if (key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE)
				{
					if (this.utils.isEmpty($block.html()))
					{
						var $prev = $block.prev('.redactor-gallery');
						var $next = $block.next('.redactor-gallery');
						var removeBlock = false;

						if ($prev.length && $next.length)
						{
							removeBlock = true;
						}
						else if ($next.length)
						{
							var $prev = $block.prev();
							if (!$prev.length)
							{
								removeBlock = true;
							}
						}

						if (removeBlock)
						{
							this.uploadImage.removeBlock($block, $prev, $next);
							return false;
						}
					}
				}

				if (typeof $block[0] !== 'undefined' && ($block[0].tagName === 'FIGURE' || $block[0].tagName === 'FIGCAPTION' || ($block[0].tagName === 'DIV' && $block.hasClass('.redactor-gallery'))))
				{
					var $gallery = $block.closest('.redactor-gallery');
					var marker = this.marker.get();

					if (key === this.keyCode.DOWN || key === this.keyCode.RIGHT)
					{
						var $next = $gallery.next();
						if ($next.length)
						{
							$next.prepend(marker);
						}
						else
						{
							var $p = $('<p>');
							$p.append(marker);
							$gallery.after($p);
						}
					}
					else
					{
						var $prev = $gallery.prev();
						if ($prev.length)
						{
							$prev.append(marker);
						}
						else
						{
							var $p = $('<p>');
							$p.append(marker);
							$gallery.before($p);
						}
					}

					this.selection.restore();

					return false;
				}

				return true;
			},
			keydown: function(e)
			{
				var key = e.which;
				if (key === this.keyCode.BACKSPACE || key === this.keyCode.DELETE)
				{
					var $block = $(this.selection.block());
					var $prev = $block.prev('.redactor-gallery');

					if ($prev.length)
					{
						var sel = this.selection.get();
						var range = this.selection.range(sel);

						if (range.endOffset === 0)
						{
							this.buffer.set();

							$children = $prev.children('figure');
							if ($children.length > 1)
							{
								$children.last().remove();
							}
							else
							{
								$prev.remove();
							}

							this.code.sync();

							return false;
						}
					}
				}

				return true;
			},
			click: function(e)
			{
				var $block = $(this.selection.block());
				if (typeof $block[0] !== 'undefined' && ($block[0].tagName === 'FIGURE' || $block[0].tagName === 'FIGCAPTION' || ($block[0].tagName === 'DIV' && $block.hasClass('.redactor-gallery'))))
				{
					var $gallery = $block.closest('.redactor-gallery');
					var marker = this.marker.get();
					var $next = $gallery.next();

					if ($next.length)
					{
						$next.prepend(marker);
					}
					else
					{
						var $p = $('<p>');
						$p.append(marker);
						$gallery.after($p);
					}

					this.selection.restore();
				}

				return true;
			},
			removeBlock: function($block, $prev, $next)
			{
				var marker = this.marker.get();
				$block.remove();

				var $p = $('<p>');
				$p.append(marker);

				$next.after($p);

				if ($prev.length)
				{
					$prev.append($next.children());
					$next.remove();
				}

				this.selection.restore();
			},
			log : [],
			errors : {

				104 : {

					'title' : 'This is not an image.',
					'message' : 'The following file is not an image.',
					'advice' : 'The image formats we accept are png, jpg and jpeg.'

				},
				105 : {

					'title' : 'This file is too big.',
					'message' : 'The following image is too large.',
					'advice' : 'Maximum size is 20MB.'

				},
				'accessDenied' : {

					'title' : 'Session timed out.',
					'message' : 'The following image could not be uploaded due to session timeout.',
					'advice' : 'Please try again.'

				},
				'default' : {

					'title' : 'Something went wrong.',
					'message' : 'The following image could not be uploaded due to an unexpected system error.',
					'advice' : 'Please try again.'

				}

			},

			insertPixabayCallback: function()
			{
				this.selection.save();
				this.uploadImage.modalPixabay = Object.create(modal);

				var linkPixabay = '<a class="w-editor-stock-logo" href="https://pixabay.com/" target="_blank"><img src="https://demo.itseeze.com/_webedit/generator/images/pixabay.svg" width="160" height="31"></a>';

				var content = $('<div class="edit-image">');
				var container = $('<div>');
				var options = $('<div class="search">');

				var searchBox = $('<section class="search-row">');
				this.search = $('<input type="text" placeholder="Search Pixabay stock images">');

				var submit = $('<label href="javascript:;">Search</label>');
				submit.on('click', this.uploadImage.searchPixabay.bind(this));

				this.search.keypress(function (e) {
					if (e.which == 13) {
						submit.click();
					}
				});

				this.results = $('<div class="results">');

				var footer = $('<div class="footer">');

				var cancel = $('<a class="btn btn-grey" href="javascript:;">Cancel</a>');
				cancel.on('click', this.uploadImage.closeModal);

				searchBox.append(this.search,submit);

				content.append(container);
				container.append(options,this.results);
				options.append(searchBox);
				footer.append(cancel);

				this.uploadImage.modalPixabay.show(
					'compact',
					linkPixabay,
					false,
					false,
					content,
					footer,
					this.uploadImage.closeModal,
					1090,
					false
				);
			},
			searchPixabay : function()
			{
				ajaxRequest(
					'/pixabay/search/' + config.currentProject,
					{
						search : this.search.val()
					},
					this.uploadImage.processPixabayResponse.bind(this),
					'add the getty image'
				);
			},
			processPixabayResponse: function(data)
			{
				// Control Variables
				var imageLimit = 198; // multiple of 6
				var imageDisplayed = 0;

				// Reset results
				this.results.empty();

				// Display results
				let images = data.images;
				$.each( images, function( index, value ){
					var row = $('<div class="pixabay-image">');
					var image = $('<img src="' + value.thumbnailUrl + '" max-width="100%" max-height="100%">');
					var holder = $('<div class="holder">');
					var use = $('<div data-url="' + value.url + '">Use</div>');
					use.on('click', this.uploadImage.pixabayUse);
					var zoom = $('<div data-zoom="' + value.url + '">Zoom</div>');
					zoom.on('click', this.uploadImage.pixabayZoom);
					holder.append(use,zoom);
					row.append(holder,image);
					this.results.append(row);

					imageDisplayed++;

					if(imageDisplayed >= imageLimit)
						return false;

				}.bind(this));

				// Completed
				loading.stop();
			},
			pixabayUse: function(data)
			{
				ajaxRequest(
					'/pixabay/add-image/' + config.currentProject,
					{
						url : $(data.currentTarget).data('url'),
						search : this.search.val()
					},
					this.uploadImage.pixabayUseComplete.bind(this),
					'add the pixabay image'
				);
			},
			pixabayUseComplete: function(data)
			{
				if (data.error !== undefined)
				{
					// TODO
				}
				else if (data.success !== undefined)
				{
					this.uploadImage.insertImage(data.success.id, data.success.src, 'data-gallery', true);
				}
				loading.stop();
			},
			pixabayZoom: function(data)
			{
				var body = $('body');
				$("div.pixabay-full").remove();

				var fullDiv = $('<div class="pixabay-full">');
				var fullImage = $('<img src="' + $(data.currentTarget).data('zoom') + '">');

				fullDiv.on('click' ,this.uploadImage.pixabayZoomClose);
				fullImage.on('click', this.uploadImage.pixabayZoomClose);

				fullDiv.append(fullImage);
				body.append(fullDiv);
			},
			pixabayZoomClose: function()
			{
				$("div.pixabay-full").remove();
			},
			insertCallback: function(buttonName)
			{
				this.selection.save();
				this.uploadImage.message  = Object.create(modal);

				var content = $('<div class="content content-stock-image-id">');
				var left = $('<div class="stock-image-sample"><img src="/img/stock-image-id2.png" /></div>');
				var right = $('<div class="stock-image-info">');

				content.append(left, right);

				right.append('<p>At <a href="https://www.gettyimages.co.uk/landing/pa-preview/expanded/219333" target="_blank">Getty Images</a> you can find millions of high quality images for use on your website.</p>');
				right.append('<p>When you find an image that you want to use, copy the image number into the box below.</p>');
				right.append('<p>When clicking onto an image, it will display a purple bar confirming that you are in a <b>\'Premium Access guest preview\'</b> mode.</p>');
				right.append('<p>You must use the search bar to find images, and should only search within <b>\'Creative Images\'</b></p>');
				right.append('<p>Any images found outside of guest preview mode cannot be downloaded, and will not be included in the website design.</p>');

				this.uploadImage.stockImageIdBox = $('<input type="text" placeholder="Getty Images Item Number"/>');

				right.append(this.uploadImage.stockImageIdBox);

				var gettyimages = $('<a class="gettyimages" href="https://www.gettyimages.co.uk/landing/pa-preview/expanded/219333" target="_blank">Visit Getty Images</a>');
				var save = $('<a class="btn btn-green" href="javascript:;">Insert Image</a>');
				var cancel = $('<a class="btn btn-grey" href="javascript:;">Cancel</a>');

				cancel.on('click', this.uploadImage.closeModal);
				save.on('click', this.uploadImage.saveId);

				right.append(gettyimages, save, cancel);

				var footer = $('<div class="footer">');
				var max_getty_images = document.getElementById('max_getty_images').dataset.max_getty_images;
				footer.append('<p class="muted">You can add up to ' + max_getty_images + ' Getty images on your website.</p>');

				this.uploadImage.message.show(
					'compact',
					'Insert Getty Image <span class="muted">-</span> <a class="gettyimages" href="https://www.gettyimages.co.uk/landing/pa-preview/expanded/219333" target="_blank">Visit Getty Images</a>',
					false,
					false,
					content,
					footer,
					this.uploadImage.closeModal,
					900,
					false
				);
			},
			saveId: function(e)
			{
				$('.stock-image-info .error-message').remove();

				var id = this.uploadImage.stockImageIdBox.val().trim();
				if (id === '')
				{
					var error = '<div class="error-message">Please insert a Getty Images item number.</div>';
					this.uploadImage.stockImageIdBox.after(error);

					return;
				}

				ajaxRequest(
					config.stock.url,
					{
						id : id
					},
					this.uploadImage.processResponse.bind(this),
					'add the getty image'
				);
			},
			processResponse : function(data)
			{
				if (data.error !== undefined)
				{
					this.error = $('<div class="error-message">');
					this.error.html(data.error);

					this.uploadImage.stockImageIdBox.next('.error-message').remove();
					this.uploadImage.stockImageIdBox.after(this.error);
				}
				else if (data.success !== undefined)
				{
					this.uploadImage.insertImage(data.success.id, data.success.src, 'data-stock', true);
				}

				loading.stop();
			},
			galleryCallback : function(buttonName)
			{
				this.modal.load('galleryImages', 'Insert Gallery Image', 800);
				var images = this.$modal.find('.redactor-modal-gallery-frame');

				images.on('click', function(e)
				{
					var image = $(e.currentTarget);
					this.uploadImage.insertImage(image.data('id'), image.data('src'), 'data-gallery');
					this.modal.close();
				}
				.bind(this));

				this.modal.show();
			},
			closeModal : function()
			{
				overlay.obj.off('click');

				if (typeof this.uploadImage.message !== 'undefined')
				{
					this.uploadImage.message.modal.remove();
				}

				if (typeof this.uploadImage.modalPixabay !== 'undefined')
				{
					this.uploadImage.modalPixabay.modal.remove();
				}

				$("div.pixabay-full").remove();

				overlay.hide();
			}

		};
	};

	$.Redactor.prototype.insertAction = function() {
		return {

			init: function()
			{
				var button = this.button.addBefore('link', 'insertAction', this.lang.get('insertAction'));

				this.button.setIcon(button, '<i class="re-icon-codesnippets"></i>');
				this.button.addCallback(button, this.insertAction.show);

				this.modal.addTemplate('insertAction', this.insertAction.getTemplate());
			},
			show: function()
			{
				this.modal.load('insertAction', 'Insert call to action', 700);

				this.modal.getActionButton().on('click', this.insertAction.insert);
				this.modal.show();
			},
			getTemplate: function()
			{
				return String()
					+ '<div class="modal-section" id="redactor-modal-insert-action">'
						+ '<div class="redactor-modal-hint">A call to action or a CTA is a written directive used to encourage website visitors to take the desired action. '
						+ 'E.g. “Buy Now”, “Download Now”, “Subscribe today so you’ll never miss a post.", "Buy now and get 50% off"</div>'
						+ '<section>'
							+ '<textarea id="insert-action-box" rows="6"></textarea>'
						+ '</section>'
						+ '<section class="footer">'
							+ '<button id="redactor-modal-button-action" class="btn btn-lg btn-green">Insert</button>'
							+ '<button id="redactor-modal-button-cancel" class="btn btn-lg btn-grey">Cancel</button>'
						+ '</section>'
					+ '</div>';
			},
			insert: function()
			{
				ajaxRequest(
					config.code.url,
					{
						code : $('#insert-action-box').val()
					},
					this.insertAction.processResponse.bind(this),
					'insert your code'
				);
			},
			processResponse: function(data)
			{
				if (data.success !== undefined)
				{
					this.selection.restore();
					this.placeholder.hide();

					var $block = $(this.selection.block());
					var $code = $('<p class="action">');

					$code.attr('data-id', data.id);
					$code.html(data.code);

					var $outer = $block.parentsUntil('.redactor-styles').last();
					if ($outer.length)
					{
						$block = $outer;
					}

					if (!this.utils.isEmpty($block.html()))
					{
						this.modal.close();
						this.buffer.set();

						$block.after($code);
						loading.stop();

						return;
					}

					this.modal.close();
					this.buffer.set();

					$block.replaceWith($code);

					var marker = this.marker.get();
					var $p = $('<p>');

					$p.append(marker);
					$code.after($p);

					this.selection.restore();
				}
				else
				{
					this.modal.close();
					this.placeholder.hide();
				}

				loading.stop();
			}
		};
	};

	var editorConfig = {

		buttons : ['format', 'bold', 'italic', 'lists', 'link', 'horizontalrule'],
		formatting: ['p', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
		imageUpload: '/modules/upload.php',
		fileUpload: '/file-upload.php',
		toolbarFixed: false,
		//toolbarFixedTopOffset: 81,
		minHeight: 400,
		pasteImages: false,
		pasteBlockTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'tbody', 'thead', 'tfoot', 'th', 'tr', 'td', 'ul', 'ol', 'li'],
		pasteInlineTags: ['strong', 'b', 'em', 'i', 'span'],
		imageEditable: false,

		callbacks: {

			start: function()
			{
				this.opts.langs.en.format = 'Paragraphs & Headings';
				this.opts.langs.en.image = 'Upload image';
				this.opts.langs.en.file = 'Upload file';
				this.opts.langs.en.heading1 = 'Header (H1)';
				this.opts.langs.en.heading2 = 'Header (H2)';
				this.opts.langs.en.heading3 = 'Header (H3)';
				this.opts.langs.en.heading4 = 'Header (H4)';
				this.opts.langs.en.heading5 = 'Header (H5)';
				this.opts.langs.en.heading6 = 'Header (H6)';
				this.opts.langs.en.quote = 'Design note';
				this.opts.langs.en.insertCode = 'Insert code';
				this.opts.langs.en.insertAction = 'Insert call to action';

				this.utils.disableBodyScroll = function() {};
				this.utils.enableBodyScroll = function() {};
			},
			init: function ()
			{
				this.modal.addTemplate('link', String()
					+ '<div class="redactor-modal-tab" data-title="General">'
						+ '<section>'
							+ '<label>URL</label>'
							+ '<input type="url" id="redactor-link-url" aria-label="URL" />'
						+ '</section>'
						+ '<section>'
							+ '<label>' + this.lang.get('text') + '</label>'
							+ '<input type="text" id="redactor-link-url-text" aria-label="' + this.lang.get('text') + '" />'
						+ '</section>'
						+ '<section class="footer">'
							+ '<button id="redactor-modal-button-cancel" class="btn btn-lg btn-grey">' + this.lang.get('cancel') + '</button>'
							+ '<button id="redactor-modal-button-action" class="btn btn-lg btn-green">' + this.lang.get('insert') + '</button>'
						+ '</section>'
					+ '</div>');
			},
			focus: function(e)
			{
				this.$box.prev('.error-message').remove();
			},
			change: function()
			{
				var $dirty = $(this.core.editor()).find('table, figure');
				$dirty.contents().filter(function() { return this.nodeType === 3; }).remove();

				this.uploadImage.editableImages();

				this.$textarea.trigger('change');
				checkProceed.check();
			},
			keyup: function(e)
			{
				if (!this.uploadImage.keyup(e))
				{
					return false;
				}

				if (!this.uploadFile.keyup(e))
				{
					return false;
				}

				if (!this.video.keyup(e))
				{
					return false;
				}

				if (!this.insertCode.keyup(e))
				{
					return false;
				}

				if (!this.insertAction.keyup(e))
				{
					return false;
				}

				return true;
			},
			keydown: function(e)
			{
				if (!this.uploadImage.keydown(e))
				{
					return false;
				}

				if (!this.uploadFile.keydown(e))
				{
					return false;
				}

				if (!this.video.keydown(e))
				{
					return false;
				}

				if (!this.insertCode.keydown(e))
				{
					return false;
				}

				if (!this.insertAction.keydown(e))
				{
					return false;
				}

				return true;
			},
			click: function(e)
			{
				if (!this.uploadImage.click(e))
				{
					return false;
				}

				if (!this.uploadFile.click(e))
				{
					return false;
				}

				if (!this.insertCode.click(e))
				{
					return false;
				}

				if (!this.insertAction.click(e))
				{
					return false;
				}

				return true;
			}

		},
		plugins: ['table', 'uploadImage', 'uploadFile', 'video', 'insertCode', 'insertAction', 'bufferbuttons', 'definedlinks']

	}

	var editor = function()
	{
		$('.content-editor').redactor(editorConfig);

		var notesConfig = Object.create(editorConfig);

		notesConfig.buttons = ['format', 'bold', 'italic', 'lists', 'link'];
		notesConfig.formatting = ['p', 'h5'];
		notesConfig.minHeight = 300;
		notesConfig.pasteBlockTags = ['h5', 'table', 'ul', 'ol', 'li'];

		notesConfig.callbacks = {

			start: function()
			{
				this.opts.langs.en.format = 'Paragraphs & Headings';
				this.opts.langs.en.image = 'Upload Image';
				this.opts.langs.en.file = 'Upload File';
				this.opts.langs.en.heading5 = 'Header';
				this.opts.langs.en.quote = 'Design Note';

				this.utils.disableBodyScroll = function() {};
				this.utils.enableBodyScroll = function() {};
			},
			init: function ()
			{
				this.modal.addTemplate('link', String()
					+ '<div class="redactor-modal-tab" data-title="General">'
						+ '<section>'
							+ '<label>URL</label>'
							+ '<input type="url" id="redactor-link-url" aria-label="URL" />'
						+ '</section>'
						+ '<section>'
							+ '<label>' + this.lang.get('text') + '</label>'
							+ '<input type="text" id="redactor-link-url-text" aria-label="' + this.lang.get('text') + '" />'
						+ '</section>'
						+ '<section class="footer">'
							+ '<button id="redactor-modal-button-cancel" class="btn btn-lg btn-grey">' + this.lang.get('cancel') + '</button>'
							+ '<button id="redactor-modal-button-action" class="btn btn-lg btn-green">' + this.lang.get('insert') + '</button>'
						+ '</section>'
					+ '</div>');
			},
			focus: function(e)
			{
				this.$box.prev('.error-message').remove();
			},
			change: function()
			{
				var $dirty = $(this.core.editor()).find('table, figure');
				$dirty.contents().filter(function() { return this.nodeType === 3; }).remove();

				this.uploadImage.editableImages();

				this.$textarea.trigger('change');
				checkProceed.check();
			},
			keyup: function(e)
			{
				if (!this.uploadImage.keyup(e))
				{
					return false;
				}

				if (!this.uploadFile.keyup(e))
				{
					return false;
				}

				return true;
			},
			keydown: function(e)
			{
				if (!this.uploadImage.keydown(e))
				{
					return false;
				}

				if (!this.uploadFile.keydown(e))
				{
					return false;
				}

				return true;
			},
			click: function(e)
			{
				if (!this.uploadImage.click(e))
				{
					return false;
				}

				if (!this.uploadFile.click(e))
				{
					return false;
				}

				return true;
			},

		};

		notesConfig.plugins = ['uploadImage', 'uploadFile', 'bufferbuttons'];
		$('.content-editor-notes').redactor(notesConfig);

		var extraConfig = Object.create(editorConfig);

		extraConfig.buttons = ['format', 'bold', 'italic', 'lists', 'link'];
		extraConfig.formatting = ['p', 'h5'];
		extraConfig.minHeight = 300;
		extraConfig.pasteBlockTags = ['h5', 'table', 'ul', 'ol', 'li'];

		extraConfig.callbacks = {

			start: function()
			{
				this.opts.langs.en.format = 'Paragraphs & Headings';
				this.opts.langs.en.image = 'Upload Image';
				this.opts.langs.en.file = 'Upload File';
				this.opts.langs.en.heading5 = 'Header';
				this.opts.langs.en.quote = 'Design Note';

				this.utils.disableBodyScroll = function() {};
				this.utils.enableBodyScroll = function() {};
			},
			init: function ()
			{
				this.modal.addTemplate('link', String()
					+ '<div class="redactor-modal-tab" data-title="General">'
						+ '<section>'
							+ '<label>URL</label>'
							+ '<input type="url" id="redactor-link-url" aria-label="URL" />'
						+ '</section>'
						+ '<section>'
							+ '<label>' + this.lang.get('text') + '</label>'
							+ '<input type="text" id="redactor-link-url-text" aria-label="' + this.lang.get('text') + '" />'
						+ '</section>'
						+ '<section class="footer">'
							+ '<button id="redactor-modal-button-cancel" class="btn btn-lg btn-grey">' + this.lang.get('cancel') + '</button>'
							+ '<button id="redactor-modal-button-action" class="btn btn-lg btn-green">' + this.lang.get('insert') + '</button>'
						+ '</section>'
					+ '</div>');
			},
			focus: function(e)
			{
				this.$box.prev('.error-message').remove();
			},
			change: function()
			{
				var $dirty = $(this.core.editor()).find('table, figure');
				$dirty.contents().filter(function() { return this.nodeType === 3; }).remove();

				this.uploadImage.editableImages();

				this.$textarea.trigger('change');
				checkProceed.check();
			},
			keyup: function(e)
			{
				if (!this.uploadImage.keyup(e))
				{
					return false;
				}

				if (!this.uploadFile.keyup(e))
				{
					return false;
				}

				if (!this.insertCode.keyup(e))
				{
					return false;
				}

				if (!this.insertAction.keyup(e))
				{
					return false;
				}

				return true;
			},
			keydown: function(e)
			{
				if (!this.uploadImage.keydown(e))
				{
					return false;
				}

				if (!this.uploadFile.keydown(e))
				{
					return false;
				}

				if (!this.insertCode.keydown(e))
				{
					return false;
				}

				if (!this.insertAction.keydown(e))
				{
					return false;
				}

				return true;
			},
			click: function(e)
			{
				if (!this.uploadImage.click(e))
				{
					return false;
				}

				if (!this.uploadFile.click(e))
				{
					return false;
				}

				if (!this.insertCode.click(e))
				{
					return false;
				}

				if (!this.insertAction.click(e))
				{
					return false;
				}

				return true;
			},

		};

		extraConfig.plugins = ['uploadImage', 'uploadFile', 'insertCode', 'bufferbuttons'];
		$('.content-editor-extra').redactor(extraConfig);

		win.scroll($.throttle(10, function() {
			$('.redactor-box').each(function(i, obj)
			{
				var box = $(obj);
				var toolbar = box.find('.redactor-toolbar-box');
				var left = box.offset().left - win.scrollLeft();
				var start = box.offset().top - 1;
				var end = start + box.height();
				var scroll = win.scrollTop();

				toolbar.css({ width : box.outerWidth() + 'px' });

				if (scroll + 65 > start && scroll < end - 110) {
					toolbar.addClass('fixed');
					toolbar.css({ left : left + 'px' });
				} else {
					toolbar.removeClass('fixed');
					toolbar.css({ left : 0 });
				}
			});
		}));
	}

	var editorSiteLinkCancel = function(e)
	{
		e.preventDefault();
		overlay.obj.off('click');

		this.modal.remove();
		overlay.hide();
	}

	var editorSiteLink = function(obj)
	{
		var proceed = true;
		var page;

		for (var i = 0; i < config.links.length; i++)
		{
			if (config.links[i].url !== false && config.links[i].url === obj.attr('href'))
			{
				proceed = false;
				page = config.links[i].name;
			}
		}

		if (proceed)
		{
			return true;
		}

		var message = Object.create(modal);
		var footer = $('<div class="footer">');
		var save = $('<a class="btn btn-lg btn-green" href="#">Continue</a>');

		save.on('click', editorSiteLinkCancel.bind(message));
		footer.append(save);

		message.show(
			'compact',
			'Website Link',
			false,
			false,
			'<div class="content">On your new site this will link to your ' + page + ' page.</div>',
			footer,
			editorSiteLinkCancel.bind(message),
			false,
			false
		);

		$('.redactor-link-tooltip').remove();

		return false;
	}

	function forms()
	{
		body.on('focus', 'input[type="text"], select', function(e)
		{
			$(e.currentTarget).removeClass('error').next('.error-message').remove();
		});

		body.on('keyup', 'input[type="text"], textarea', function(e)
		{
			var obj = $(e.currentTarget);
			var group = obj.parent('.form-group');

			if (group.length)
			{
				obj.val().trim() == '' ? group.removeClass('content') : group.addClass('content');
			}

			$(e.currentTarget).removeClass('error').next('.error-message').remove();
		});

		body.on('keyup', 'input[data-copy]', function(e)
		{
			var obj = $(e.currentTarget);
			var target = $('#' + obj.data('copy'));

			target.siblings('.error-message').remove();
			target.val(obj.val()).trigger('change').blur();
		});
	}

	var modal = {

		show : function (label, title, header, hint, content, footer, click, width, toptip)
		{
			overlay.show();

			this.modal = $('<div class="modal">');
			this.modal.css('top', win.scrollTop());
			this.modal.addClass(label);

			var central = $('<div class="central">');
			this.temp_panel = $('<div class="panel">');

			if (width)
			{
				central.css('flex-basis', width + 'px');
			}

			this.modal.append(central);
			central.append(this.temp_panel);

			this.temp_main = $('<div class="main">');
			this.temp_panel.append(this.temp_main);

			this.temp_header = $('<div class="header">');
			this.temp_header.html('<h2>' + title + '</h2>');

			if (header)
			{
				var info = $('<p>');
				info.html(header);
				this.temp_header.append(info);
			}

			if (hint)
			{
				var info = $('<p class="info">');

				if (toptip)
				{
					info.html('<span class="badge">Top tip</span> ');
				}

				info.append(hint);
				this.temp_header.append(info);
			}

			this.temp_main.append(this.temp_header, content, footer);
			this.temp_panel.on('click', function(e)
			{
				e.stopPropagation();
			});

			body.append(this.modal);

			if (hint)
			{
				window.setTimeout(function()
				{
					info.addClass('show');
				}, 20);
			}

			if (click !== null)
			{
				this.modal.on('click', click);
				overlay.obj.on('click', click);
			}
		}

	};

	function autoTextareas()
	{
		autosize($('textarea:not([class*="content-editor"])'));
	}

	var draftProject = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function()
			{
				if(this.obj.data('trigger-draft-create'))
					this.createLaunch();
				else if(this.obj.data('trigger-draft-delete'))
					this.deleteLaunch();
				else if(this.obj.data('trigger-draft-import'))
					this.importLaunchLoad();
			},
			createLaunch : function()
			{
				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var options = $('<div class="options">');
				var intro = $('<p class="text-center">Please provide a name for your new website draft project?</p>');

				var section_name = $('<section>');
				var label_name = $('<label>Name:</label>');

				this.name = $('<input type="text" />');
				this.name.keypress(function (e) {
					if (e.which == 13) {
						edit.click();
					}
				});

				content.append(container);
				container.append(options);
				options.append(intro, section_name);
				section_name.append(label_name, this.name);

				var footer = $('<div class="footer">');
				var create = $('<a class="btn btn-green">Create</a>');
				create.on('click', this.create.bind(this));

				var cancel = $('<a class="btn btn-red">Cancel</a>');
				cancel.on('click', this.done.bind(this));

				footer.append(create, cancel);
				this.show('compact', 'Create New Website Draft', false, false, content, footer, this.done.bind(this), 600);
			},
			create : function(data)
			{
				data.preventDefault();

				ajaxRequest(
					'/site/create-standard-draft/' + this.obj.data('trigger-draft-create'),
					{
						name : this.name.val(),
					},
					this.createDone.bind(this),
					'create draft'
				);
			},
			deleteLaunch : function()
			{
				let id = this.obj.data('trigger-draft-delete');

				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var options = $('<div class="options">');
				var intro = $('<p class="text-center">Are you sure you want to delete this draft?</p>');

				content.append(container);
				container.append(options);
				options.append(intro);

				var footer = $('<div class="footer">');
				var yes = $('<a class="btn btn-green" data-id="' + id + '">Yes</a>');
				yes.on('click', this.delete.bind(this));

				var cancel = $('<a class="btn btn-grey">Cancel</a>');
				cancel.on('click', this.done.bind(this));

				footer.append(yes, cancel);
				this.show('compact', 'Delete Draft', false, false, content, footer, this.done.bind(this));
			},
			delete : function(data)
			{
				data.preventDefault();

				ajaxRequest(
					'/site/delete-draft/' + this.obj.data('id'),
					{
						id : this.obj.data('trigger-draft-delete'),
					},
					this.deleteDone.bind(this),
					'create draft'
				);
			},
			importLaunchLoad : function()
			{
				ajaxRequest(
					'/site/import-draft-list/' + this.obj.data('id'),
					{
						id : this.obj.data('trigger-draft-import'),
					},
					this.importLaunch.bind(this),
					'import draft list'
				);
			},
			importLaunch : function(data)
			{
				loading.stop();
				let id = this.obj.data('trigger-draft-import');

				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var options = $('<div class="options">');

				var section_name = $('<section>');
				var label_draft = $('<label>Draft:</label>');

				this.draft = $('<select>');

				content.append(container);
				container.append(options);

				var footer = $('<div class="footer">');
				var importDraft = $('<a class="btn btn-green" data-id="' + id + '">Import</a>');
				importDraft.on('click', this.import.bind(this));

				var cancel = $('<a class="btn btn-grey">Cancel</a>');
				cancel.on('click', this.done.bind(this));

				var close = $('<a class="btn btn-green">Close</a>');
				close.on('click', this.done.bind(this));

				let drafts = data.draft_projects;
				let i = 0;
				if(drafts.length === 0){
					var intro = $('<p class="text-center"><b class="error-message">You do not currently have any new website drafts.</b></p>');
					var intro2 = $('<p class="text-center">Use the green link below to <b>create a draft project</b>.<br/>Please note: new website drafts are not the same as redesign drafts.</p>');
					options.append(intro, intro2);

					let draft_id = this.obj.data('draft-link')
					if( draft_id ){
						var create = $('<a class="btn btn-green" href="/projects/all/' + draft_id + '">Create Draft Project</a>');
						footer.append(create);
					}

					footer.append(cancel);
				}else{
					var intro = $('<p class="text-center">Please select a draft to import?</p>');
					options.append(intro, section_name);
					section_name.append(label_draft,this.draft);
					$(drafts).each(function() {
						this.draft.append($("<option>").attr('value',drafts[i].id).text(drafts[i].name));
						i++;
					}.bind(this));

					footer.append(importDraft, cancel);
				}

				this.show('compact', 'Import New Website Draft', false, false, content, footer, this.done.bind(this), 600);
			},
			import : function(data)
			{
				data.preventDefault();

				ajaxRequest(
					'/site/import-draft/' + this.obj.data('id'),
					{
						draft : this.draft.val(),
						new : this.obj.data('trigger-draft-import'),
					},
					this.importDone.bind(this),
					'create draft'
				);
			},
			importDone : function(data)
			{
				window.location.href = "/projects/all/" + this.obj.data('id');
			},
			createDone : function(data)
			{
				window.location.href = "/projects/all/" + this.obj.data('trigger-draft-create');
			},
			deleteDone : function()
			{
				this.obj.closest('.project-draft').remove();
				this.done();
			},
			done : function()
			{
				overlay.obj.off('click');

				this.modal.remove();
				overlay.hide();
				loading.stop();
			}
		});

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var draftRedesignProject = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function()
			{
				if(this.obj.data('trigger-redesign-draft-create'))
					this.createLaunch();
				else if(this.obj.data('trigger-redesign-draft-delete'))
					this.deleteLaunch();
				else if(this.obj.data('trigger-redesign-draft-import'))
					this.importLaunchLoad();
			},
			createLaunch : function()
			{
				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var options = $('<div class="options">');
				var intro = $('<p class="text-center">Please provide a name for your redesign draft project?</p>');

				var section_name = $('<section>');
				var label_name = $('<label>Name:</label>');

				this.name = $('<input type="text" />');
				this.name.keypress(function (e) {
					if (e.which == 13) {
						edit.click();
					}
				});

				content.append(container);
				container.append(options);
				options.append(intro, section_name);
				section_name.append(label_name, this.name);

				var footer = $('<div class="footer">');
				var create = $('<a class="btn btn-green">Create</a>');
				create.on('click', this.create.bind(this));

				var cancel = $('<a class="btn btn-red">Cancel</a>');
				cancel.on('click', this.done.bind(this));

				footer.append(create, cancel);
				this.show('compact', 'Create Redesign Draft', false, false, content, footer, this.done.bind(this), 600);
			},
			create : function(data)
			{
				data.preventDefault();

				ajaxRequest(
					'/site/create-redesign-draft/' + this.obj.data('trigger-redesign-draft-create'),
					{
						name : this.name.val(),
					},
					this.createDone.bind(this),
					'create draft'
				);
			}, // Delete handled by standard delete
			importLaunchLoad : function()
			{
				ajaxRequest(
					'/site/import-redesign-draft-list/' + this.obj.data('id'),
					{
						id : this.obj.data('trigger-redesign-draft-import'),
					},
					this.importLaunch.bind(this),
					'import draft list'
				);
			},
			importLaunch : function(data)
			{
				loading.stop();
				let id = this.obj.data('trigger-redesign-draft-import');

				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var options = $('<div class="options">');

				var section_name = $('<section>');
				var label_draft = $('<label>Draft:</label>');

				this.draft = $('<select>');

				content.append(container);
				container.append(options);

				var footer = $('<div class="footer">');
				var importDraft = $('<a class="btn btn-green" data-id="' + id + '">Import</a>');
				importDraft.on('click', this.import.bind(this));

				var cancel = $('<a class="btn btn-grey">Cancel</a>');
				cancel.on('click', this.done.bind(this));

				var close = $('<a class="btn btn-green">Close</a>');
				close.on('click', this.done.bind(this));

				let drafts = data.draft_projects;
				let i = 0;
				if(drafts.length === 0){
					var intro = $('<p class="text-center"><b class="error-message">You currently do not have any redesign drafts.</b></p>');
					var intro2 = $('<p class="text-center">Use the green link below to <b>create a draft project</b>.<br/>Please note: redesign drafts are not the same as new website drafts.</p>');
					options.append(intro, intro2);

					let draft_id = this.obj.data('draft-link')
					if( draft_id ){
						var create = $('<a class="btn btn-green" href="/projects/all/' + draft_id + '">Create Draft Project</a>');
						footer.append(create);
					}

					footer.append(cancel);
				}else{
					var intro = $('<p class="text-center">Please select a draft to import?</p>');
					options.append(intro, section_name);
					section_name.append(label_draft,this.draft);
					$(drafts).each(function() {
						this.draft.append($("<option>").attr('value',drafts[i].id).text(drafts[i].name));
						i++;
					}.bind(this));

					footer.append(importDraft, cancel);
				}

				this.show('compact', 'Import Redesign Draft', false, false, content, footer, this.done.bind(this), 600);
			},
			import : function(data)
			{
				data.preventDefault();

				ajaxRequest(
					'/site/import-draft/' + this.obj.data('id'),
					{
						draft : this.draft.val(),
						new : this.obj.data('trigger-redesign-draft-import'),
					},
					this.importDone.bind(this),
					'create draft'
				);
			},
			importDone : function(data)
			{
				window.location.href = "/projects/all/" + this.obj.data('id');
			},
			createDone : function(data)
			{
				window.location.href = "/projects/all/" + this.obj.data('trigger-redesign-draft-create');
			},
			deleteDone : function()
			{
				this.obj.closest('.project-draft').remove();
				this.done();
			},
			done : function()
			{
				overlay.obj.off('click');

				this.modal.remove();
				overlay.hide();
				loading.stop();
			}
		});

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	function pageActions()
	{
		var obj = $('#add-page-action');
		if (obj.length)
		{
			pageAction(obj);
		}
	}

	var pageAction = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function()
			{
				if(this.obj.hasClass('action_row'))
					this.modal();
				else{
					$(this.obj).click(this.modal.bind(this));
				}
			},
			modal : function()
			{

				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var options = $('<div class="options">');

				var section_action = $('<section>');
				var label_action = $('<label class="long">Action:</label>');

				var section_details = $('<section>');
				var label_details = $('<label class="long">Details:</label>');

				this.action = $('<textarea class="input"/>');
				this.choice = $('<select>');
				this.choice.append($("<option>").attr('value','').text('- Please select -'));
				this.choice.append($("<option>").attr('value','Other').text('Other'));

				this.optgroup0 = $('<optgroup>').attr('label','Shop');
				$.each(['Buy','Shop','Order','Add to basket','Pick','View'], function (index, value) {
					this.optgroup0.append($("<option>").attr('value',value).text(value));
				}.bind(this));

				this.optgroup1 = $('<optgroup>').attr('label','SaaS conversion');
				$.each(['Try','Get started','Subscribe','Sign up'], function (index, value) {
					this.optgroup1.append($("<option>").attr('value',value).text(value));
				}.bind(this));

				this.optgroup2 = $('<optgroup>').attr('label','Non-profit conversion');
				$.each(['Donate','Commit','Volunteer','Adopt','Give','Support'], function (index, value) {
					this.optgroup2.append($("<option>").attr('value',value).text(value));
				}.bind(this));

				this.optgroup3 = $('<optgroup>').attr('label','Newsletter or community');
				$.each(['Subscribe','Join','Sign up','Refer'], function (index, value) {
					this.optgroup3.append($("<option>").attr('value',value).text(value));
				}.bind(this));

				this.optgroup4 = $('<optgroup>').attr('label','Freebie giveaway');
				$.each(['Download','Get','Grab','Claim','Take advantage of'], function (index, value) {
					this.optgroup4.append($("<option>").attr('value',value).text(value));
				}.bind(this));

				this.optgroup5 = $('<optgroup>').attr('label','General');
				$.each(['Learn More','See more','See how','Start','Find out', 'Check it out', 'Click here', 'Continue', 'Swipe up'], function (index, value) {
					this.optgroup5.append($("<option>").attr('value',value).text(value));
				}.bind(this));


				this.choice.append(this.optgroup0,this.optgroup1,this.optgroup2,this.optgroup3,this.optgroup4,this.optgroup5);
				this.choice.val(this.obj.data('choice'));

				if(!this.obj.data('id'))
					var modalTitle = 'Add call to action';

				else
				{
					var modalTitle = 'Edit call to action';
					this.action.val(this.obj.data('action'));
					this.id = $('<input type="hidden" />');
					this.id.val(this.obj.data('id'));
					options.append(this.id);
				}

				content.append(container);
				container.append(options);
				options.append(section_action,section_details);
				section_action.append(label_action, this.choice);
				section_details.append(label_details, this.action);

				var footer = $('<div class="footer">');
				var save = $('<a class="btn btn-green" data-id="' + '">Save</a>');

				save.on('click', this.save.bind(this));

				var cancel = $('<a class="btn btn-grey">Cancel</a>');

				cancel.on('click', this.cancel.bind(this));

				var remove = $('<a class="btn btn-red" href="#">Delete</a>');
				remove.on('click', this.delete.bind(this));

				footer.append(save, cancel);

				if(this.obj.data('id'))
					footer.append(remove);

				this.show('compact', modalTitle, false, false, content, footer, this.cancel.bind(this),600);
			},
			save : function(data)
			{
				data.preventDefault();

				if(this.obj.data('id'))
				{
					ajaxRequest(
						'/content/edit-action/' + this.obj.data('page_id'),
						{
							id : this.obj.data('id'),
							action : this.action.val(),
							choice : this.choice.val(),
						},
						this.editDone.bind(this),
						'Edit Action'
					);
				}
				else
				{
					ajaxRequest(
						'/content/add-action/' + this.obj.data('page_id'),
						{
							action : this.action.val(),
							choice : this.choice.val(),
						},
						this.addDone.bind(this),
						'Add Action'
					);
				}

			},
			delete : function()
			{
				ajaxRequest(
					'/content/delete-action/' + this.obj.data('page_id'),
					{
						id : this.obj.data('id'),
					},
					this.deleteDone.bind(this),
					'Add Note'
				);
			},
			addDone : function(data)
			{
				var choice = data.choice ? '<b>' + data.choice + ': - </b> ' : '';
				var svg = '<svg viewBox="0 0 20 20" class="icon icon-cross">'
									+ '<polygon points="15.606,0 10,5.606 4.394,0 0,4.394 5.606,10 0,15.606 4.394,20 10,14.394 15.606,20 20,15.606 14.394,10 20,4.394 "/>'
								+ '</svg>';

				var row = '<div class="row action_row" data-page_id="' + this.obj.data('page_id') + '" data-id="' + data.id + '" data-action="' + data.action + '" data-choice="' + data.choice + '">'
									+ '<div class="action">' + choice + nl2br(data.action) + '</div>'
									+ '<div class="delete">' + svg + '</div>'
								+ '</div>'

				let element = $('#page-actions');
				element.prepend(row);

				$('#page-actions-norow').data().count ++;
				$('#page-actions-norow').addClass('hidden');

				this.done();
			},
			editDone : function()
			{
				var choice = this.choice.val() ? '<b>' + this.choice.val() + ': - </b> ' : '';
				this.obj.data('action', this.action.val());
				this.obj.data('choice', this.choice.val());
				this.obj.children( ".action" ).html(choice + nl2br(this.action.val()));
				this.done();
			},
			deleteDone : function()
			{
				this.obj.remove();
				$('#page-actions-norow').data().count --;
				if($('#page-actions-norow').data('count') === 0)
				{
					$('#page-actions-norow').removeClass('hidden');
				}
				this.done();
			},
			cancel : function()
			{
				this.done();
			},
			done : function()
			{
				overlay.obj.off('click');

				this.modal.remove();
				overlay.hide();
				loading.stop();
			}
		});

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};

	})();

	function franchiseNotes()
	{
		var obj = $('#add-franchise-note');
		if (obj.length)
		{
			franchiseNote(obj);
		}
	}

	var franchiseNote = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function()
			{
				if(this.obj.hasClass('franchise_row'))
					this.modal();
				else{
					$(this.obj).click(this.modal.bind(this));
				}
			},
			modal : function()
			{

				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var options = $('<div class="options">');

				var section_context = $('<section>');
				var label_context = $('<label class="long">Context:</label>');

				var section_note = $('<section>');
				var label_note = $('<label class="long">Note:</label>');

				this.context = $('<select/>');

				// In alphabetical order apart from the first and last
				var select_arr = [
					{text: 'General Note'},
					{text: 'Content'},
					{text: 'Colour Preferences'},
					{text: 'Extras'},
					{text: 'Header & Footer'},
					{text: 'Image Gallary'},
					{text: 'Likes & Dislikes'},
					{text: 'Look & feel'},
					{text: 'Logo'},
					{text: 'Navigation'},
					{text: 'Review'},
					{text: 'Social Media'},
					{text: 'Web Design Brief'},
					{text: 'Other'}
				];

				let i = 0;
				$(select_arr).each(function() {
					this.context.append($("<option>").attr('value',select_arr[i].text).text(select_arr[i].text));
					i++;
				}.bind(this));

				this.note = $('<textarea class="input"/>');

				if(!this.obj.data('id'))
					var modalTitle = 'Add Note';

				else
				{
					var modalTitle = 'Edit Note';
					this.context.val(this.obj.data('context'));
					this.note.val(this.obj.data('note'));
					this.id = $('<input type="hidden" />');
					this.id.val(this.obj.data('id'));
					options.append(this.id);
				}

				content.append(container);
				container.append(options);
				options.append(section_context, section_note);
				section_context.append(label_context, this.context);
				section_note.append(label_note, this.note);

				var footer = $('<div class="footer">');
				var save = $('<a class="btn btn-green" data-id="' + '">Save</a>');

				save.on('click', this.save.bind(this));

				var cancel = $('<a class="btn btn-grey">Cancel</a>');

				cancel.on('click', this.cancel.bind(this));

				var remove = $('<a class="btn btn-red" href="#">Delete</a>');
				remove.on('click', this.delete.bind(this));

				footer.append(save, cancel);

				if(this.obj.data('id'))
					footer.append(remove);

				this.show('compact', modalTitle, false, false, content, footer, this.cancel.bind(this),600);
			},
			save : function(data)
			{
				data.preventDefault();

				if(this.obj.data('id'))
				{
					ajaxRequest(
						'/project/edit-note/' + config.currentProject,
						{
							id : this.obj.data('id'),
							context : this.context.val(),
							note : this.note.val(),
						},
						this.editDone.bind(this),
						'Edit Note'
					);
				}
				else
				{
					ajaxRequest(
						'/project/add-note/' + config.currentProject,
						{
							context : this.context.val(),
							note : this.note.val(),
						},
						this.addDone.bind(this),
						'Add Note'
					);
				}

			},
			delete : function()
			{
				ajaxRequest(
					'/project/delete-note/' + config.currentProject,
					{
						id : this.obj.data('id'),
					},
					this.deleteDone.bind(this),
					'Add Note'
				);
			},
			addDone : function(data)
			{
				var svg = '<svg viewBox="0 0 20 20" class="icon icon-cross">'
									+ '<polygon points="15.606,0 10,5.606 4.394,0 0,4.394 5.606,10 0,15.606 4.394,20 10,14.394 15.606,20 20,15.606 14.394,10 20,4.394 "/>'
								+ '</svg>';

				var row = '<div class="row franchise_row" data-id="' + data.id + '" data-context="' + data.context + '" data-note="' + data.note + '">'
									+ '<div class="context">' + data.context + '</div>'
									+ '<div class="note">' + nl2br(data.note) + '</div>'
									+ '<div class="note_by">' + data.name + '<br><span>' + data.created_at + '</span></div>'
									+ '<div class="delete">' + svg + '</div>'
								+ '</div>'

				let element = $('#franchise-notes');
				element.prepend(row);

				$('#franchise-notes-norow').data().count ++;
				$('#franchise-notes-norow').addClass('hidden');

				this.done();
			},
			editDone : function()
			{
				this.obj.data('context', this.context.val());
				this.obj.data('note', this.note.val());
				this.obj.children( ".context" ).html(this.context.val());
				this.obj.children( ".note" ).html(nl2br(this.note.val()));
				this.done();
			},
			deleteDone : function()
			{
				this.obj.remove();
				$('#franchise-notes-norow').data().count --;
				if($('#franchise-notes-norow').data('count') === 0)
				{
					$('#franchise-notes-norow').removeClass('hidden');
				}
				this.done();
			},
			cancel : function()
			{
				this.done();
			},
			done : function(dat)
			{
				overlay.obj.off('click');

				this.modal.remove();
				overlay.hide();
				loading.stop();
			}
		});

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};

	})();

	var gbpCategory = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function()
			{
				if(this.obj.hasClass('gbp_category_row'))
					this.modal();
				else{
					$(this.obj).click(this.modal.bind(this));
				}
			},
			modal : function()
			{

				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var options = $('<div class="options">');

				var section_name = $('<section>');
				var label_name = $('<label class="long">Name:</label>');

				this.name = $('<input type="text" readonly></input>');

				var modalTitle = 'Edit Category';
				this.name.val(this.obj.data('name'));
				this.gcid = $('<input type="hidden" />');
				this.gcid.val(this.obj.data('gcid'));
				options.append(this.gcid);

				content.append(container);
				container.append(options);
				options.append(section_name);
				section_name.append(label_name, this.name);

				var footer = $('<div class="footer">');
				var save = $('<a class="btn btn-green" data-id="' + '">Save</a>');

				save.on('click', this.save.bind(this));

				var cancel = $('<a class="btn btn-grey">Cancel</a>');

				cancel.on('click', this.cancel.bind(this));

				var remove = $('<a class="btn btn-red" href="#">Delete</a>');
				remove.on('click', this.delete.bind(this));

				//footer.append(save);
				footer.append(cancel,remove);
				footer.append(remove);

				this.show('compact', modalTitle, false, false, content, footer, this.cancel.bind(this),600);
			},
			save : function(data)
			{
				data.preventDefault();
				ajaxRequest(
					'/gbp/edit-category/' + this.obj.data('id'),
					{
						gcid : this.obj.data('gcid'),
						primary : this.primary.val(),
					},
					this.editDone.bind(this),
					'Edit Category'
				);

			},
			delete : function()
			{
				ajaxRequest(
					'/gbp/delete-category/' + this.obj.data('id'),
					{
						gcid : this.obj.data('gcid'),
					},
					this.deleteDone.bind(this),
					'Delete Category'
				);
			},
			editDone : function()
			{
				this.done();
			},
			deleteDone : function()
			{
				this.obj.remove();
				$('#gbp-categories-norow').data().count --;
				if($('#gbp-categories-norow').data('count') === 0)
				{
					$('#gbp-categories-norow').removeClass('hidden');
				}
				this.done();
			},
			cancel : function()
			{
				this.done();
			},
			done : function()
			{
				overlay.obj.off('click');

				this.modal.remove();
				overlay.hide();
				loading.stop();
			}
		});

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};

	})();

	function uploads()
	{
		// Old Upload with hardcoded id
		var obj = $('#upload-single');
		if (obj.length)
		{
			upload(obj);
		}

		// New Upload with hardcoded class to allow multiple versions
		$(".upload-single").each(function() {
			if ($(this).length)
			{
				upload($(this));
			}
		});

	}

	var upload = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function()
			{
				if(this.obj.data('trigger-file-edit'))
					this.editFileLaunch();
				else{
					this.settings = $.extend({ name : '' }, this.options());
					this.launch();
				}

			},
			options : function()
			{
				return {
					name : this.obj.data('upload-name')
				};
			},
			launch : function(){

				this.browse = $(this.obj).children('.add-file');
				let multi_uploader = this.browse.data('uploader') === 'new';
				this.preview = $(this.obj).children('.upload .preview');
				this.container = this.browse.closest('.form-input');

				let progress = $(this.obj).children('.progress');
				let bar = $(progress).children('.bar');

				this.browse.click(function()
				{
					this.container.next('.error-message').remove();
				}
				.bind(this));

				let browse_button = 'add-file';
				let config_container = 'upload-single';

				this.usage = this.browse.data('usage')
				if(this.usage)
				{
					browse_button = this.usage + '-add-file';
					config_container = this.usage + '-upload-single';
				}
				var uploaderConfig = {
					runtimes : 'html5',
					browse_button : browse_button,
					container: config_container,
					max_file_size : '10mb',
					multipart_params : { _csrf : config.token, usage : this.usage },
					chunk_size : 0,
					multi_selection : false,
					url: config.upload,
					filters: {
						max_file_size: "20mb",
						prevent_duplicates: true
					},
					headers:{
						'X-UPLOAD-FILE': 'yes'
					},
					max_retries: 0
				}

				if (detect.isDesktop()) {
					uploaderConfig.drop_element = browse_button;
				}

				var up = new plupload.Uploader(uploaderConfig);

				up.init();

				up.bind('Error', function(up, data)
				{
					up.stop();

					if (data.code == plupload.HTTP_ERROR){
						switch (data.status){
							case 403: // Forbidden

								function retry(){
									data.file.status = plupload.QUEUED;
									up.start();
								}

								accessDenied(retry, 'upload your file');

								return;

							break;
						}
					}

					this.handleError(up, data.file, data.message);
				}
				.bind(this));

				up.bind('FilesAdded', function(up, files)
				{
					this.browse.html('Loading (<span class="loading">0</span>%)');
					up.start();
					progress.addClass('show');
				}, this);

				up.bind('BeforeUpload', function(up, file)
				{
					up.settings.multipart_params.token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
				}
				.bind(this));

				up.bind('FilesRemoved', function(up, files)
				{
					window.setTimeout(function()
					{
						progress.removeClass('show');
					}
					.bind(this), speed * 3);
				});

				up.bind('ChunkUploaded', function(up, file, data)
				{
					var response = $.parseJSON(data.response);

					if (response.accessDenied){
						function retry(){}
						accessDenied(retry, 'upload your file');

						this.handleError(up, file, 'The upload failed due to session timeout. Please try again.');
					}
					else if (response.error) {
						this.handleError(up, file, response.error);
					}
				}, this);

				up.bind('FileUploaded', function(up, file, data)
				{
					var response = $.parseJSON(data.response);

					if (response.accessDenied){
						function retry(){}
						accessDenied(retry, 'upload your file');

						this.handleError(up, file, 'The upload failed due to session timeout. Please try again.');
					}
					else if (response.error)
					{
						this.handleError(up, file, response.error);
					}
					else
					{
						up.removeFile(file.id);

						this.container.data('required', false);
						this.browse.addClass('hidden');
						this.browse.html('<span class="click">Click</span> or drag your file file here to upload...');
						this.preview.children('span').addClass('success').html('Your file has been successfully uploaded.');
						this.preview.removeClass('hidden');

						up.refresh();

						window.setTimeout(function()
						{
							this.preview.children('.success').css({ opacity : 0 });
							window.setTimeout(function()
							{
								if(!multi_uploader)
								{
									this.settings.name = response.name + ' (' + response.size + ')';
									this.preview.children('span').removeClass('success').html(this.settings.name).css({ opacity : 1 });
								}
								else
								{
									var svg = '<svg viewBox="0 0 20 20" class="icon icon-cross">'
														+ '<polygon points="15.606,0 10,5.606 4.394,0 0,4.394 5.606,10 0,15.606 4.394,20 10,14.394 15.606,20 20,15.606 14.394,10 20,4.394 "/>'
													+ '</svg>';
									var row = '<div class="element" data-id="' + response.id + '" data-title="' + response.title + '" data-trigger-file-edit="1">'
														+ '<div class="label">' + response.title + '</div>'
														+ '<div class="description">' + svg + response.height + ' x ' + response.width + ' pixels (' + response.size + ')</div>'
													+ '</div>';
									let element = $('#' + this.usage + '-file_uploaded').find('.site-elements');
									element.append(row);

									let maxUploads = this.browse.data('max_uploads');
									let currentUploads = this.browse.data('current_uploads');
									currentUploads++;
									this.browse.data('current_uploads', currentUploads);
									if(maxUploads <= currentUploads)
									{
										$('#' + this.usage + '-file_uploader').css({ opacity : 0 }).addClass('hidden');
										$('#' + this.usage + '-file_uploader_max').removeClass('hidden');
									}
									$('#' + this.usage + '-file_uploaded').removeClass('hidden');
									this.browse.removeClass('hidden');
									this.preview.addClass('hidden');
									$('#' + this.usage + '-file_uploader_header').html(this.browse.data('uploader_header_new'));
									this.preview.children('span').removeClass('success').css({ opacity : 1 });
									bar.css({ width : '0%' });
									checkProceed.check();
								}
							}
							.bind(this), speed);
						}
						.bind(this), 1500);
					}
				}, this);

				up.bind('UploadProgress', function(up, file)
				{
					this.browse.children('.loading').text(up.total.percent);
					bar.css({ width : up.total.percent+'%' });
				}, this);

				this.preview.click(function()
				{
					var hint = $('<div class="hint">');
					hint.html('<p>Are you sure you want to delete your logo?</p>');

					var footer = $('<div class="footer">');
					var cancel = $('<a class="btn btn-green" href="#">No - Cancel</a>');

					cancel.on('click', this.cancel.bind(this));

					var remove = $('<a class="btn btn-red" href="#">Yes - Delete</a>');
					remove.click(this.delete.bind(this));

					footer.append(cancel, remove);

					this.show('compact', 'Delete logo', 'Are you sure you want to delete your logo?', false, '', footer, this.cancel.bind(this));
				}
				.bind(this));
			},
			handleError : function(up, file, error)
			{
				up.stop();
				up.removeFile(file.id);
				this.browse.html('<span class="error">' + error.message + '</span>');

				window.setTimeout(function()
				{
					this.browse.children('.error').css({ opacity : 0 });
					window.setTimeout(function()
					{
						this.browse.html('<span class="click">Click</span> or drag your logo file here to upload...');
					}
					.bind(this), speed);
				}
				.bind(this), 4000);
			},
			cancel : function(e)
			{
				e.preventDefault();
				overlay.obj.off('click');

				this.modal.remove();
				overlay.hide();
			},
			delete : function(e)
			{
				e.preventDefault();

				ajaxRequest(
					'/upload/delete-logo/' + config.currentProject,
					{},
					this.done.bind(this),
					'delete the logo'
				);
			},
			done : function(data)
			{
				if (data.error)
				{
					this.preview.children('span').addClass('error').html(data.error.message);

					window.setTimeout(function()
					{
						this.preview.children('.error').css({ opacity : 0 });

						window.setTimeout(function()
						{
							this.preview.children('span').removeClass('error').html(this.settings.name).css({ opacity : 1 });
						}
						.bind(this), speed);
					}
					.bind(this), 3000);
				}
				else
				{
					this.preview.addClass('hidden');
					this.browse.html('<span class="click">Click</span> or drag your file here to upload...');
					this.browse.removeClass('hidden');
				}

				this.container.data('required', true);
				this.modal.remove();

				overlay.hide();
				loading.stop();
				checkProceed.check();
			},
			editFileLaunch : function()
			{
				let id = this.obj.data('id');
				let title = this.obj.data('title');
				let note = this.obj.data('note');
				let project_id = this.obj.data('project_id');
				let filename = this.obj.data('filename');

				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var options = $('<div class="options">');
				var intro = $('<p class="text-center">Would you like to rename this file?</p>');

				var section_name = $('<section>');
				var label_name = $('<label>Name:</label>');

				var section_note = $('<section>');
				var label_note = $('<label>Note:</label>');
				var download = $('<p class="text-center">Click <a target="_new" href="/uploads/' + project_id + '/files/' + filename + '">here</a> to download this file.</p>');

				this.name = $('<input type="text" />');
				this.name.val(title);
				this.name.keypress(function (e) {
					if (e.which == 13) {
						edit.click();
					}
				});

				this.note = $('<textarea class="input"/>');
				this.note.val(note);

				content.append(container);
				container.append(options);
				options.append(intro, section_name, section_note, download);
				section_name.append(label_name, this.name);
				section_note.append(label_note, this.note);

				var footer = $('<div class="footer">');
				var edit = $('<a class="btn btn-green" data-id="' + id + '">Save</a>');

				edit.on('click', this.editFile.bind(this));

				var cancel = $('<a class="btn btn-grey">Cancel</a>');

				cancel.on('click', this.cancel.bind(this));

				var remove = $('<a class="btn btn-red">Delete</a>');
				remove.click(this.deleteFile.bind(this));

				footer.append(edit, cancel, remove);
				this.show('compact', 'Edit File', false, false, content, footer, this.cancel.bind(this),600);
			},
			editFile : function(data)
			{
				data.preventDefault();

				ajaxRequest(
					'/upload/edit-file/' + config.currentProject,
					{
						id : this.obj.data('id'),
						title : this.name.val(),
						note : this.note.val(),
					},
					this.editFileDone.bind(this),
					'edit the file'
				);
			},
			editFileDone : function(data)
			{
				if (data.error)
				{
					console.log(data.error);
				}
				else
				{
					this.obj.data('title', this.name.val());
					this.obj.data('note', this.note.val());
					this.obj.children( ".label" ).html(this.name.val());

					let description = this.obj.children( ".description" );
					description.children( "span" ).remove();
					description.children( "br" ).remove();
					description.children( "svg" ).remove();

					if(this.note.val())
						description.prepend('<span>' + nl2br(this.note.val()) + '</span><br/>');

					var svg = '<svg viewBox="0 0 20 20" class="icon icon-cross">'
										+ '<polygon points="15.606,0 10,5.606 4.394,0 0,4.394 5.606,10 0,15.606 4.394,20 10,14.394 15.606,20 20,15.606 14.394,10 20,4.394 "/>'
									+ '</svg>';

					description.prepend(svg);
				}

				this.modal.remove();
				overlay.hide();
				loading.stop();

			},
			deleteFile : function()
			{
				ajaxRequest(
					'/upload/delete-file/' + config.currentProject,
					{
						id : this.obj.data('id'),
					},
					this.deleteFileDone.bind(this),
					'delete the file'
				);
			},
			deleteFileDone : function(data)
			{
				if (data.error)
				{
					console.log(data.error);
				}
				else
				{
					this.usage = data.usage;
					this.browse = $('#' + this.usage + '-add-file');
					let maxUploads = this.browse.data('max_uploads');
					let currentUploads = this.browse.data('current_uploads');
					currentUploads--;
					this.browse.data('current_uploads', currentUploads);
					$('#' + this.usage + '-file_uploader').css({ opacity : 1 });

					if(maxUploads > currentUploads)
					{
						$('#' + this.usage + '-file_uploader').removeClass('hidden');
						$('#' + this.usage + '-file_uploader_max').addClass('hidden');
					}

					if(currentUploads === 0 )
					{
						$('#' + this.usage + '-file_uploader_header').html(this.browse.data('uploader_header'));
						$('#' + this.usage + '-file_uploaded').addClass('hidden');
					}

					this.obj.remove();
				}

				this.modal.remove();
				overlay.hide();
				loading.stop();
				checkProceed.check();

			}

		});

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var iconBar = {

		init : function()
		{
			this.marker = $('.icon-bar .marker');

			if (this.marker.length)
			{
				var active = $('.icon-bar a.active');
				this.marker.css('top', active.position().top + 'px');
				this.marker.css('height', active.outerHeight() + 2 + 'px');
				this.marker.css('opacity', 1);
			}

			this.links = $('.icon-bar a');
			this.links.on('click', this.setActive.bind(this));
		},
		setActive : function(e)
		{
			this.active = $(e.currentTarget);
			this.update();
		},
		update : function()
		{
			this.links.removeClass('active');
			this.active.addClass('active');
			this.marker.css('transition', 'top ' + speed / 1000 + 's, height ' + speed / 1000 + 's');
			this.marker.css('top', this.active.position().top + 'px');
			this.marker.css('height', this.active.outerHeight() + 2 + 'px');
		}

	};

	var popover = (function()
	{
		const prototype = {

			init : function()
			{
				this.settings = $.extend({

					position : 'top',
					content : '',
					space : 10,
					offset : 0,
					align : 'center',
					overlay : true,
					blur : true,
					class : false,
					fixed : false

				}, this.options());

				this.show();
			},
			options : function()
			{
				return {

					position : this.obj.data('popover-position'),
					content : this.obj.data('popover-content'),
					space : this.obj.data('popover-space'),
					offset : this.obj.data('popover-offset'),
					align : this.obj.data('popover-align'),
					overlay : this.obj.data('popover-overlay'),
					blur : this.obj.data('popover-blur'),
					fixed : this.obj.data('popover-fixed')

				};
			},
			show : function() {

				$('.popover').remove();
				$('body').off('click.popover');

				this.popover = $('<div class="popover ' + this.settings.position + '">');
				this.popover.html(this.settings.content);

				var links = this.popover.find('a[data-ajax]');
				links.on('click', function(e)
				{
					page.load(e);
					this.popover.remove();
					overlay.hide();
				}
				.bind(this));

				this.arrow = $('<div class="arrow">');
				this.popover.prepend(this.arrow);

				if (this.settings.class)
				{
					this.popover.addClass(this.settings.class);
				}

				if (this.settings.fixed)
				{
					this.popover.css('position', 'fixed');
				}

				$('body').append(this.popover);

				this.setPosition();
				this.popover.addClass('show');

				if (this.settings.overlay)
				{
					overlay.show();
				}

				if (this.settings.blur)
				{
					this.popover.click(function(e)
					{
						e.stopPropagation();
					});

					$('body').on('click.popover', function(e)
					{
						$(e.currentTarget).off('click.popover');
						this.popover.remove();
					}
					.bind(this));

					$('.overlay').on('click.popover', function(e)
					{
						$(e.currentTarget).off('click.popover');
						overlay.hide();
					});
				}
			},
			setPosition : function()
			{
				var offset = this.obj.offset();

				switch (this.settings.position)
				{
					case 'top':

						this.popover.css({

							left : (offset.left + this.obj.outerWidth() / 2 + this.settings.offset) + 'px',
							top : (offset.top - this.popover.outerHeight() - this.settings.space) + 'px',
							marginLeft : (this.popover.outerWidth() / -2) + 'px'

						});

						this.arrow.css({ marginLeft : (-7 - this.settings.offset) + 'px' });

						break;

					case 'bottom':

						this.popover.css({

							left : (offset.left + this.obj.outerWidth() / 2 + this.settings.offset) + 'px',
							top : (offset.top + this.obj.outerHeight() + this.settings.space - (this.settings.fixed ? doc.scrollTop() : 0)) + 'px',
							marginLeft : (this.popover.outerWidth() / -2) + 'px'

						});

						this.arrow.css({ marginLeft : (-7 - this.settings.offset) + 'px' });

						break;

					case 'left':

						this.popover.css({

							left : (offset.left - this.popover.outerWidth() - this.settings.space) + 'px',
							top : (offset.top + this.obj.outerHeight() / 2 + this.settings.offset) + 'px',
							marginTop : (this.popover.outerHeight() / -2) + 'px'

						});

						this.arrow.css({ marginTop : (-7 - this.settings.offset) + 'px' });

						break;

					case 'right':

						this.popover.css({

							left : (offset.left + this.obj.outerWidth() + this.settings.space) + 'px',
							top : (offset.top + this.obj.outerHeight() / 2 + this.settings.offset) + 'px',
							marginTop : (this.popover.outerHeight() / -2) + 'px'

						});

						this.arrow.css({ marginTop : (-7 - this.settings.offset) + 'px' });

						break;
				}

				switch (this.settings.align)
				{
					case 'left':

						this.popover.css({

							left : (offset.left + this.settings.offset) + 'px',
							marginLeft : 0,
							textAlign : 'left'

						});

						this.arrow.css({ marginLeft : '-7px' });

						break;
				}
			}

		};

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	// any element with a 'trigger-email' attribute will call this function when clicked on

	var triggerEmail = (function()
	{
		const prototype = Object.create(modal);
		Object.assign(prototype, {

			init : function()
			{
				this.settings = $.extend({

					id         : null, // Project Id
					email      : null, // default email address
					title      : null, // Header
					header     : null, // Header
					info       : null, // Info
					content    : null // Content

				}, this.options());

				this.launch();
			},
			options : function()
			{
				return {

					id         : this.obj.data('id'),
					email      : this.obj.data('email'),
					title      : this.obj.data('title'),
					header     : this.obj.data('header'),
					info       : this.obj.data('info'),
					content    : $('<div class="content">'),
				};
			},
			launch : function()
			{
				this.obj.next('.error-message').remove();
				this.textarea = $('<input type="text"></input>');
				this.textarea.val(this.settings.email);
				this.settings.content.append(this.textarea);

				this.notes = $('<textarea class="input invite">');
				this.settings.content.append('<br/><h4>Client Notes</h4><p>If you have a note for the client please enter it below.</p>').append(this.notes);
				var footer = $('<div class="footer">');

				this.save = $('<a class="btn btn-lg btn-green" href="#" data-actions="1">Send</a>');
				this.save.on('click', this.send.bind(this));
				footer.append(this.save);
				this.show(
					'compact',
					this.settings.title, // Title
					this.settings.header, // Header
					this.settings.info, // Info
					this.settings.content, // Content
					footer, // Footer
					this.close.bind(this), // Action on click overlay object
					false, // Fix width in pixels
					this.settings.toptip // ?? Top Tip?
				);

				this.textarea.focus();
			},
			send : function(data)
			{
				data.preventDefault();

				overlay.obj.off('click');
				this.save.text('Sending...');

				ajaxRequest(
					'/email/invite/' + this.settings.id,
					{
						email : this.textarea.val(),
						notes : this.notes.val()
					},
					this.slide.bind(this),
					'Invitation Email Sent'
				);
				this.close();
			},
			slide : function(data)
			{
				if (data.slides)
				{
					elements.slides.html(data.slides);
					loading.stop();
					page.refresh();
				}
			},
			close : function(e)
			{
				this.modal.remove();
				overlay.hide();
				loading.stop();
			}

		});

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	// any element with a 'data-content' attribute will call this function when clicked on
	var content = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function()
			{
				this.settings = $.extend({

					id         : null, // record id
					attribute  : null, // field name
					collection : null, // class name
					title      : '',
					header     : '',
					info       : '',
					toptip     : 1,
					content    : '',   // value
					autofill   : null

				}, this.options());

				this.launch();
			},
			options : function()
			{
				return {

					id         : this.obj.data('content'),            // record id
					attribute  : this.obj.data('content-attribute'),  // field name
					collection : this.obj.data('content-collection'), // class name
					title      : this.obj.data('content-title'),
					header     : this.obj.data('content-header'),
					info       : this.obj.data('content-info'),
					toptip     : this.obj.data('content-toptip'),
					char_min   : this.obj.data('content-char-min'),
					char_max   : this.obj.data('content-char-max'),
					content    : this.obj.next().val()                // value

				};
			},
			launch : function()
			{
				this.obj.next('.error-message').remove();
				this.textarea = $(this.isTextarea ? '<textarea>' : '<input type="text">');
				this.textarea.val(this.settings.content.replace(/(<br>)|(<br \/>)/g, "\n"));

				if (!this.isTextarea)
				{
					var content = $('<div class="content">');
					content.append(this.textarea);
				}

				var footer = $('<div class="footer">');

				// Character Count
				var char_min = this.settings.char_min;
				var char_max = this.settings.char_max;

				// Either one is required
				if(char_min > 0 || char_max > 0){
					var advice_text = '';
					var css_class = '';
					var char_length = this.settings.content.length;

					// If length is outside good range
					if (char_min > 0 && char_length < char_min && char_length > 0){
						advice_text = '(very short — fewer than ' + char_min + ' characters)';
						css_class = 'text-red';
					}else if (char_max > 0 && char_length > char_max){
						advice_text = '(very long — more than ' + char_max + ' characters)';
						css_class = 'text-red';
					}

					// Build character count text
					this.char_count_p = $('<p class="char-count">Length: </p>').addClass(css_class);
					footer.append(this.char_count_p);

					this.char_count_span = $('<span>');
					this.char_count_span.html(char_length);
					this.char_count_p.append(this.char_count_span);
					this.char_count_p.append(' characters ');

					this.char_count_span_advice = $('<span>');
					this.char_count_span_advice.html(advice_text);
					this.char_count_p.append(this.char_count_span_advice);

					// Add an on keyup event to change the count
					this.textarea.on('keyup', function()
					{
						var char_length = this.textarea.val().length;
						this.char_count_span.html(char_length);

						// If length is outside good range
						if (char_min > 0 && char_length < char_min && char_length > 0){
							advice_text = '(very short — fewer than ' + char_min + ' characters)';
							this.char_count_p.addClass('text-red');
						}else if (char_max > 0 && char_length > char_max){
							advice_text = '(very long — more than ' + char_max + ' characters)';
							this.char_count_p.addClass('text-red');
						}else{
							this.char_count_p.removeClass('text-red');
							advice_text = '';
						}

						// Update the advice text
						this.char_count_span_advice.html(advice_text);
					}.bind(this));
				}

				this.save = $('<a class="btn btn-lg btn-green" href="#">Continue</a>');
				this.save.on('click', this.update.bind(this));
				footer.append(this.save);

				this.show(
					this.isTextarea ? 'expanded' : 'compact',
					this.settings.title,
					this.settings.header ? this.settings.header : false,
					this.settings.info ? this.settings.info : false,
					this.isTextarea ? this.textarea : content,
					footer,
					this.update.bind(this),
					false,
					this.settings.toptip
				);

				this.textarea.focus();
			},
			update : function(e)
			{
				e.preventDefault();

				overlay.obj.off('click');
				this.save.text('Saving...');

				ajaxRequest(
					'/update/save-' + this.settings.collection + '-' + this.settings.attribute
							+ '/' + this.settings.id,
					{
						content : this.textarea.val()
					},
					this.done.bind(this),
					'save your changes'
				);
			},
			done : function(data)
			{
				if (data.error !== undefined)
				{
					this.error = $('<div class="error-message">');
					this.error.html(data.error);

					this.textarea.next('.error-message').remove();
					this.textarea.after(this.error);

					this.save.text('Continue');

					overlay.obj.on('click', this.update.bind(this));
				}
				else if (data.content !== undefined)
				{
					this.obj.next().val(data.content);

					if (data.preview.trim() == '')
					{
						this.setRequired(true);
						this.obj.parent().addClass('empty');
						this.obj.prev().empty();
					}
					else
					{
						this.setRequired(false);
						this.obj.parent().removeClass('empty');
						this.obj.prev().html(data.preview);
					}

					this.modal.remove();
					overlay.hide();
					checkProceed.check();
				}

				loading.stop();
			},
			setRequired : function(required)
			{
				if (this.obj.attr('data-required') != 'undefined')
				{
					this.obj.data('required', required)
				}
			}

		});

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.isTextarea = obj.hasClass('textarea');
			instance.init();

			return instance;
		};
	})();

	var addSites = function()
	{
		$('.add-site').each(function(i, obj)
		{
			addSite($(obj));
		});

		$('.delete-site').each(function(i, obj)
		{
			removeSite($(obj));
		});
	}

	var addSite = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function()
			{
				this.add.off('click').on('click', function()
				{
					this.add.next('.error-message').remove();
					this.textbox = $('<input type="text">');

					var content = $('<div class="content">');
					content.append(this.textbox);

					this.textbox.attr('placeholder', 'http://');

					var footer = $('<div class="footer">');
					var cancel = $('<a class="btn btn-grey" href="#">Cancel</a>');

					cancel.on('click', this.cancel.bind(this));

					this.save = $('<a class="btn btn-green" href="#">Continue</a>');
					this.save.on('click', this.update.bind(this));

					footer.append(cancel, this.save);

					this.show(
						'compact',
						'Add a site you ' + (this.add.data('like') ? '' : 'don\'t') + ' like',
						false,
						false,
						content,
						footer,
						this.cancel.bind(this),
						450
					);

					this.textbox.focus();
				}
				.bind(this));
			},
			cancel : function(e)
			{
				e.preventDefault();
				overlay.obj.off('click');

				this.modal.remove();
				overlay.hide();
			},
			update : function(e)
			{
				e.preventDefault();

				overlay.obj.off('click');
				this.save.text('Saving...');

				ajaxRequest(
					'/update/add-site/' + config.currentProject,
					{
						url  : this.textbox.val(),
						like : this.add.data('like')
					},
					this.done.bind(this),
					'add the website'
				);
			},
			done : function(data)
			{
				if (data.error !== undefined)
				{
					this.error = $('<div class="error-message">');
					this.error.html(data.error);

					this.textbox.next('.error-message').remove();
					this.textbox.after(this.error);
					this.save.text('Continue');

					overlay.obj.on('click', this.update.bind(this));
				}
				else if (data.site !== undefined)
				{
					this.add.before(data.site);

					if (this.add.data('like'))
					{
						this.add.data('required', false);
					}

					addSites();

					this.modal.remove();
					overlay.hide();
					checkProceed.check();
				}

				loading.stop();
			}

		});

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.add = obj;
			instance.init();

			return instance;
		};
	})();

	var removeSite = (function() {

		const prototype = Object.create(modal);

		Object.assign(prototype,
		{
			init : function()
			{
				this.obj.off('click').on('click', function()
				{
					var hint = $('<div class="hint">');
					hint.html('<p>Are you sure you want to delete the following site?</p>');

					var item = $('<div class="item">');
					item.html(this.obj.data('url'));
					hint.append(item);

					var footer = $('<div class="footer">');

					var cancel = $('<a class="btn btn-green" href="#">No - Cancel</a>');
					cancel.on('click', this.cancel.bind(this));

					var remove = $('<a class="btn btn-red" href="#">Yes - Delete</a>');
					remove.click(this.delete.bind(this));

					footer.append(cancel, remove);

					this.show(
						'compact',
						'Delete a website',
						false,
						false,
						hint,
						footer,
						this.cancel.bind(this)
					);
				}
				.bind(this));
			},
			cancel : function(e)
			{
				e.preventDefault();
				overlay.obj.off('click');

				this.modal.remove();
				overlay.hide();
			},
			delete : function(e)
			{
				e.preventDefault();

				overlay.obj.off('click');

				ajaxRequest(
					'/update/remove-site/' + this.obj.data('id'),
					{},
					this.done.bind(this),
					'remove the website'
				);
			},
			done : function(data)
			{
				if (data.success)
				{
					var site = this.obj.closest('.site');

					if (site.hasClass('site-like') && $('.site-like').length < 2)
					{
						site.siblings('.add-site').data('required', true);
					}

					site.remove();
					addSites();

					this.modal.remove();
					overlay.hide();

					checkProceed.check();
					loading.stop();
				}
			}
		});

		return function(obj, isTextarea)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var socialMediaLinks = function()
	{
		var add = $('.add-social-link');
		addSocialLink(add);

		$('.media-link .remove').each(function(i, obj)
		{
			removeSocialLink($(obj));
		});

		var none = $('#social_none');

		if (!none.data('check-proceed'))
		{
			none.data('check-proceed', true)
			none.on('change', function()
			{
				add.next('.error-message').remove();
				checkProceed.check();
			});
		}
	}

	var addSocialLink = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function()
			{
				this.obj.off('click').on('click', function()
				{
					$('#social_none').prop('checked', false).trigger('change');

					this.dropdown = $('<select>');
					this.dropdown.append('<option value="*">Link to...</option>');

					$.each(config.links, function(i, link)
					{
						this.dropdown.append('<option value="' + i + '" data-placeholder="' + link[1] + '">' + link[0] + '</option>');
					}
					.bind(this));

					this.textbox = $('<input type="text">');

					this.dropdown.change(function(e)
					{
						if (e.currentTarget.value === '*')
						{
							this.textbox.attr('placeholder', '');
						}
						else
						{
							this.textbox.attr('placeholder', config.links[e.currentTarget.value][1]);
						}

						var option = config.links[e.currentTarget.value][1];
					}
					.bind(this));

					var content = $('<div class="content inline">');
					content.append(this.dropdown);
					content.append(this.textbox);

					var footer = $('<div class="footer">');

					var cancel = $('<a class="btn btn-lg btn-grey" href="#">Cancel</a>');
					cancel.on('click', this.cancel.bind(this));

					this.save = $('<a class="btn btn-lg btn-green" href="#">Add Link</a>');
					this.save.on('click', this.update.bind(this));
					footer.append(cancel, this.save);

					this.show(
						'compact',
						'Add a social media link',
						false,
						false,
						content,
						footer,
						this.cancel.bind(this),
						460
					);

					this.textbox.focus();
				}
				.bind(this));
			},
			cancel : function(e)
			{
				e.preventDefault();
				this.modal.remove();
				overlay.hide();
			},
			update : function(e)
			{
				e.preventDefault();
				this.save.text('Saving...');

				ajaxRequest(
					'/update/add-social-media-link/' + config.currentProject,
					{
						type : this.dropdown.val(),
						url  : this.textbox.val()
					},
					this.done.bind(this),
					'add the social media link'
				);
			},
			done : function(data)
			{
				if (data.links !== undefined)
				{
					config.links = data.links;
					if ($.isEmptyObject(config.links))
					{
						this.block.addClass('all');
					}
				}

				if (data.error !== undefined)
				{
					if (data.error.type !== undefined)
					{
						this.errorType = $('<div class="error-message">');
						this.errorType.html(data.error.type);

						this.dropdown.next('.error-message').remove();
						this.dropdown.after(this.errorType);

						this.save.text('Continue');
					}

					if (data.error.url !== undefined)
					{
						this.errorUrl = $('<div class="error-message">');
						this.errorUrl.html(data.error.url);

						this.textbox.next('.error-message').remove();
						this.textbox.after(this.errorUrl);

						this.save.text('Continue');
					}
				}
				else if (data.link !== undefined)
				{
					this.obj.before(data.link);
					this.block.addClass('one');
					socialMediaLinks();
					checkProceed.check();
					this.modal.remove();
					overlay.hide();
				}

				loading.stop();
			}

		});

		return function(obj, isTextarea)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.block = obj.closest('.block');
			instance.init();

			return instance;
		};
	})();

	var removeSocialLink = (function()
	{
		const prototype = {

			init : function()
			{
				this.obj.off('click').on('click', function()
				{
					ajaxRequest(
						'/update/remove-social-media-link/' + this.obj.data('id'),
						{},
						this.done.bind(this),
						'remove social media link'
					);
				}
				.bind(this));
			},
			done : function(data)
			{
				if (data.success)
				{
					if (data.links !== undefined)
					{
						config.links = data.links;
						if (!$.isEmptyObject(config.links))
						{
							this.block.removeClass('all');
						}
					}

					this.obj.parent().remove();

					if ($('.social-media-links .media-link').length < 1)
					{
						this.block.removeClass('one');
					}

					socialMediaLinks();
					checkProceed.check();
					loading.stop();
				}
			}

		};

		return function(obj, isTextarea)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.block = obj.closest('.block');
			instance.init();

			return instance;
		};
	})();

	// any element with a 'data-select' attribute will call this function when changed on
	var select = (function()
	{
		const prototype = {

			init : function()
			{
				this.settings = $.extend({

					id         : null, // record id
					collection : null, // class name
					attribute  : null, // field name

				}, this.options());


				this.update();
			},
			options : function()
			{
				return {

					id         : this.obj.data('select'),     // model id
					collection : this.obj.data('collection'), // class name
					attribute  : this.obj.attr('name'),       // field name

				};
			},
			update : function()
			{
				this.obj.closest('.select').data('required', false).next('.error-message').remove();

				ajaxRequest(
					'/update/save-' + this.settings.collection + '-' + this.settings.attribute
							+ '/' + this.settings.id,
					{
						content : this.obj.val()
					},
					this.done.bind(this),
					'save your changes'
				);
			},
			done : function(data)
			{
				this.hide = this.obj.data('hide');
				var hide_arr = this.hide.split(',');
				$.each(hide_arr, function(i, hide){
					if(hide){
						$('#' + hide).addClass('hidden');
					}
				});

				this.show = this.obj.find(':selected').data('show');
				if(this.show){
					$('#' + this.show).removeClass('hidden');
				}
				loading.stop();
				checkProceed.check()
			}

		};

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();
	// any element with a 'data-radio' attribute will call this function when clicked on
	var radio = (function()
	{
		const prototype = {

			init : function()
			{
				this.settings = $.extend({

					id         : null, // record id
					collection : null, // class name
					attribute  : null, // field name
					reveal     : null,
					target     : null,
					hide       : null,
					hideTarget : null

				}, this.options());

				this.update();
			},
			options : function()
			{
				return {

					id         : this.obj.data('radio'),      // record id
					collection : this.obj.data('collection'), // class name
					attribute  : this.obj.attr('name'),       // field name
					reveal     : this.obj.data('reveal'),
					target     : this.obj.data('target'),
					hide       : this.obj.data('hide'),
					hideTarget : this.obj.data('hide-target')

				};
			},
			update : function()
			{
				this.obj.closest('.radio-list').data('required', false).next('.error-message').remove();

				ajaxRequest(
					'/update/save-' + this.settings.collection + '-' + this.settings.attribute
							+ '/' + this.settings.id,
					{
						content : this.obj.val()
					},
					this.done.bind(this),
					'save your changes'
				);
			},
			done : function(data)
			{
				if (data.content)
				{
					if (this.settings.reveal !== null)
					{
						var targets = this.settings.target.split(" ");
						for( var i=0; i < targets.length; i++){
							var target = $('#' + targets[i]);

							if (this.obj.val() == this.settings.reveal)
							{
								target.removeClass('hidden');
							}
							else
							{
								target.addClass('hidden');
							}
						}
					}

					if (this.settings.hide !== null)
					{
						var hideTargets = this.settings.hideTarget.split(" ");
						for( var i=0; i < hideTargets.length; i++){
							var target = $('#' + hideTargets[i]);

							if (this.obj.val() == this.settings.hide)
							{
								target.addClass('hidden');
							}
							else
							{
								target.removeClass('hidden');
							}

						}
					}

					loading.stop();
					checkProceed.check();
				}
			}

		};

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	// any element with a 'data-checkbox' attribute will call this function when clicked on
	var checkbox = (function()
	{
		const prototype = {

			init : function()
			{
				this.settings = $.extend({

					id            : null, // record id
					collection    : null, // class name
					attribute     : null, // field name
					showChecked   : null,
					showUnchecked : null

				}, this.options());

				this.update();
			},
			options : function()
			{
				return {

					id            : this.obj.data('checkbox'),     // record id
					collection    : this.obj.data('collection'),   // class name
					attribute     : this.obj.attr('name'),         // field name
					showChecked   : this.obj.data('show-checked'),
					showUnchecked : this.obj.data('show-unchecked')

				};
			},
			update : function()
			{
				ajaxRequest(
					'/update/save-' + this.settings.collection + '-' + this.settings.attribute
							+ '/' + this.settings.id,
					{
						content : this.obj.is(':checked') ? 1 : 0
					},
					this.done.bind(this),
					'save your changes'
				);
			},
			done : function(data)
			{
				if (data.content)
				{
					if (this.settings.showChecked !== null)
					{
						var target = $('#' + this.settings.showChecked);

						if (this.obj.is(':checked'))
						{
							target.removeClass('hidden');
						}
						else
						{
							target.addClass('hidden');
						}
					}

					if (this.settings.showUnchecked !== null)
					{
						var target = $('#' + this.settings.showUnchecked);

						if (this.obj.is(':checked'))
						{
							target.addClass('hidden');
						}
						else
						{
							target.removeClass('hidden');
						}
					}

					loading.stop();
					checkProceed.check();
				}
			}

		};

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var submit = (function()
	{
		const prototype = {

			init : function()
			{
				this.settings = $.extend({

					id            : null, // record id
					collection    : null, // class name
					attribute     : null, // field name
					showChecked   : null,
					showUnchecked : null

				}, this.options());

				this.update();
			},
			options : function()
			{
				return {

					id            : this.obj.data('submit'),     // record id
					collection    : this.obj.data('collection'),   // class name
					attribute     : this.obj.attr('name'),         // field name
					showChecked   : this.obj.data('show-checked'),
					showUnchecked : this.obj.data('show-unchecked')

				};
			},
			update : function()
			{
				ajaxRequest(
					'/update/save-' + this.settings.collection + '-' + this.settings.attribute
							+ '/' + this.settings.id,
					{
						content : this.obj.val()
					},
					this.done.bind(this),
					'save your changes'
				);
			},
			done : function(data)
			{
				if (data.content)
				{
					loading.stop();
					checkProceed.check();
				}
			}

		};

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var selector = (function()
	{
		const prototype = {

			init : function()
			{
				this.settings = $.extend({

					id            : null, // record id
					class         : null, // class name
					attribute     : null, // field name
					selector      : null, // field name

				}, this.options());

				this.search();
			},
			options : function()
			{
				return {

					id            : this.obj.data('id'),         // record id
					class         : this.obj.data('class'),      // class name
					attribute     : this.obj.attr('name'),       // field name
					selector      : this.obj.data('selector'),   // selector name
				};
			},
			search : function()
			{
				ajaxRequest(
					'/selector/' + this.settings.class + '-' + this.settings.selector + '/' + this.settings.id,
					{
						search : this.obj.val()
					},
					this.done.bind(this,this.settings.id,this.obj),
					'search'
				);
			},
			selector : function()
			{
				// Get content
				var value = $(this).data('value');
				var display = $(this).data('display');

				// Get inputs
				var div = $(this).parent();
				var input = div.parent().children('input');

				// Post
				ajaxRequest(
					'/update/save-' + input.data('class') + '-' + input.attr('name') + '/' + input.data('id'),
					{
						content : value
					}
				);

				loading.stop();

				// Set display
				input.val(display);;
				input.attr('value',display);
				input.attr('data-value',display);

				// Remove dropdown
				div.remove();
			},
			done : function(id,e,data)
			{
				loading.stop();
				checkProceed.check();

				this.obj.parent().children('div').remove();
				var div = $('<div></div>');
				this.obj.parent().append(div);
				let query = this.obj.val();
				var localThis = this;
				if (data.data){
					$.each(data.data, function( index, value ) {

						let offset = 0
						let displayValue = '';
						value.split(new RegExp(query, 'i')).forEach(substring => {
							let matchOffset = offset + substring.length
							offset = matchOffset + query.length

							displayValue+=substring;
							displayValue+='<span>' + value.substring(matchOffset, offset)+ '</span>';

						})

						var content = $('<a data-value="' + index + '" href="#" data-display="' + value + '">' + displayValue + '</a>');
						content.click(localThis.selector);
						div.append(content);
					});
				}
			}
		};

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var categorySearch = (function()
	{
		const prototype = {

			init : function()
			{
				this.settings = $.extend({

					id            : null, // record id

				}, this.options());

				this.search();
			},
			options : function()
			{
				return {

					id            : this.obj.data('id'),         // record id
				};
			},
			search : function()
			{
				ajaxRequest(
					'/selector/gbp-categories/' + this.settings.id,
					{
						search : this.obj.val()
					},
					this.done.bind(this,this.settings.id,this.obj),
					'search'
				);
			},
			selector : function()
			{
				// Get content
				var gcid = $(this).data('value');
				var name = $(this).data('display');

				// Get inputs
				var div = $(this).parent();
				var input = div.parent().children('input');

				var id = input.data('id');
				// Post
				ajaxRequest(
					'/gbp/add-category/' + id,
					{
						content : gcid
					}
				);

				loading.stop();

				// Add row
				var svg = '<svg viewBox="0 0 20 20" class="icon icon-cross">'
									+ '<polygon points="15.606,0 10,5.606 4.394,0 0,4.394 5.606,10 0,15.606 4.394,20 10,14.394 15.606,20 20,15.606 14.394,10 20,4.394 "/>'
								+ '</svg>';

				var row = '<div class="row gbp_category_row" data-id="' + id + '" data-gcid="' + gcid + '" data-name="' + name + '">'
									+ '<div class="name">' + name + '</div>'
									+ '<div class="delete">' + svg + '</div>'
								+ '</div>'

				let element = $('#gbp-categories');
				element.append(row);

				$('#gbp-categories-norow').data().count ++;
				$('#gbp-categories-norow').addClass('hidden');

				// Remove dropdown
				div.remove();

				// Reset input
				input.val('');
			},
			done : function(id,e,data)
			{
				loading.stop();
				checkProceed.check();

				this.obj.parent().children('div').remove();
				var div = $('<div></div>');
				this.obj.parent().append(div);
				let query = this.obj.val();
				var localThis = this;
				if (data.data){
					$.each(data.data, function( index, value ) {

						let offset = 0
						let displayValue = '';
						value.split(new RegExp(query, 'i')).forEach(substring => {
							let matchOffset = offset + substring.length
							offset = matchOffset + query.length

							displayValue+=substring;
							displayValue+='<span>' + value.substring(matchOffset, offset)+ '</span>';

						})

						var content = $('<a data-value="' + index + '" href="#" data-display="' + value + '">' + displayValue + '</a>');
						content.click(localThis.selector);
						div.append(content);
					});
				}
			}
		};

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var autofill = function(box, str)
	{
		var letter = str.substr(0,1);
		str = str.substr(1);

		box.val(box.val() + letter);

		if (str.length)
		{
			window.setTimeout(function()
			{
				autofill(box, str);
			}
			.bind(this), 30);
		}
		else
		{
			box.trigger('change');
		}
	};

	var textboxReveal = function()
	{
		var textboxes = $('.textbox, .textarea-auto');
		textboxes.each(function(i, obj)
		{
			var textbox = $(obj);
			var item = textbox.parent();
			var edit = item.find('.edit');
			var specify = item.find('.specify');

			specify.click(function()
			{
				specify.next('.error-message').remove();
				item.addClass('active');
				textbox.focus();
			});

			edit.click(function(e)
			{
				e.stopPropagation();
				item.addClass('active');
				textbox.focus();
			});

			textbox.blur(function()
			{
				if (textbox.val().trim() == '')
				{
					textbox.val('');
					item.addClass('empty');
				}
				else
				{
					item.removeClass('empty');
				}

				item.removeClass('active');
				checkProceed.check();
			}
			.bind(this));

			textbox.keyup(function()
			{
				checkProceed.check();
			}
			.bind(this));

			textbox.focus(function()
			{
				item.addClass('active');
			}
			.bind(this));
		});
	}

	function siteElements()
	{
		$('.site-elements input[type="checkbox"]').each(function(i, obj)
		{
			var checkbox = $(obj);
			var element = checkbox.closest('.element');
			var label = element.find('.label');
			var textarea = element.find('textarea');

			label.click(function()
			{
				checkbox.prop('checked', !checkbox.is(':checked')).trigger('change');
			});

			checkbox.change(function()
			{
				if (checkbox.is(':checked'))
				{
					element.addClass('checked');
					if (textarea.length) {
						autosize.update(textarea)
					}
				}
				else
				{
					element.removeClass('checked');
				}

				checkProceed.check();
			});
		});

		var header_required = $('.js-required-header');
		var header_elements = $('.site-elements input[id^="header_"]');
		var header_none = $('input#header_none');

		var checkHeaderIsValid = function()
		{
			var valid = false;
			header_required.next('.error-message').remove();

			if (header_none.is(':checked'))
			{
				valid = true;
			}

			header_elements.each(function(i, obj)
			{
				if ($(obj).is(':checked')) {
					valid = true;
				}
			});

			header_required.data('required', !valid);
		}

		header_elements.change(function()
		{
			if ($(this).is(':checked'))
			{
				scroll.difference(header_none, function()
				{
					header_none.prop('checked', false).trigger('change');
				});
			}
			else
			{
				checkHeaderIsValid();
			}
		});

		header_none.change(function()
		{
			if (header_none.is(':checked'))
			{
				scroll.difference(header_none, function()
				{
					header_elements.prop('checked', false).trigger('change');
				});

				header_none.closest('.none-of-above').prev().find('.site-elements').addClass('checked');
			}
			else
			{
				header_none.closest('.none-of-above').prev().find('.site-elements').removeClass('checked');
			}

			checkHeaderIsValid();
			checkProceed.check();
		});

		var footer_required = $('.js-required-footer');
		var footer_elements = $('.site-elements input[id^="footer_"]');
		var footer_none = $('input#footer_none');

		var checkFooterIsValid = function()
		{
			var valid = false;
			footer_required.next('.error-message').remove();

			if (footer_none.is(':checked'))
			{
				valid = true;
			}

			footer_elements.each(function(i, obj)
			{
				if ($(obj).is(':checked'))
				{
					valid = true;
				}
			});

			footer_required.data('required', !valid);
		}

		footer_elements.change(function()
		{
			if ($(this).is(':checked'))
			{
				scroll.difference(footer_none, function()
				{
					footer_none.prop('checked', false).trigger('change');
				});
			}
			else
			{
				checkFooterIsValid();
			}
		});

		footer_none.change(function()
		{
			if (footer_none.is(':checked'))
			{
				scroll.difference(footer_none, function()
				{
					footer_elements.prop('checked', false).trigger('change');
				});

				footer_none.closest('.none-of-above').prev().find('.site-elements').addClass('checked');
			}
			else
			{
				footer_none.closest('.none-of-above').prev().find('.site-elements').removeClass('checked');
			}

			checkFooterIsValid();
			checkProceed.check();
		});
	}

	var triggerLink = (function() {

		const prototype = {

			init : function()
			{
				if (!this.obj.hasClass('btn-disabled'))
				{
					$('.' + this.obj.data('trigger-link')).trigger('click');
				}
				else
				{
					checkRequired();
				}
			}

		};

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var triggerAiGeneration = (function() {
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function()
			{
				var content = $('<div class="generating-content">');
				var text = $('<p class="text">This may take a few seconds...<br><span id="ai-timer" data-count="20">20</span></p>');
				var bot = $('<div class="ai-bot">');

				content.append(bot,text);

				var footer = $('<div class="footer">');
				this.show('compact', 'Your content is being generated', false, false, content, footer, this.handleGeneration.bind(this), 600);


				this.obj.addClass('btn-disabled')
				ajaxRequest(
					'/update/generate-content/' + this.obj.data('id'),
					{},
					this.handleGeneration.bind(this),
					'edit the file'
				);

				var timer = $( "#ai-timer" )
				var count = timer.data('count');
				setInterval(function() {
					if(count == 1){
						timer.html('it seems to be taking longer than usual');
					}else{
						count = count -1;
						timer.html(count);
						timer.data('count',count);
					}
				}, 1000);
			},
			handleGeneration : function(data)
			{
				window.location.href = "/content/submit/" + this.obj.data('id');
			}
		});

		return function(obj){
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var triggerAiRestart = (function() {
		const prototype = {

			init : function(){
				if (!this.obj.hasClass('btn-disabled')){
					this.obj.addClass('btn-disabled')
					ajaxRequest(
						'/update/restart-content/' + this.obj.data('id'),
						{},
						this.handleRestartContent.bind(this),
						'edit the file'
					);
				}
			},
			handleRestartContent : function(data)
			{
				window.location.href = "/content/submit/" + this.obj.data('id');
			}

		};

		return function(obj){
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var triggerAiUse = (function() {
		const prototype = {

			init : function(){
				if (!this.obj.hasClass('btn-disabled')){
					this.obj.addClass('btn-disabled')
					ajaxRequest(
						'/update/use-content/' + this.obj.data('id'),
						{},
						this.handleUseContent.bind(this),
						'edit the file'
					);
				}
			},
			handleUseContent : function(data)
			{
				window.location.href = "/content/submit/" + this.obj.data('id');
			}

		};

		return function(obj){
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var elements = {

		website : $('.header-bar .website'),
		content : $('.content-area'),
		sideBar : $('.side-bar'),
		menu : $('.side-bar .menu'),
		iconBar : $('.icon-bar .links'),
		slides : $('.slides-area')

	};

	var attributes = {

		original : {},
		changed : {},

		clear : function()
		{
			this.original = {};
			this.changed = {};
		},

		set : function()
		{
			this.clear();

			$('[data-save-attribute]').each(function(i, obj)
			{
				var obj = $(obj);
				this.original[obj.attr('name')] = this.create(obj);

				obj.change(function()
				{
					var info = this.create(obj);
					info.name = obj.attr('name');

					attributes.add(info);
				}
				.bind(this));
			}
			.bind(this));
		},
		create : function(obj)
		{
			return {

				id : obj.data('save-attribute'),
				collection : obj.data('collection'),
				content : obj.is('[type="checkbox"]')
				? (obj.is(':checked') ? 1 : 0)
				: obj.val()

			}
		},
		add : function(attribute) {

			if (this.original[attribute.name].content !== attribute.content)
			{
				this.changed[attribute.name] = {

					id : attribute.id,
					collection : attribute.collection,
					content : attribute.content

				};
			}
			else
			{
				delete this.changed[attribute.name];
			}
		},
		updated : function()
		{
			return $.isEmptyObject(this.changed);
		}
	};

	function updateProgress()
	{
		var barRadial = $('.side-bar .radial-progress .bar');
		var barLinear = $('.side-bar .linear-progress .bar');
		var label     = $('.side-bar .radial-progress .label, .side-bar .linear-progress .label');

		if (!label.length) return;

		var percent = progressPercent;

		barRadial.css('stroke-dashoffset', 219.91 - 156.38 * percent / 100);
		barLinear.css('width', percent + '%');

		var current = parseInt(label.text());
		var diff = percent - current;
		var step = diff / 40;

		for (var i = 0; i < 40; ++i)
		{
			setTimeout(function()
			{
				current += step
				label.html(Math.round(current) + '%');
			}, 25 * i)
		}
	}

	function progressBars()
	{
		var bars = $('.radial-progress[data-progress]');
		bars.each(function()
		{
			radialProgress($(this));
		});
	}

	var radialProgress = (function()
	{
		const prototype = {

			init : function()
			{
				var percent = this.obj.data('progress');

				var bar = this.obj.find('.bar');
				this.label = this.obj.find('.label');

				setTimeout(function()
				{
					bar.css('stroke-dashoffset', 219.91 - 156.38 * percent / 100);
				}, 20)

				this.current = parseInt(this.label.text());
				var diff = percent - this.current;
				this.step = diff / 40;

				for (var i = 0; i < 40; ++i)
				{
					setTimeout(function()
					{
						this.current += this.step
						this.label.html(Math.round(this.current) + '%');
					}
					.bind(this), 25 * i)
				}
			}

		};

		return function(obj)
		{
			var instance = Object.create(prototype);

			instance.obj = obj;
			instance.init();

			return instance;
		};
	})();

	var collections = {

		init : function()
		{
			this.faders();
		},
		faders : function()
		{
			var faderCollections = $('.fader-collection');
			faderCollections.each(function(i, element) {
				this.faderStart($(element).children(), 0);
			}.bind(this));
		},
		faderStart : function(items, i)
		{
			window.setTimeout(function()
			{
				items.eq(i).animate({ opacity : 0}, speed * 2, function()
				{
					items.eq(i).css('display', 'none');

					if (++i >= items.length)
					{
						i = 0;
					}

					items.eq(i).css('display', 'block').animate({ opacity : 1}, speed * 2, function()
					{
						this.faderStart(items, i);
					}
					.bind(this));
				}
				.bind(this));
			}
			.bind(this), 4000);
		}

	}

	var navBuilder = {

		init : function()
		{
			this.builder = $('.nav-builder');
			if (this.builder.length)
			{
				this.showHandles();

				this.remaining = $('.nav-builder .remaining');
				this.pagesRemaining = parseInt(this.remaining.data('remaining'));
				this.no_more_required = $('.nav-builder input[name="no_more_required"]');
				this.proceed = $('.submit-your-content .btn');
				this.add = $('.nav-builder .add-page');
				this.add_blank = $('.nav-builder .add-blank');
				this.add_menu = $('.nav-builder .add-menu');

				var addLink = this.add.children('a');
				addLink.on('click', function()
				{
					if (!this.add.hasClass('disabled'))
					{
						this.add.addClass('disabled hidden');
						this.add_blank.addClass('disabled hidden');
						this.add_menu.addClass('disabled hidden');
						this.addPage(1);
					}
				}
				.bind(this));

				var addBlogLink = $('.nav-builder .add-blog-page');
				addBlogLink.on('click', function()
				{
					if (!this.add_blank.hasClass('disabled'))
					{
						this.add.addClass('disabled hidden');
						this.add_blank.addClass('disabled hidden');
						this.add_menu.addClass('disabled hidden');
						this.addPage(2);
					}
				}
				.bind(this));

				var addBlankLink = $('.nav-builder .add-blank-page');
				addBlankLink.on('click', function()
				{
					if (!this.add_blank.hasClass('disabled'))
					{
						this.add.addClass('disabled hidden');
						this.add_blank.addClass('disabled hidden');
						this.add_menu.addClass('disabled hidden');
						this.addPage(3);
					}
				}
				.bind(this));

				var addMenuHeadingLink = $('.nav-builder .add-menu-heading');
				addMenuHeadingLink.on('click', function()
				{
					if (!this.add_blank.hasClass('disabled'))
					{
						this.add.addClass('disabled hidden');
						this.add_blank.addClass('disabled hidden');
						this.add_menu.addClass('disabled hidden');
						this.addPage(4);
					}
				}
				.bind(this));

				var addMenuLink = $('.nav-builder .add-menu-link');
				addMenuLink.on('click', function()
				{
					if (!this.add_blank.hasClass('disabled'))
					{
						this.add.addClass('disabled hidden');
						this.add_blank.addClass('disabled hidden');
						this.add_menu.addClass('disabled hidden');
						this.addPage(5);
					}
				}
				.bind(this));

				this.editPages();
				this.deletePages();

				this.no_more_required.on('change', this.pagesRequired.bind(this));

				this.checkProceed();
				this.demo();
			}
		},
		pagesRequired : function()
		{
			ajaxRequest(
				this.builder.data('pages-required'),
				{
					required : this.no_more_required.is(':checked') ? 1 : 0
				},
				this.addResponse.bind(this),
				'save your changes'
			);
		},
		checkProceed : function()
		{
			if (this.no_more_required.is(':checked') || this.pagesRemaining < 1)
			{
				return this.proceed.removeClass('btn-disabled');
			}

			this.proceed.addClass('btn-disabled');
		},
		showHandles : function()
		{
			this.home = parseInt(this.builder.data('home'));
			this.pages = this.builder.find('.target-area .page');

			if (this.pages.length > 1) {

				this.initPages();

				this.handles = this.builder.find('.handle');
				this.handles.css('display', 'block');

				this.handles.each(function(index, element)
				{
					var handle = $(element);

					handle.on('mousedown', function(e)
					{
						if (handle.hasClass('disabled'))
						{
							return;
						}

						this.page = handle.parent();
						this.insertHelper();

						var id = this.page.data('id');
						var start = e.pageY;
						var current = start;

						if (this.page.data('isLastSubItem'))
						{
							this.page.data('isLastSubItem', 0);

							var prev = this.page.prev();
							prev.data('isLastSubItem', 1);

							if (prev.hasClass('ssp'))
							{
								prev.attr('data-isLastSubChild', 1).data('isLastSubChild', 1);
							}
						}

						body.on('mousemove.navBuilder', function(e)
						{
							var position = this.offset.top - start + e.pageY;
							var positions = {};

							this.helper.css('top', position + 'px');

							$('.target-area .page').each(function(i, element)
							{
								var page = $(element);
								if (page.data('id') !== id)
								{
									positions[i] = {

										id : page.data('id'),
										top :page.offset().top,
										position : parseInt(page.data('position')),
										group : parseInt(page.data('group')),
										parent : parseInt(page.data('parent')),
										topParent : parseInt(page.data('topParent')),
										isParent : parseInt(page.data('isParent')),
										isSubParent : parseInt(page.data('isSubParent')),
										isSubPage : page.hasClass('sp'),
										isSubSubPage : page.hasClass('ssp'),
										isTarget : page.hasClass('target'),
										isLastItem : parseInt(page.data('isLastItem')),
										isLastSubItem : parseInt(page.data('isLastSubItem')),
										isLastChild : parseInt(page.data('isLastChild')),
										isLastSubChild : parseInt(page.data('isLastSubChild')),
										isLastSubSubChild : parseInt(page.data('isLastSubSubChild'))

									};
								}
							});

							if (e.pageY < current)
							{
								$.each(positions, function(i, page)
								{
									if (position - 64 <= page.top && position - 10 > page.top)
									{
										if (!this.home)
										{
											this.insertAfter(page);
										}
										else if (this.page.data('isTopParent'))
										{
											if (page.isLastSubChild)
											{
												this.insertAfter(page);
											}
										}
										else if (this.page.data('isParent') || this.page.data('isSubParent'))
										{
											if (!page.isSubParent)
											{
												if (page.isSubSubPage)
												{
													if (page.isLastSubSubChild)
													{
														this.insertAfter(page);
														if (position - 32 <= page.top)
														{
															this.makeSubPage();
														}
														else
														{
															if(page.isLastSubSubChild && page.isLastSubChild)
															{
																this.makeTopLevel();
															}
															else
															{
																this.makeSubPage();
															}
														}
													}
												}
												else if (page.isSubPage)
												{
													this.insertAfter(page);
													if (position - 32 <= page.top)
													{
														this.makeSubPage();
													}
													else
													{
														if(page.isLastSubItem)
														{
															this.makeTopLevel();
														}
														else
														{
															this.makeSubPage();
														}
													}
												}
												else
												{
													this.insertAfter(page);

													if (position - 32 <= page.top)
													{
														this.makeSubPage();
													}
													else
													{
														if (page.isParent)
														{
															this.makeSubPage();
														}
														else
														{
															this.makeTopLevel();
														}
													}
												}
											}
										}
										else
										{
											this.insertAfter(page);
											if (page.isSubSubPage)
											{
												if (position - 32 <= page.top)
												{
													this.makeSubSubPage();
												}
												else if (position - 48 <= page.top)
												{
													if (this.page.next().hasClass('ssp') || this.page.data('parent') == page.parent)
													{
														this.makeSubSubPage();
													}
													else
													{
														this.makeSubPage();
													}
												}
												else if (position - 64 <= page.top)
												{
													if (this.page.next().hasClass('ssp') || this.page.data('parent') == page.parent)
													{
														this.makeSubSubPage();
													}
													else if (this.page.data('parent') == page.topParent || this.page.next().hasClass('sp'))
													{
														this.makeSubPage();
													}
													else
													{
														this.makeTopLevel();
													}
												}
											}
											else if (page.isSubPage)
											{
												if (position - 32 <= page.top)
												{
													this.makeSubSubPage();
												}
												else if (position - 48 <= page.top)
												{
													if (this.page.next().hasClass('ssp') || this.page.data('parent') == page.position)
													{
														this.makeSubSubPage();
													}
													else
													{
														this.makeSubPage();
													}
												}
												else if (position - 64 <= page.top)
												{
													if (this.page.next().hasClass('ssp') || this.page.data('parent') == page.position)
													{
														this.makeSubSubPage();
													}
													else if (this.page.next().hasClass('sp') || this.page.data('parent') == page.parent)
													{
														this.makeSubPage();
													}
													else
													{
														this.makeTopLevel();
													}
												}
											}
											else
											{
												if (position - 32 <= page.top)
												{
													this.makeSubPage();
												}
												else if (position - 64 <= page.top)
												{
													if (this.page.next().hasClass('sp') || this.page.data('parent') == page.position)
													{
														this.makeSubPage();
													}
													else
													{
														this.makeTopLevel();
													}
												}
											}
										}
									}
									else if (i == 0 && position - 10 <= page.top)
									{
										this.insertBefore(page);
										this.makeTopLevel();
									}
								}
								.bind(this));
							}
							else if (e.pageY > current)
							{
								$.each(positions, function(i, page)
								{
									var margin = 0;
									if (this.page.data('isTopParent') || (this.page.data('isParent') || this.page.data('isSubParent')))
									{
										margin = ($('.target-area .target').length - 1) * 54;
									}

									if (position + 32 + margin >= page.top && position - (6 + 16 + 6 + 48 + margin) < page.top)
									{
										if (!this.home) {
											this.insertAfter(page);
										}
										else if (this.page.data('isTopParent'))
										{
											if (page.isLastSubChild || page.isLastItem)
											{
												this.insertAfter(page);
											}
										}
										else if (this.page.data('isParent') || this.page.data('isSubParent'))
										{
											if (!page.isTarget)
											{
												if (!page.isSubParent)
												{
													if (page.isSubSubPage)
													{
														if (page.isLastSubSubChild)
														{
															this.insertAfter(page);
															if (position - 38 >= page.top)
															{
																if (page.isLastSubChild)
																{
																	this.makeTopLevel();
																}
																else
																{
																	this.makeSubPage();
																}
															}
															else
															{
																this.makeSubPage();
															}
														}
													}
													else if (page.isSubPage)
													{
														this.insertAfter(page);
														if (position - 38 >= page.top)
														{
															if (page.isLastSubItem)
															{
																this.makeTopLevel();
															}
															else
															{
																this.makeSubPage();
															}
														}
														else
														{
															this.makeSubPage();
														}
													}
													else
													{
														this.insertAfter(page);
														if (position - 38 >= page.top)
														{
															if (page.isParent)
															{
																if (page.group == this.page.data('group') && parseInt(this.page.attr('data-isLastSubItem')))
																{
																	this.makeTopLevel();
																	$('.target-area .page[data-id='+page.id+']').attr('data-isParent', 0).data('isParent', 0);
																}
																else
																{
																	this.makeSubPage();
																}
															}
															else
															{
																this.makeTopLevel();
															}
														}
														else
														{
															this.makeSubPage();
														}
													}
												}
											}
										}
										else
										{
											this.insertAfter(page);
											if (page.isSubSubPage)
											{
												if (position - 48 >= page.top && !this.page.next().hasClass('sp') && !this.page.next().hasClass('ssp'))
												{
													this.makeTopLevel();
												}
												else if (position - 38 >= page.top && !this.page.next().hasClass('ssp'))
												{
													this.makeSubPage();
												}
												else
												{
													this.makeSubSubPage();
												}
											}
											else if (page.isSubPage)
											{
												if (position - 48 >= page.top && !this.page.next().hasClass('sp') && !this.page.next().hasClass('ssp'))
												{
													this.makeTopLevel();
												}
												else if (position - 38 >= page.top && !this.page.next().hasClass('ssp'))
												{
													this.makeSubPage();
												}
												else
												{
													this.makeSubSubPage();
												}
											}
											else
											{
												if (position - 38 >= page.top && !this.page.next().hasClass('sp'))
												{
													this.makeTopLevel();
												}
												else
												{
													this.makeSubPage();
												}
											}
										}
									}
								}.bind(this));
							}

							current = e.pageY;
						}
						.bind(this));

						body.on('mouseup.navBuilder', function(e) { this.dropPage(); }.bind(this));
						body.on('mouseleave.navBuilder', function(e) { this.dropPage(); }.bind(this));
					}
					.bind(this));
				}
				.bind(this));
			}
		},
		insertHelper : function()
		{
			this.helper = $('<div class="nav-builder helper">');
			var clone = this.page.clone();
			this.children = false;

			if (parseInt(this.page.data('isSubParent')))
			{
				this.children = this.page.nextUntil(':not(.ssp)');
			}
			else if (parseInt(this.page.data('isParent')))
			{
				this.children = this.page.nextUntil(':not(.sp):not(.ssp)');
			}

			this.offset = this.page.offset();
			this.helper.css({ position : 'absolute', left : this.offset.left+'px', top : this.offset.top+'px', zIndex : 60, width : this.page.outerWidth()+'px' });

			this.helper.append(clone);
			body.prepend(this.helper);

			this.page.addClass('target');
			if (this.children !== false)
			{
				this.children.addClass('target');
			}
		},
		initPages : function()
		{
			var pages = $('.target-area .page');
			var parentId;
			var subParentId;
			var group = 0;
			var lastSubItem;

			this.positions = [];

			pages.each(function(i, element)
			{
				var page = $(element);

				page.attr('data-isParent', 0).data('isParent', 0);
				page.attr('data-isSubParent', 0).data('isSubParent', 0);
				page.attr('data-isTopParent', 0).data('isTopParent', 0);
				page.attr('data-topParent', 0).data('topParent', 0);
				page.attr('data-isLastChild', 0).data('isLastChild', 0);
				page.attr('data-isLastSubChild', 0).data('isLastSubChild', 0);
				page.attr('data-isLastSubSubChild', 0).data('isLastSubSubChild', 0);
				page.attr('data-isLastItem', 0).data('isLastItem', 0);
				page.attr('data-isLastSubItem', 0).data('isLastSubItem', 0);

				if (!page.hasClass('ssp'))
				{
					var prev = pages.eq(i).prev();
					if (prev.length && prev.hasClass('ssp'))
					{
						prev.attr('data-isLastSubSubChild', 1).data('isLastSubSubChild', 1);
					}
				}

				if (page.hasClass('ssp'))
				{
					page.attr('data-group', group).data('group', group);
					page.attr('data-parent', subParentId).data('parent', subParentId);
					page.attr('data-topParent', parentId).data('topParent', parentId);

					pages.eq(subParentId).attr('data-isSubParent', 1).data('isSubParent', 1);
					pages.eq(subParentId).attr('data-isParent', 1).data('isParent', 1);
					pages.eq(parentId).attr('data-isTopParent', 1).data('isTopParent', 1);
				}
				else if (page.hasClass('sp'))
				{
					subParentId = i;
					lastSubItem = i;

					page.attr('data-group', group).data('group', group);
					page.attr('data-parent', parentId).data('parent', parentId);
					pages.eq(parentId).attr('data-isParent', 1).data('isParent', 1);

					var next = pages.eq(i).next();
					if (!next.hasClass('sp') && !next.hasClass('ssp'))
					{
						page.attr('data-isLastChild', 1).data('isLastChild', 1);
					}
				}
				else
				{
					parentId = i;

					page.attr('data-group', ++group).data('group', group);
					page.attr('data-parent', -1).data('parent', -1);
					pages.eq(lastSubItem).attr('data-isLastSubItem', 1).data('isLastSubItem', 1);
					pages.eq(i).prev().attr('data-isLastSubChild', 1).data('isLastSubChild', 1);

					if (i + 1 == pages.length)
					{
						pages.eq(i).attr('data-isLastSubChild', 1).data('isLastSubChild', 1);
					}
				}

				if (i + 1 == pages.length)
				{
					page.attr('data-isLastItem', 1).data('isLastItem', 1);
					pages.eq(lastSubItem).attr('data-isLastSubItem', 1).data('isLastSubItem', 1);
				}

				page.attr('data-position', i).data('position', i);
				this.positions.push({ id : page.attr('data-id'), parent : page.attr('data-parent')});
			}
			.bind(this));
		},
		dropPage : function()
		{
			this.demoNav.css('opacity', 0);

			body.off('mouseup.navBuilder');
			body.off('mousemove.navBuilder');
			body.off('mouseleave.navBuilder');

			this.initPages();

			this.helper.remove();
			this.page.removeClass('target');

			if (this.children !== false)
			{
				this.children.removeClass('target');
			}

			ajaxRequest(
				this.builder.data('sort-positions'),
				{
					positions : JSON.stringify(this.positions)
				},
				this.addResponse.bind(this),
				'save your changes'
			);
		},
		insertBefore : function(page)
		{
			$('.target-area .page[data-id='+page.id+']').before(this.page);
			if (this.children !== false)
			{
				this.page.after(this.children);
			}
		},
		insertAfter : function(page)
		{
			$('.target-area .page[data-id='+page.id+']').after(this.page);
			if (this.children !== false)
			{
				this.page.after(this.children);
			}
		},
		makeTopLevel : function()
		{
			this.page.removeClass('sp');
			this.page.removeClass('ssp');
			this.updateParent();

			if (this.children !== false && !this.page.data('isTopParent'))
			{
				this.children.each(function(i, element)
				{
					var child = $(element);
					if(child.hasClass('ssp'))
					{
						child.toggleClass('sp ssp');
					}
				});
			}
		},
		makeSubPage : function()
		{
			this.page.addClass('sp');
			this.page.removeClass('ssp');
			this.updateParent();

			if (this.children !== false)
			{
				this.children.each(function(i, element)
				{
					var child = $(element);
					if(child.hasClass('sp'))
					{
						child.toggleClass('sp ssp');
					}
				});
			}
		},
		makeSubSubPage : function()
		{
			this.page.addClass('ssp');
			this.page.removeClass('sp');
			this.updateParent();
		},
		updateParent : function()
		{
			if (this.page.hasClass('ssp'))
			{
				this.page.data('parent', this.page.prevAll('.sp').first().data('position'));
			}
			else if (this.page.hasClass('sp'))
			{
				this.page.data('parent', this.page.prevAll(':not(.sp):not(.ssp)').first().data('position'));
			}
			else
			{
				this.page.data('parent', '-1');
			}
		},
		addPage : function(content_status)
		{
			var content_status_class = '';
			var value = '';
			var btn_disabled = 'btn-disabled';
			switch(content_status){
				case 2 :
					content_status_class = 'blog-page';
					value = 'Blog';
					btn_disabled = '';
					break;
				case 3 :
					content_status_class = 'blank-page';
					break;
				case 4 :
					content_status_class = 'menu-heading';
					break;
				case 5 :
					content_status_class = 'menu-link';
					break;
			}

			this.createPage = $('<div class="create-page ' + content_status_class + '">');
			this.createName = $('<input type="text" name="name" placeholder="Name" value="' + value + '">');
			this.createGroupUnder = $('<div class="group-under"><div class="shadow"></div><label>Group under...</label></div>');
			this.createGroup = $('<select><option value="0">None</option></select>');
			this.createSave = $('<div class="btn btn-green ' + btn_disabled + '" data-non-content="' + content_status + '"><svg focusable="false" role="presentation" viewBox="0 0 19 19" class="icon icon-tick"><path d="M0.331,11.117l6.829,6.072L18.67,4.344l-2.838-2.533L6.824,11.886 L2.816,8.337L0.331,11.117z"></path></svg></div>');
			this.createCancel = $('<div class="delete"><svg viewBox="0 0 20 20" class="icon icon-cross"><polygon points="15.606,0 10,5.606 4.394,0 0,4.394 5.606,10 0,15.606 4.394,20 10,14.394 15.606,20 20,15.606 14.394,10 20,4.394 "/></svg></div>');

			this.createName.on('keyup', function(e)
			{
				if (this.createName.val().match(/^\s*$/))
				{
					this.createSave.addClass('btn-disabled');
				}
				else
				{
					this.createSave.removeClass('btn-disabled');

					var keycode = (e.keyCode ? e.keyCode : e.which);
					if(keycode == '13')
					{
						this.createName.blur();
						this.createSave.click();
					}
				}
			}
			.bind(this));

			if (this.home && this.pages.length)
			{
				this.createGroupUnder.append(this.createGroup);

				this.pages.each(function(i, element)
				{
					var page = $(element);

					if (!page.hasClass('ssp') && (content_status == 1 || page.data('content-status') != 2 ) )
					{
						var option = $('<option>');
						option.attr('value', page.data('id')).text(page.children('.name').text().trim());

						this.createGroup.append(option);
					}
				}
				.bind(this));

				this.createGroup.change(function()
				{
					this.createGroupUnder.addClass('selected');
				}
				.bind(this));
			}
			else
			{
				this.createGroupUnder.css('display', 'none');
			}

			this.createSave.click(function()
			{
				if (!this.createSave.hasClass('btn-disabled'))
				{
					this.demoNav.css('opacity', 0);
					this.createSave.css('padding', '7px 19px').html('Saving');

					if (this.pagesRemaining > 1)
					{
						this.createPage.addClass('saving');
					}

					this.add.removeClass('disabled');
					this.add_blank.removeClass('disabled');
					this.add_menu.removeClass('disabled');
					this.no_more_required.closest('.no-more-required ').addClass('disabled');
					this.enableElements();

					ajaxRequest(
						this.builder.data('add-page'),
						{
							name   : this.createName.val(),
							parent : this.createGroup.val(),
							content : this.createSave.data('non-content')
						},
						this.addResponse.bind(this),
						'add the page'
					);
				}
			}
			.bind(this));

			this.createCancel.click(function()
			{
				this.createPage.remove();
				this.add.removeClass('hidden');
				this.add.removeClass('disabled');
				this.add_blank.removeClass('hidden');
				this.add_blank.removeClass('disabled');
				this.add_menu.removeClass('hidden');
				this.add_menu.removeClass('disabled');
				this.enableElements();
				checkProceed.check();
			}
			.bind(this));

			this.createPage.append(this.createName, this.createGroupUnder, this.createSave, this.createCancel);

			this.disableElements();

			this.add.before(this.createPage);
			var val = this.createName.val();
			this.createName.focus().val('').val(val); // Focus at end of val not begining
			checkProceed.check();
		},
		addResponse : function(data)
		{
			if (data.error)
			{
				this.errorModal(data.message);
			}
			if (data.progress)
			{
				progress = data.progress;
			}

			if ('progressPercent' in data)
			{
				progressPercent = data.progressPercent;
				updateProgress();
			}

			if (data.menu)
			{
				$('.navigation-menu').html(data.menu);
			}

			if (data.url)
			{
				$('.icon-bar .links .section-icon-content').attr('href', data.url);
			}

			if (data.content)
			{
				elements.content.html(data.content);
				checkProceed.check();
			}

			if (data.slides)
			{
				elements.slides.html(data.slides);
			}

			if (data.content || data.slides)
			{
				loading.stop();
				page.refresh();
			}
		},
		errorModal : function(message)
		{
			// The Error modal shows if a valid
			this.modal = Object.create(modal);

			var content = $('<div class="edit-image">');
			var container = $('<div class="container">');
			var intro = $('<p class="text-center">' + message + '</p>');

			content.append(container);
			container.append(intro);

			var footer = $('<div class="footer">');
			var refresh = $('<a class="btn btn-green">Refresh Page</a>');

			refresh.on('click', this.refreshPage.bind(this));

			footer.append(refresh);

			this.modal.show('compact', 'Navigation Error', false, false, content, footer, this.refreshPage.bind(this));

			loading.stop();
		},
		refreshPage : function()
		{
			// Trigger Full refresh (without post, there shouldn't be any anyway)
			window.location.href = window.location.href;
		},
		editPages : function()
		{
			this.pages.each(function(i, element)
			{
				var page = $(element);
				var edit = page.children('.edit');

				var content_status = page.data('content-status');

				var content_status_class = '';
				switch(content_status){
					case 2 :
						content_status_class = 'blog-page';
						break;
					case 3 :
						content_status_class = 'blank-page';
						break;
					case 4 :
						content_status_class = 'menu-heading';
						break;
					case 5 :
						content_status_class = 'menu-link';
						break;
				}

				edit.on('click', function()
				{
					if (!edit.hasClass('disabled'))
					{
						this.editPage = $('<div class="create-page edit-page ' + content_status_class + '">');
						this.editName = $('<input type="text" name="name" placeholder="Name">');
						this.editGroupUnder = $('<div class="group-under"><div class="shadow"></div><label>Group under...</label></div>');
						this.editGroup = $('<select><option value="0">None</option></select>');
						this.editSave = $('<div class="btn btn-green" data-non-content="' + content_status + '"><svg focusable="false" role="presentation" viewBox="0 0 19 19" class="icon icon-tick"><path d="M0.331,11.117l6.829,6.072L18.67,4.344l-2.838-2.533L6.824,11.886 L2.816,8.337L0.331,11.117z"></path></svg></div>');
						this.editCancel = $('<div class="delete"><svg viewBox="0 0 20 20" class="icon icon-cross"><polygon points="15.606,0 10,5.606 4.394,0 0,4.394 5.606,10 0,15.606 4.394,20 10,14.394 15.606,20 20,15.606 14.394,10 20,4.394 "/></svg></div>');

						this.editName.val(page.children('.name').text().trim());
						this.editName.on('keyup', function(e)
						{
							if (this.editName.val().match(/^\s*$/))
							{
								this.editSave.addClass('btn-disabled');
							}
							else
							{
								this.editSave.removeClass('btn-disabled');
								var keycode = (e.keyCode ? e.keyCode : e.which);

								if(keycode == '13')
								{
									this.editName.blur();
									this.editSave.click();
								}
							}
						}
						.bind(this));

						if (this.home && this.pages.length)
						{
							this.editGroupUnder.append(this.editGroup);

							if (page.data('isTopParent') == 1)
							{
								this.editGroupUnder.css('display', 'none')
							}

							this.pages.each(function(i, element)
							{
								var item = $(element);
								if (!item.hasClass('ssp') && page.data('id') != item.data('id') && (content_status == 1 || item.data('content-status') != 2 ) )
								{
									if (page.data('isParent') == 1 && item.hasClass('sp'))
									{
										return;
									}

									var option = $('<option>');
									option.attr('value', item.data('id')).text(item.children('.name').text().trim());

									this.editGroup.append(option);
								}
							}
							.bind(this));

							if (page.hasClass('sp') || page.hasClass('ssp'))
							{
								this.editGroup.val($('.target-area .page[data-position="'+page.data('parent')+'"').data('id'));
								this.editGroupUnder.addClass('selected');
							}

							this.editGroup.change(function()
							{
								this.editGroupUnder.addClass('selected');
							}
							.bind(this));
						}
						else
						{
							this.editGroupUnder.css('display', 'none');
						}

						this.editSave.click(function()
						{
							if (!this.editSave.hasClass('btn-disabled'))
							{
								this.demoNav.css('opacity', 0);
								this.editSave.css('padding', '7px 19px').html('Saving');
								this.enableElements();
								this.add.removeClass('disabled');

								ajaxRequest(
									this.builder.data('edit-page') + '/' + page.data('id'),
									{
										name   : this.editName.val(),
										parent : this.editGroup.val()
									},
									this.addResponse.bind(this),
									'save your changes'
								);
							}
						}
						.bind(this));

						// Change the icon depending on the type of page
						if(page.data('contentStatus'))
						{
							this.editPage.removeClass('non-content');
						}else{
							this.editPage.addClass('non-content');
						}

						this.editCancel.click(function()
						{
							this.editPage.remove();
							page.removeClass('hidden')
							this.enableElements();
						}
						.bind(this));

						this.editPage.append(this.editName, this.editGroupUnder, this.editSave);

						this.disableElements();
						this.add.addClass('disabled');
						this.add_blank.addClass('disabled');
						this.add_menu.addClass('disabled');

						page.addClass('hidden').before(this.editPage);
						this.editName.focus();
						checkProceed.check();
					}
				}
				.bind(this));
			}
			.bind(this));
		},
		deletePages : function()
		{
			this.confirm_delete = Object.create(modal);
			if (this.pages.length)
			{
				this.pages.each(function(i, element)
				{
					var page = $(element);
					if (!page.data('isParent') && !page.data('isSubParent'))
					{
						var remove = page.find('.delete');
						remove.data('id',page.data('id'));
						remove.css('display', 'block').on('click', function()
						{
							if (!remove.hasClass('disabled'))
							{

								var content = $('<div class="edit-image">');
								var container = $('<div class="container">');
								var intro = $('<p class="text-center">Are you sure you want to delete this page?</p>');

								content.append(container);
								container.append(intro);

								var footer = $('<div class="footer">');
								var yes = $('<a class="btn btn-green">Yes</a>');

								yes.on('click', this.deletePagesComplete.bind(this,remove));

								var no = $('<a class="btn btn-red">No</a>');

								no.on('click', this.closeModal.bind(this));

								footer.append(yes, no);

								this.confirm_delete.show('compact', 'Delete Page', false, false, content, footer, this.closeModal.bind(this));
							}
						}
						.bind(this));
					}
				}
				.bind(this));
			}
		},
		closeModal : function ()
		{
			overlay.obj.off('click')
			this.confirm_delete.modal.remove();
			overlay.hide();
		},
		deletePagesComplete : function(remove)
		{
			let page_id = remove.data('id');
			let page = remove.parent();
			this.demoNav.css('opacity', 0);
			page.css('opacity', 0);

			window.setTimeout(function()
			{
				page.css('margin-top', '-47px');
				if (!this.pagesRemaining)
				{
					this.remaining.removeClass('move-up');
				}
			}
			.bind(this), speed);

			this.closeModal();

			ajaxRequest(
				this.builder.data('delete-page') + '/' + page_id,
				{},
				this.addResponse.bind(this),
				'delete the page'
			);
		},
		disableElements : function()
		{
			this.builder.addClass('active');
			this.elements = $('.target-area .handle, .target-area .edit, .target-area .delete');
			this.elements.addClass('disabled');
			this.proceed.addClass('btn-disabled');
		},
		enableElements : function()
		{
			this.builder.removeClass('active');
			this.elements.removeClass('disabled');
			this.checkProceed();
		},
		demo : function()
		{
			this.demoNav = $('.demo-nav');
			var parents = $('.demo-nav a.parent');

			parents.each(function(i , element)
			{
				var link = $(element);
				var menu = link.next();

				link.click(function()
				{
					var parent = link.parent();
					parent.toggleClass('open');
					var height = menu.children().length * 34;

					if (parent.hasClass('open'))
					{
						var open = parent.find('.open ul')
						open.each(function(i , element)
						{
							height += $(element).children().length * 34;
						});

						menu.css('height', height + 'px');

						window.setTimeout(function()
						{
							menu.css('height', 'auto');
						}, speed);
					}
					else
					{
						menu.css('height', menu.height() + 'px');
						window.setTimeout(function()
						{
							menu.css('height', 0);
						}, 20);
					}
				});
			});

			window,setTimeout(function()
			{
				this.demoNav.css('opacity', 1);
			}
			.bind(this), 20);
		}

	}

	var imageGallery = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			overlay : $('.slides-overlay'),
			errors : {

				104 : {

					'title' : 'This is not an image.',
					'message' : 'The following file is not an image.',
					'advice' : 'The image formats we accept are png, jpg and jpeg.'

				},
				105 : {

					'title' : 'This file is too big.',
					'message' : 'The following image is too large.',
					'advice' : 'Maximum size is 20MB.'

				},
				108 : {

					'title' : 'This file is too large.',
					'message' : 'The following image is too large.',
					'advice' : 'Maximum image size is 5000x5000 pixels.'

				},
				'accessDenied' : {

					'title' : 'Session timed out.',
					'message' : 'The following image could not be uploaded due to session timeout.',
					'advice' : 'Please try again.'

				},
				'default' : {

					'title' : 'Something went wrong.',
					'message' : 'The following image could not be uploaded due to an unexpected system error.',
					'advice' : 'Please try again.'

				}

			},
			log : [],

			init : function()
			{
				if (this.gallery.length)
				{
					this.items = this.gallery.find('.items');
					this.images = this.gallery.find('.images');
					this.launch = this.gallery.find('.upload-images');
					this.launch.on('click', this.showUploads.bind(this));
					this.pixabay = this.gallery.find('.add-pixabay');
					this.pixabay.on('click', this.showPixabay.bind(this));
					this.editLinks();
				}
			},
			build : function()
			{
				this.slides = $('<div class="slides slide-gallery-uploads">');
				this.central = $('<div class="central">');
				this.slide = $('<div id="slide-gallery-uploads" class="slide">');

				this.central.append(this.slide);
				this.slides.append(this.central);

				this.slides.css('top', win.scrollTop());

				this.slide.html('<h2>Upload Your Images</h2>'
					+ '<p>Add your images to the upload queue and hit the start button.</p>');

				this.actions = $('<div class="actions">');
				this.add = $('<a id="add-file" class="btn btn-lg btn-blue" href="javascript:;">Add Files</a>');
				this.start = $('<a class="btn btn-lg btn-purple-dark" href="javascript:;">Start Upload</a>');

				this.slide.append(this.actions);
				this.actions.append(this.add, this.start);

				this.queue = $('<div class="upload-queue">');
				this.empty = $('<div class="empty muted">Your upload queue is empty</div>');
				this.headers = $('<div class="headers muted"><div class="filename">Filename</div><div class="size">Size</div><div class="status">Status</div></div>');

				this.slide.append(this.queue);
				this.queue.append(this.empty, this.headers);

				this.progress = $('<div class="progress"></div>');
				this.bar = $('<div class="bar"></div>');
				this.cancel = $('<a class="btn btn-lg btn-grey" href="javascript:;">Cancel</a>');

				this.progress.append(this.bar);
				this.slide.append(this.progress, this.cancel);
			},
			showPixabay : function ()
			{
				this.modalPixabay = Object.create(modal);

				var linkPixabay = '<a class="w-editor-stock-logo" href="https://pixabay.com/" target="_blank"><img src="https://demo.itseeze.com/_webedit/generator/images/pixabay.svg" width="160" height="31"></a>';

				var content = $('<div class="edit-image">');
				var container = $('<div>');
				var options = $('<div class="search">');

				var searchBox = $('<section class="search-row">');
				this.search = $('<input type="text" placeholder="Search Pixabay stock images">');

				var submit = $('<label href="javascript:;">Search</label>');
				submit.on('click', this.searchPixabay.bind(this));

				this.search.keypress(function (e) {
					if (e.which == 13) {
						submit.click();
					}
				});

				this.results = $('<div class="results">');

				var footer = $('<div class="footer">');

				var cancel = $('<a class="btn btn-grey" href="javascript:;">Cancel</a>');
				cancel.on('click', this.closeModal.bind(this));

				searchBox.append(this.search,submit);

				content.append(container);
				container.append(options,this.results);
				options.append(searchBox);
				footer.append(cancel);

				this.modalPixabay.show(
					'compact',
					linkPixabay,
					false,
					false,
					content,
					footer,
					this.closeModal.bind(this),
					1090,
					false
				);
			},
			searchPixabay : function()
			{
				ajaxRequest(
					'/pixabay/search/' + config.currentProject,
					{
						search : this.search.val()
					},
					this.processPixabayResponse.bind(this),
					'add the pixabay image'
				);
			},
			processPixabayResponse: function(data)
			{
				// Control Variables
				var imageLimit = 198; // multiple of 6
				var imageDisplayed = 0;

				// Reset results
				this.results.empty();

				// Display results
				let images = data.images;
				$.each( images, function( index, value ){
					var row = $('<div class="pixabay-image">');
					var image = $('<img src="' + value.thumbnailUrl + '" max-width="100%" max-height="100%">');
					var holder = $('<div class="holder">');
					var use = $('<div data-url="' + value.url + '">Use</div>');
					use.on('click', this.pixabayUse.bind(this));
					var zoom = $('<div data-zoom="' + value.url + '">Zoom</div>');
					zoom.on('click', this.pixabayZoom.bind(this));
					holder.append(use,zoom);
					row.append(holder,image);
					this.results.append(row);

					imageDisplayed++;

					if(imageDisplayed >= imageLimit)
						return false;

				}.bind(this));

				// Completed
				loading.stop();
			},
			pixabayUse: function(data)
			{
				ajaxRequest(
					'/pixabay/add-image/' + config.currentProject,
					{
						url : $(data.currentTarget).data('url'),
						search : this.search.val()
					},
					this.pixabayUseComplete.bind(this),
					'add the pixabay image'
				);
			},
			pixabayUseComplete: function(data)
			{
				if (data.error !== undefined)
				{
					// TODO
				}
				else if (data.success !== undefined)
				{
					var image = $('<div class="image">');
					var a = $('<a href="javascript:;" data-id="' + data.success.id + '" data-name="' + data.success.name + '"data-in-use="0" data-init="false">'
					+ '<h6 class="name">' + data.success.name + '</h6>'
					+ '<img src="' + data.success.thumb + '">'
				+ '</a>');

					a.on('click', this.editLinkWindow.bind(this));
					image.append(a);
					this.images.append(image);
					this.items.addClass('populated');
				}
				loading.stop();
				this.closeModal();
			},
			pixabayZoom: function(data)
			{
				var body = $('body');
				$("div.pixabay-full").remove();

				var fullDiv = $('<div class="pixabay-full">');
				var fullImage = $('<img src="' + $(data.currentTarget).data('zoom') + '">');

				fullDiv.on('click' ,this.pixabayZoomClose);
				fullImage.on('click', this.pixabayZoomClose);

				fullDiv.append(fullImage);
				body.append(fullDiv);
			},
			pixabayZoomClose: function()
			{
				$("div.pixabay-full").remove();
			},
			closeModal : function ()
			{
				overlay.obj.off('click');
				this.modalPixabay.modal.remove();

				$("div.pixabay-full").remove();

				overlay.hide();
			},
			showUploads : function ()
			{
				this.build();

				this.files = {};

				this.cancel.on('click', this.cancelUploads.bind(this));

				this.overlay.addClass('show');
				body.append(this.slides);

				this.uploader = new plupload.Uploader(
				{
					runtimes : 'html5',
					browse_button : 'add-file',
					container: 'slide-gallery-uploads',
					max_file_size : '10mb',
					multipart_params : { _csrf : config.token },
					chunk_size : 204800,
					multi_selection : true,
					url: config.upload.url,
					filters: {

						mime_types : [
							{ title : "Choose the image file you would like to upload", extensions : config.upload.filetypes }
						],
						max_file_size: "20mb",
						prevent_duplicates: true

					},
					headers:{
						'X-UPLOAD-FILE': 'yes'
					},
					max_retries: 0
				});

				this.uploader.init();

				this.uploader.bind('Error', function(up, data)
				{
					up.stop();

					if (data.code == plupload.HTTP_ERROR){
						switch (data.status){
							case 403: // Forbidden

								function retry(){
									data.file.status = plupload.QUEUED;
									up.start();
								}

								accessDenied(retry, 'upload images');

								return;

							break;
						}
					}

					this.log.push({ code : 'default', file : data.file });
					if (typeof this.warning === 'undefined')
					{
						this.showError();
					}
				}
				.bind(this));

				this.uploader.bind('FilesAdded', function(up, files)
				{
					plupload.each(files, function(file)
					{
						var item = $('<div id="' + file.id + '" class="item">'
								+ '<div class="filename">' + file.name + '</div>'
								+ '<div class="size">' + this.formatFileSize(file.size) + '</div>'
							+ '</div>');

						var status = $('<div class="status">'
								+ '<div></div>'
								+ '<svg focusable="false" role="presentation" viewBox="0 0 19 19" class="icon icon-tick"><path d="M0.331,11.117l6.829,6.072L18.67,4.344l-2.838-2.533L6.824,11.886 L2.816,8.337L0.331,11.117z"/></svg>'
								+ '<svg viewBox="0 0 97 89" class="icon icon-warning"><path d="M94.478,69.866c-5.581-9.561-29.38-51.956-35.752-62.901 c-5.499-9.447-14.641-9.105-19.893-0.06c-3.677,6.332-31.285,54.61-36.549,63.873C-2.979,80.041,1.244,89,10.944,89h76.164 C96.461,89,99.77,78.933,94.478,69.866z M49.331,78.124c-3.619,0-6.554-2.937-6.554-6.561c0-3.622,2.935-6.559,6.554-6.559 c3.62,0,6.555,2.937,6.555,6.559C55.886,75.188,52.951,78.124,49.331,78.124z M55.893,29.503 c-0.52,8.153-1.324,16.459-1.716,21.393c-0.392,4.935-1.197,8.831-4.864,8.831s-4.408-2.608-4.92-9.009 c-0.512-6.4-1.015-12.883-1.43-21.131c-0.416-8.249,1.315-11.771,6.573-11.771C54.794,17.815,56.412,21.35,55.893,29.503z"/></svg>'
							+ '</div>');

						var remove = $('<a class="delete" href="javascript:;">'
								+ '<svg viewBox="0 0 20 20" class="icon icon-cross"><polygon points="15.606,0 10,5.606 4.394,0 0,4.394 5.606,10 0,15.606 4.394,20 10,14.394 15.606,20 20,15.606 14.394,10 20,4.394 "/></svg>'
							+ '</a>');

						remove.on('click', function()
						{
							this.uploader.removeFile(file.id);
							item.remove();
							this.updateQueue();
						}
						.bind(this));

						item.append(status);
						status.append(remove);

						this.queue.append(item);
						this.updateQueue();
					}
					.bind(this));
				}
				.bind(this));

				this.uploader.bind('BeforeUpload', function(up, file)
				{
					this.uploader.settings.multipart_params.token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
					$('#'+file.id).find('.status').addClass('uploading');
					this.progress.addClass('show');
				}
				.bind(this));

				this.uploader.bind('FileUploaded', function(up, file, data)
				{
					var response = $.parseJSON(data.response);

					if (response.accessDenied){
						function retry(){}
						accessDenied(retry, 'upload images');

						this.uploadImage.log.push({ code : 'accessDenied', file : file });
						if (typeof this.uploadImage.warning === 'undefined')
						{
							this.uploadImage.showError();
						}
					}
					else if (response.error)
					{
						this.log.push({ code : response.error.code, file : file });
						if (typeof this.warning === 'undefined')
						{
							this.showError();
						}
					}
					else
					{
						$('#'+file.id).find('.status').removeClass('uploading').addClass('complete');

						var image = $('<div class="image">'
							+ '<a href="javascript:;" data-id="' + response.id + '" data-name="' + response.name + '" data-init="false">'
								+ '<h6 class="name">' + response.name + '</h6>'
								+ '<img src="' + response.path + 'thumb/' + response.id + '" ?>'
							+ '</a>'
						+ '</div>');

						this.images.append(image);
						this.showImages();
						this.editLinks();
					}
				}
				.bind(this));

				this.uploader.bind('UploadProgress', function(up, file)
				{
					this.bar.css({ width : up.total.percent+'%' });
				}
				.bind(this));

				this.uploader.bind('UploadComplete', function(up, file)
				{
					this.bar.css({ width : '0%' });
					this.progress.removeClass('show');
					this.cancel.html('Continue').removeClass('btn-grey').addClass('btn-green');
				}
				.bind(this));

				this.start.on('click', function()
				{
					this.uploader.start();
				}
				.bind(this));
			},
			updateQueue : function()
			{
				if (this.uploader.files.length)
				{
					this.queue.addClass('items');
				}
				else
				{
					this.queue.removeClass('items');
				}
			},
			cancelUploads : function()
			{
				this.uploader.destroy();
				this.slides.remove();
				this.overlay.removeClass('show');
			},
			showError : function()
			{
				if (this.log.length)
				{
					var error = this.log.shift();

					$('#'+error.file.id).find('.status').removeClass('uploading').addClass('warning');

					if (typeof this.warning !== 'undefined')
					{
						this.warning.remove();
						delete this.warning;
					}

					this.warning = $('<div class="slide slide-error">');

					if (!this.errors.hasOwnProperty(error.code))
					{
						error.code = 'default';
					}

					this.warning.html('<svg viewBox="0 0 97 89" class="icon icon-warning"><path d="M94.478,69.866c-5.581-9.561-29.38-51.956-35.752-62.901 c-5.499-9.447-14.641-9.105-19.893-0.06c-3.677,6.332-31.285,54.61-36.549,63.873C-2.979,80.041,1.244,89,10.944,89h76.164 C96.461,89,99.77,78.933,94.478,69.866z M49.331,78.124c-3.619,0-6.554-2.937-6.554-6.561c0-3.622,2.935-6.559,6.554-6.559 c3.62,0,6.555,2.937,6.555,6.559C55.886,75.188,52.951,78.124,49.331,78.124z M55.893,29.503 c-0.52,8.153-1.324,16.459-1.716,21.393c-0.392,4.935-1.197,8.831-4.864,8.831s-4.408-2.608-4.92-9.009 c-0.512-6.4-1.015-12.883-1.43-21.131c-0.416-8.249,1.315-11.771,6.573-11.771C54.794,17.815,56.412,21.35,55.893,29.503z"/></svg>'
						+ '<h3>Oops! ' + this.errors[error.code].title + '</h3>'
						+ '<p>' + this.errors[error.code].message + '</p>'
						+ '<div class="error-item">' + error.file.name + '</div>'
						+ '<p class="muted">' + this.errors[error.code].advice + '</p>');

					var close = $('<a class="btn btn-lg btn-v8" href="javascript:;">Continue</a>');

					close.on('click', function()
					{
						this.showError();
					}
					.bind(this));

					this.warning.append(close);

					this.slide.css('display', 'none');
					this.central.append(this.warning);
				}
				else
				{
					this.warning.remove();
					delete this.warning;
					this.slide.css('display', 'block');
				}
			},
			formatFileSize : function(bytes,decimalPoint)
			{
				if(bytes == 0) return '0 Bytes';

				var k = 1000,
					dm = decimalPoint || 2,
					sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
					i = Math.floor(Math.log(bytes) / Math.log(k));

				return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
			},
			editLinks : function()
			{
				var links = $('.image-gallery .image a');
				links.each(function(i, img)
				{
					// As this could be run multiple times we need to ensure there isn't already an on click event
					$(img).prop("onclick", null).off("click");
					$(img).on('click', this.editLinkWindow.bind(this));
				}
				.bind(this));
				var links = $('.image-gallery-gbp .image a');
				links.each(function(i, img)
				{
					// As this could be run multiple times we need to ensure there isn't already an on click event
					$(img).prop("onclick", null).off("click");
					$(img).on('click', this.editLinkWindowGbp.bind(this));
				}
				.bind(this));
			},
			editLinkWindow : function(data)
			{
				var img = $(data.currentTarget)
				var id = img.data('id');
				var name = img.find('.name').html();
				var inUse = img.data('in-use');
				var src = img.find('img').eq(0).attr('src');
				var caption = img.find('.note').eq(0);

				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var image = $('<div class="image"><img src="' + src + '" /></div>');
				var options = $('<div class="options">');
				var note = $('<div class="note">Add a note about this image for our design team.</div>');
				this.warningMessage = $('<div class="text-error"></div>');
				this.warningMessage.hide();

				var section = $('<section>');
				var label_name = $('<label>Name:</label>');
				this.name = $('<input type="text" />');
				this.name.val(name);

				var section_note = $('<section>');
				var label_note = $('<label>Note:</label>');
				this.note = $('<input type="text" />');

				var actions = $('<div class="actions">');

				if (caption.length)
				{
					this.note.val(caption.text());
				}

				var save = $('<a href="javascript:;" class="btn btn-lg btn-green" data-id="' + id + '">Save</a>');
				save.click(this.save.bind(this));

				var cancel = $('<a href="javascript:;" class="btn btn-lg btn-grey">Cancel</a>');
				cancel.on('click', this.cancelEdit.bind(this));

				if (!inUse)
				{
					var remove = $('<a href="#" class="btn btn-lg btn-red" data-id="' + id + '">Delete</a>');
					remove.click(this.delete.bind(this));
				}

				content.append(container);
				container.append(image, options);
				options.append(note, this.warningMessage, section, section_note, actions);
				section.append(label_name, this.name);
				section_note.append(label_note, this.note);
				actions.append(save, cancel, remove);

				this.show('compact', 'Edit Image', false, false, content, false, this.cancelEdit.bind(this), 600);
			},
			editLinkWindowGbp : function(data)
			{
				var img = $(data.currentTarget)
				var id = img.data('id');
				var name = img.find('.name').html();
				var src = img.find('img').eq(0).attr('src');
				var usage = img.find('.usage').eq(0);

				var content = $('<div class="edit-image">');
				var container = $('<div class="container">');
				var image = $('<div class="image"><img src="' + src + '" /></div>');
				var options = $('<div class="options">');
				var note = $('<div class="note">Add a note about this image for our design team.</div>');
				this.warningMessage = $('<div class="text-error"></div>');
				this.warningMessage.hide();

				var section = $('<section>');
				var label_name = $('<label>Name:</label>');
				this.name = $('<input type="text" />');
				this.name.val(name);

				var section_usage = $('<section>');
				var label_usage = $('<label>Usage:</label>');
				this.usage = $('<select />');

				var data = {
					''								: '',
					'Logo'						: 'Logo',
					'Cover'						: 'Cover',
					'Interior'				: 'Interior',
					'Exterior'				: 'Exterior',
					'At work / Team'	: 'At work / Team',
					'Other'						: 'Other',
				}

				for(var val in data) {
					$('<option />', {value: val, text: data[val]}).appendTo(this.usage);
				}

				var actions = $('<div class="actions">');

				if (usage.length)
				{
					this.usage.val(usage.text());
				}

				var save = $('<a href="javascript:;" class="btn btn-lg btn-green" data-id="' + id + '">Save</a>');
				save.click(this.saveGbp.bind(this));

				var cancel = $('<a href="javascript:;" class="btn btn-lg btn-grey">Cancel</a>');
				cancel.on('click', this.cancelEdit.bind(this));

				var remove = $('<a href="#" class="btn btn-lg btn-red" data-id="' + id + '">Delete</a>');
				remove.click(this.deleteGbp.bind(this));

				content.append(container);
				container.append(image, options);
				options.append(note, this.warningMessage, section, section_usage, actions);
				section.append(label_name, this.name);
				section_usage.append(label_usage, this.usage);
				actions.append(save, cancel, remove);

				this.show('compact', 'Edit Photo', false, false, content, false, this.cancelEdit.bind(this), 600);
			},
			cancelEdit : function()
			{
				overlay.obj.off('click');
				this.modal.remove();
				overlay.hide();
			},
			delete : function(e)
			{
				e.preventDefault();
				var id = $(e.currentTarget).data('id');

				ajaxRequest(
					'/upload/delete-gallery-image/' + id,
					{},
					this.deleteComplete.bind(this),
					'delete the image'
				);
			},
			deleteComplete : function(data)
			{
				if (data.success)
				{
					$('.image-gallery .image a[data-id="' + data.success + '"]').parent('.image').remove();
					this.showImages();
				}

				this.modal.remove();
				overlay.hide();
				loading.stop();
			},
			save : function(e)
			{
				e.preventDefault();
				var id = $(e.currentTarget).data('id');

				ajaxRequest(
					'/update/gallery-image/' + id,
					{
						name : this.name.val(),
						note : this.note.val()
					},
					this.saveComplete.bind(this),'save your changes');
			},
			saveComplete : function(data)
			{
				loading.stop();
				if (data.success)
				{
					var img = $('.images .image a[data-id="' + data.id + '"]');
					if (img.length)
					{
						var name = img.find('.name');
						name.html(data.name);
						img.attr('data-name',data.name);

						var note = img.find('.note');
						if (note.length)
						{
							if (data.note == '')
							{
								note.remove();
							}
							else
							{
								note.html(data.note);
							}
						}
						else
						{
							if (data.note != '')
							{
								note = $('<span class="note">');
								note.html(data.note);
								img.append(note);
							}
						}
					}
					overlay.hide();
					this.modal.remove();
				}else{
					this.warningMessage.show();
					this.warningMessage.html(data.message);
				}

			},
			showImages : function()
			{
				if ($('.image-gallery .image a').length)
				{
					this.items.addClass('populated');
				}
				else if ($('.image-gallery-gbp .image a').length)
				{
					this.items.addClass('populated');
				}
				else
				{
					this.items.removeClass('populated');
				}
			},
			saveGbp : function(e)
			{
				e.preventDefault();
				var id = $(e.currentTarget).data('id');

				ajaxRequest(
					'/upload/gbp-edit-image/' + id,
					{
						name : this.name.val(),
						usage : this.usage.val()
					},
					this.saveGbpComplete.bind(this),'save your changes');
			},
			saveGbpComplete : function(data)
			{
				loading.stop();
				if (data.success)
				{
					var img = $('.images .image a[data-id="' + data.id + '"]');
					if (img.length)
					{
						var name = img.find('.name');
						name.html(data.name);
						img.attr('data-name',data.name);

						var usage = img.find('.usage');
						if (usage.length)
						{
							if (data.usage == '')
							{
								usage.remove();
							}
							else
							{
								usage.html(data.usage);
							}
						}
						else
						{
							if (data.usage != '')
							{
								usage = $('<span class="usage">');
								usage.html(data.usage);
								img.append(usage);
							}
						}
					}
					overlay.hide();
					this.modal.remove();
				}else{
					this.warningMessage.show();
					this.warningMessage.html(data.message);
				}

			},
			deleteGbp : function(e)
			{
				e.preventDefault();
				var id = $(e.currentTarget).data('id');

				ajaxRequest(
					'/upload/gbp-delete-image/' + id,
					{},
					this.deleteCompleteGbp.bind(this),
					'delete the photo'
				);
			},
			deleteCompleteGbp : function(data)
			{
				if (data.success)
				{
					$('.image-gallery-gbp .image a[data-id="' + data.success + '"]').parent('.image').remove();
					this.showImagesGbp();
				}

				this.modal.remove();
				overlay.hide();
				loading.stop();
			},
			showImagesGbp : function()
			{
				if ($('.image-gallery-gbp .image a').length)
				{
					this.items.addClass('populated');
				}
				else
				{
					this.items.removeClass('populated');
				}
			}

		});

		return function(gallery)
		{
			var instance = Object.create(prototype);

			instance.gallery = gallery;
			instance.init();

			return instance;
		};
	})();

	var dropSection = (function()
	{
		const prototype = {

			init: function()
			{
				this.body = this.section.children('.body');

				this.body.css('cursor', 'default')
				.on('click', function(e)
				{
					e.stopPropagation();
				}
				.bind(this));

				this.section.on('click', function()
				{
					this.section.hasClass('open') ? this.hide() : this.show();
				}
				.bind(this));
			},
			show: function ()
			{
				var height = this.body.css('height', 'auto').height() + 1;

				this.body.css('height', 0);
				this.section.addClass('open');
				this.body.stop().animate({ height: height }, speed);

				window.setTimeout(function()
				{
					this.body.stop().css('height', 'auto')
				}
				.bind(this), speed);
			},
			hide: function()
			{
				this.section.removeClass('open');
				this.body.stop().animate({ height: 0 }, speed);
			}

		};

		return function(section)
		{
			var instance = Object.create(prototype);

			instance.section = $(section);
			instance.init();

			return instance;
		};
	})();

	var dropSections = function()
	{
		var sections = $('[data-drop]');
		sections.each(function(i, section)
		{
			dropSection(section);
		});
	}

	var reviewSubmit = function()
	{
		var review = $('.review-section');
		if (review.length)
		{
			var contentLinks = review.find('.redactor-styles a');
			contentLinks.attr('target', '_blank');

			contentLinks.on('click', function(e)
			{
				return editorSiteLink($(e.currentTarget));
			});

			var $fileLinks = review.find('.file-box');
			$fileLinks.each(function(i, box) {
				var $box = $(box);
				var link = $box.parent().data('file');

				$box.replaceWith('<a class="file-box" href="' + config.download.url + '/' + link + '">' + $box.html() +'</a>')
			});
		}
	}

	var loginPage = function()
	{
		var login = $('.login-page input[type="text"], .login-page input[type="password"]');
		var page = $('.login-page');

		login.each(function(i, obj)
		{
			var box = $(obj);
			var group = box.parent();

			box.on('focus', function()
			{
				group.addClass('focus');
				page.addClass('focus');
			})
			.on('blur', function()
			{
				group.removeClass('focus');
				page.removeClass('focus');
			});
		});
	}

	var checkRequired = function()
	{
		var focused = false;

		$('[data-required]').each(function(i, obj)
		{
			var obj = $(obj);
			if (obj.is(':visible') && obj.data('required'))
			{
				var error = obj.next('.error-message');
				var hasError = error.length > 0;

				if (!hasError)
				{
					error = $('<div class="error-message">');
				}

				error.html(obj.data('required-message'));

				if (hasError)
				{
					error.addClass('shake');
				}
				else
				{
					obj.addClass('error').after(error);
				}

				if (!focused)
				{
					scroll.obj(obj, -60);
					focused = true;
				}
			}
		});

		window.setTimeout(function()
		{
			$('.shake').removeClass('shake');
		},
		speed * 4);
	}

	var checkProceed = {

		check : function()
		{
			if (typeof config !== 'undefined' && config.proceed)
			{
				this.errors = 0;

				$.each(config.proceed, function(validator, attrs)
				{
					$.each(attrs, function(i, attr)
					{
						this[validator](attr);
					}
					.bind(this));
				}
				.bind(this));
				if (this.errors == 0)
				{
					$('.proceed').removeClass('btn-disabled');
				}
				else
				{
					$('.proceed').addClass('btn-disabled');
				}

				this.ai_errors = 0;

				$.each(config.ai, function(validator, attrs)
				{
					$.each(attrs, function(i, attr)
					{
						this[validator](attr);
					}
					.bind(this));
				}
				.bind(this));
				if (this.ai_errors > 0){
					$('.generate').addClass('btn-disabled');
				}else{
					$('.generate').removeClass('btn-disabled');
				}
			}
			else
			{
				$('.proceed').removeClass('btn-disabled');
			}
		},
		match : function(attr){
			if (!$('#' + attr[0]).length){
				console.log('Error: "' + attr[0] + '" does not exist');
			}else if (!$('#' + attr[1]).length){
				console.log('Error: "' + attr[1] + '" does not exist');
			}else{
				if($('#' + attr[0]).val().trim() != $('#' + attr[1]).val().trim()){
					this.errors++;
				}
			}
		},
		required : function(attr)
		{
			if ($('#' + attr).length){ // Standard require
				if ($('#' + attr).val().trim() == '')
				{
					this.errors++;
				}
			}else if($('.'+ attr).length){ // Editor require
				var box = $('.'+attr);
				var html = box.redactor('core.object').code.get();

				if (html.trim() === '')
				{
					this.errors++;
				}

				var $html = $('<div>').html(html);
				this.removeEmptyTags($html);

				if ($html.html().trim() === '')
				{
					this.errors++;
					box.parent().prev('.js-required').data('required', true);
				}
				else
				{
					box.parent().prev('.js-required').data('required', false);
				}

			}else{
				console.log('Error: "' + attr + '" does not Exist!')
			}
		},
		selected : function(attr)
		{
			if (!$('input[name="'+attr+'"]:checked').val())
			{
				this.errors++;
			}
		},
		option : function(attr)
		{
			if ($('select[name="'+attr+'"] option:selected').val() === '-1')
			{
				this.errors++;
			}
		},
		visible : function(attr)
		{
			if (!$('.'+attr).is(':visible'))
			{
				this.errors++;
			}
		},
		invisible : function(attr)
		{
			if ($('.'+attr).is(':visible'))
			{
				this.errors++;
			}
		},
		condition : function(obj)
		{
			var check = obj[3];

			// Check if obj is input [radio / checkbox]
			var isCheckbox = $('input[name="'+obj[2]+'"]').is(':checkbox');
			var isRadio = $('input[name="'+obj[2]+'"]').is(':radio');
			if(isCheckbox || isRadio){
				var value = $('input[name="'+obj[2]+'"]:checked').val();
				if(value === undefined){ // if unchecked we don't have an off value
					value = 0;
				}
			}else{ // assume obj is select
				value = $('select[name="'+obj[2]+'"] option:selected').val();
			}
			if (value == check)
			{
				this[obj[1]](obj[0]);
			}
		},
		or : function(obj)
		{
			if (!$('#'+obj[0]).is(':checked') && !$('.'+obj[1]).is(':visible'))
			{
				this.errors++;
			}
		},
		count : function(obj)
		{
			if ($('.'+obj[0]).length < obj[1])
			{
				this.errors++;
			}
		},
		editor : function(obj)
		{
			var box = $('.'+obj);
			var html = box.redactor('core.object').code.get();

			if (html.trim() === '')
			{
				this.errors++;
			}

			var $html = $('<div>').html(html);
			this.removeEmptyTags($html);

			if ($html.html().trim() === '')
			{
				this.errors++;
				box.parent().prev('.js-required').data('required', true);
			}
			else
			{
				box.parent().prev('.js-required').data('required', false);
			}
		},
		removeEmptyTags : function($html)
		{
			var $tags = $html.find('*:not(img)');
			var removed = 0;

			$tags.each(function()
			{
					var $tag = $(this);
					if($tag.html().replace(/\s|&nbsp;|<br>/g, '').length == 0)
					{
							$tag.remove();
							removed++;
					}
			});

			if (removed > 0)
			{
				this.removeEmptyTags($html);
			}
		},
		ai_required : function(attr)
		{
			if ($('#' + attr).length){ // Standard require
				if ($('#' + attr).val().trim() == '')
				{
					this.ai_errors++;
				}
			}else{
				console.log('Error: "' + attr + '" does not Exist!')
			}
		},
		ai_option : function(attr)
		{
			if ($('select[name="'+attr+'"] option:selected').val() === '-1')
			{
				this.ai_errors++;
			}
		}
	}

	var actions = {

		init : function()
		{
			var links = $('[data-actions]');
			links.each(function(i, link)
			{
				var link = $(link);
				if (!link.data('initiated'))
				{
					link.data('initiated', true);
					link.on('click', function(e)
					{
						actions.click(e);
					});
				}
			});
		},

		click : function(e)
		{
			e.preventDefault();
			e.stopPropagation();

			var link = $(e.currentTarget);
			if (link.hasClass('btn-disabled'))
			{
				return;
			}

			body.addClass('leaving arriving');
			win.scrollTop(0);
			page.tidy();

			ajaxRequest(
				link.attr('href'),
				{},
				this.done.bind(this),
				'process the request'
			);
		},

		done : function(data)
		{
			window.setTimeout(function()
			{
				if (data.success)
				{
					body.removeClass('leaving');

					window.setTimeout(function()
					{
						if (data.progress)
						{
							progress = data.progress;
							page.setTitle();
							document.title = this.title;
						}

						delete config.temp;

						if (data.config)
						{
							Object.assign(config, data.config);
						}

						if (data.website)
						{
							elements.website.html(data.website);
						}

						if (data.icons)
						{
							elements.iconBar.html(data.icons);
						}

						if (data.content)
						{
							slides.reset();
							elements.content.html(data.content);
						}

						if (data.slides)
						{
							elements.slides.html(data.slides);
						}

						if (data.updateMenu)
						{
							if (data.hasMenu)
							{
								if (data.menu)
								{
									elements.menu.html(data.menu);
									elements.sideBar.addClass('show');
								}

								if ('progressPercent' in data)
								{
									progressPercent = data.progressPercent;
									window.setTimeout(function()
									{
										updateProgress();
									},
									speed);
								}
							}
							else
							{
								elements.sideBar.removeClass('show');
							}
						}

						page.refresh();

						window.setTimeout(function()
						{
							body.removeClass('arriving');
							window.setTimeout(function()
							{
								loading.stop();
								elements.sideBar.removeClass('update');

								if (data.icons)
								{
									iconBar.init();
								}
							}
							.bind(this), speed);
						}
						.bind(this), 20);
					}
					.bind(this), 20);
				}
			}.bind(this), speed);
		}

	}

	var ajax = function()
	{
		var links = $('[data-ajax]');
		links.each(function(i, link)
		{
			var link = $(link);
			if (!link.data('initiated'))
			{
				link.data('initiated', true);
				link.on('click', function(e)
				{
					page.load(e);
				});
			}
		});
	}

	var declineJobs = (function(){

		const prototype = Object.create(modal);

		Object.assign(prototype, {

			init : function (obj){

				this.obj = obj;

				this.obj.off('click').on('click', function(e)
				{
					e.preventDefault();

					this.obj.next('.error-message').remove();

					this.textbox = $('<textarea>');

					//var content = $('<div class="content">');
					//content.append(this.textbox);

					this.textbox.attr('placeholder', 'Enter reject message for Franchisee');

					var footer = $('<div class="footer">');
					var cancel = $('<a class="btn btn-lg btn-green" href="#">No - Cancel</a>');

					cancel.on('click', this.cancel.bind(this));

					this.reject = $('<a class="btn btn-lg btn-red" href="#">Yes - Reject</a>');
					this.reject.on('click', this.update.bind(this));

					footer.append(cancel, this.reject);

					var title = '<svg viewBox="0 0 97 89" class="icon icon-warning"> <path d="M94.478,69.866c-5.581-9.561-29.38-51.956-35.752-62.901 c-5.499-9.447-14.641-9.105-19.893-0.06c-3.677,6.332-31.285,54.61-36.549,63.873C-2.979,80.041,1.244,89,10.944,89h76.164 C96.461,89,99.77,78.933,94.478,69.866z M49.331,78.124c-3.619,0-6.554-2.937-6.554-6.561c0-3.622,2.935-6.559,6.554-6.559 c3.62,0,6.555,2.937,6.555,6.559C55.886,75.188,52.951,78.124,49.331,78.124z M55.893,29.503 c-0.52,8.153-1.324,16.459-1.716,21.393c-0.392,4.935-1.197,8.831-4.864,8.831s-4.408-2.608-4.92-9.009 c-0.512-6.4-1.015-12.883-1.43-21.131c-0.416-8.249,1.315-11.771,6.573-11.771C54.794,17.815,56.412,21.35,55.893,29.503z"/></svg>'
										+ '<br>Reject content'

					this.show(
						'expanded',
						title,
						'Are you sure you want to reject this project?',
						'Please enter complete details of the reason that the content is being rejected below',
						this.textbox,
						footer,
						this.cancel.bind(this),
						false
					);

					this.textbox.focus();
				}
				.bind(this));
			},
			cancel : function (e)
			{
				e.preventDefault();

				overlay.obj.off('click')
				this.modal.remove();
				overlay.hide();
			},
			update : function (e)
			{
				e.preventDefault();

				overlay.obj.off('click');
				this.reject.text('Rejecting...');

				ajaxRequest(
					this.obj.attr('href'),
					{
						reason : this.textbox.val(),
					},
					this.done.bind(this),
					'reject the job'
				);
			},
			done : function (data)
			{
				if (data.url !== undefined)
				{
					window.location = data.url;
					return
				}

				if (data.error === undefined)
				{
					data.error = 'Unable to reject project'
				}

				this.error = $('<div class="error-message">');
				this.error.html(data.error);

				this.textbox.next('.error-message').remove();
				this.textbox.after(this.error);
				this.reject.text('Yes - Reject');

				overlay.obj.on('click', this.update.bind(this));
				loading.stop();

			}

		});


		return function(){
			$('.job-decline').each(function(i, obj)
			{
				Object
				.create(prototype)
				.init($(obj));
			});
		};

	})();

	var page = {

		init : function()
		{
			if (typeof(progress) !== 'undefined')
			{
				this.setTitle();
				document.title = this.title;

				this.url = window.location.pathname + window.location.search;

				var state = {
					url : this.url
				};

				window.history.replaceState(state, this.title, state.url);

				attributes.set();

				updateProgress();

				window.addEventListener('beforeunload', this.beforeunload.bind(this));

				window.onpopstate = function(event)
				{
					if ('state' in event)
					{
						var state = event.state;

						if (state !== null && 'url' in state)
						{
							page.render(state.url, false);
						}
					}
				}
			}
		},
		load : function(e)
		{
			e.preventDefault();
			e.stopPropagation();

			var link = $(e.currentTarget);
			if (link.hasClass('btn-disabled')){
				checkRequired();
			}else if (link.hasClass('no-content')){
				// Do nothing
			}else{
				page.render(link.attr('href'), true);
			}
		},
		search : function(e)
		{
			e.preventDefault();
			var form = $(e.currentTarget);
			page.render(form.attr('action') + '?' + form.serialize(), true);
		},
		beforeunload : function(e)
		{
			// if there are no changes, allow the page to unload
			if ($.isEmptyObject(attributes.changed))
			{
				return;
			}

			// attempt a synchronous ajax request to save the changes

			var complete = false;
			var denied   = false;
			var request = $.ajax({
				url   : '/update/save-all/' + config.currentProject,
				type  : 'POST',
				async : false,
				data  : {
					attributes : attributes.changed
				},
				cache : false
			}).done(function(data){
				if (data.token){
					config.token = data.token;
				}

				if (data.accessDenied){
					denied = true;
				}else if (data.success){
					complete = true;
				}
			});

			// did the request complete successfully?
			if (complete){
				attributes.clear();

				// allow the window to close;
				return;
			}

			// If access was denied, display the login form
			if (denied){

				// Ensure that when the page reloads after the save, we don't save it as history
				this.push = false;

				accessDenied(
					this.savechanges.bind(this)
				);

			}

			// warn the user not to close the page
			e.returnValue = 'You have unsaved changes on this page which will be lost if you continue.';

		},
		render : function(url, push)
		{
			if ($.isEmptyObject(attributes.changed))
			{
				this.request(url, push);
			}
			else
			{
				this.url  = url;
				this.push = push;

				this.savechanges();
			}
		},
		savechanges : function()
		{
			var section = 'project';
			var url 		= '/update/save-all/' + config.currentProject
			if (typeof config.context != 'undefined'){
				section = config.context;
			}
			if(section === 'gbp'){
				url 		= '/update/save-all-gbp/' + config.currentGbp
			}
			ajaxRequest(
				url,
				{
					attributes : attributes.changed
				},
				this.savedone.bind(this),
				'save your changes'
			);
		},
		savedone : function(data)
		{
			if (data.success)
			{
				this.request(this.url, this.push);
			}
			else if (data.errors)
			{
				var focused = false;

				for (var key in data.errors)
				{
					var obj = $('#' + key);
					var error = obj.next('.error-message');
					var hasError = error.length > 0;

					if (!hasError)
					{
						error = $('<div class="error-message">');
					}

					error.html(data.errors[key]);

					if (hasError)
					{
						error.addClass('shake');
					}
					else
					{
						obj.addClass('error').after(error);
					}

					if (!focused)
					{
						scroll.obj(obj, -60);
						focused = true;
					}

					loading.stop();
				}

				window.setTimeout(function()
				{
					$('.shake').removeClass('shake');
				},
				speed * 4);
			}
		},
		request : function(url, push)
		{
			this.push = push;
			this.url  = url;

			var newSection     = url.split('/')[1];

			if (newSection != 'projects' && newSection !== currentSection)
			{
				elements.sideBar.addClass('update');
			}

			body.addClass('leaving arriving');
			win.scrollTop(0);
			this.tidy();

			ajaxRequest(
				this.url,
				{
					currentSection : currentSection
				},
				this.done.bind(this),
				'access the page'
			);
		},
		done : function(data)
		{
			window.setTimeout(function()
			{
				if (data.success)
				{
					body.removeClass('leaving');

					window.setTimeout(function()
					{
						var url = this.url.split("/").slice(1);
						currentSection = url[0];
						var currentAction = url.slice(1).join('/');

						if (this.push)
						{
							var state = {
								url : this.url
							};

							window.history.pushState(state, data.progress && data.progress.title ? this.title : undefined, this.url);
						}

						if (data.progress)
						{
							progress = data.progress;
							this.setTitle();
							document.title = this.title;

						}

						delete config.temp;

						if (data.config)
						{
							Object.assign(config, data.config);
						}

						if (data.website)
						{
							elements.website.html(data.website);
						}

						if (data.icons)
						{
							elements.iconBar.html(data.icons);
						}

						if (data.content)
						{
							slides.reset();
							elements.content.html(data.content);
						}

						if (data.slides)
						{
							elements.slides.html(data.slides);
						}

						if (data.updateMenu)
						{
							if (data.hasMenu)
							{
								if (data.menu)
								{
									elements.menu.html(data.menu);
									elements.sideBar.addClass('show');
								}
								else
								{
									$('.page-link').each(function(i, page){

										var $page = $(page);

										if ($page.data('url') == currentAction)
										{
											$page.addClass('active');
										}
										else
										{
											$page.removeClass('active');
										}

										if (data.pageProgress && $page.data('url') in data.pageProgress)
										{
											if (data.pageProgress[$page.data('url')] == 100 || $page.data('content') > 1)
											{
												$page.addClass('complete');
											}
											else
											{
												$page.removeClass('complete');
											}
										}
									});

								}

								if ('progressPercent' in data)
								{
									progressPercent = data.progressPercent;
									window.setTimeout(function()
									{
										updateProgress();
									},
									speed);
								}
							}
							else
							{
								elements.sideBar.removeClass('show');
							}
						}

						attributes.set();
						this.refresh();

						window.setTimeout(function()
						{
							body.removeClass('arriving');
							window.setTimeout(function()
							{
								loading.stop();
								elements.sideBar.removeClass('update');

								if (data.icons)
								{
									iconBar.init();
								}
							}
							.bind(this), speed);
						}
						.bind(this), 20);
					}
					.bind(this), 20);
				}
			}.bind(this), speed);
		},
		setTitle : function()
		{
			this.title = progress.title;

			if (progress.label){
				$('.page-label').text(progress.label);
			}
		},
		tidy : function()
		{
			$('.redactor-link-tooltip').remove();
		},
		refresh : function()
		{
			ajax();
			slides.init();
			actions.init();
			popups.init();
			dropdowns();
			editor();
			autoTextareas();
			uploads();
			siteElements();
			socialMediaLinks();
			progressBars();
			addSites();
			dropSections();
			reviewSubmit();
			navBuilder.init();
			collections.init();
			checkProceed.check();
			textboxReveal();
			imageGallery($('.image-gallery'));
			imageGallery($('.image-gallery-gbp'));
			declineJobs();
			franchiseNotes();
			pageActions();
		}

	};

	var ajaxRequest = (function()
	{
		const prototype = {

			init : function(url, data, callback, notice)
			{
				data._csrf    = config.token;

				this.url      = url;
				this.data     = data;
				this.callback = callback;
				this.notice   = notice;

				this.request();
			},

			request : function()
			{
				loading.start();

				$.ajax({
					type  : 'POST',
					url   : this.url,
					data  : this.data,
					cache : false
				}).done(
					this.done.bind(this)
				);
			},

			done : function(data)
			{
				if (data.token){
					config.token = data.token;
				}

				if (data.accessDenied){
					loading.stop();
					accessDenied(this.request.bind(this), this.notice);
					return;
				}

				if ( typeof this.callback !== "undefined" && this.callback){
					this.callback(data);
				}
			}

		};

		return function(url, data, callback, notice)
		{
			var instance = Object.create(prototype);

			return instance.init(url, data, callback, notice);
		};

	})();

	var accessDenied = (function()
	{
		const prototype = Object.create(modal);

		Object.assign(prototype, {

			overlay : $('.slides-overlay'),

			init : function()
			{
				this.showLogin();
			},

			showLogin : function()
			{
				this.slides = $('<div class="slides slide-access-denied">');
				this.central = $('<div class="central">');
				this.slide = $('<div id="slide-access-denied" class="slide">');

				this.central.append(this.slide);
				this.slides.append(this.central);

				this.slides.css('top', win.scrollTop());

				this.slide.append($('<div class="header">'
														+'<div class="logo">'
															+'<div class="icon">'
																+'<svg class="icon-uploader" viewBox="0 0 100 51" class="icon icon-uploader">'
																	+'<path d="M97.667,28.616c-1.555,2.852-3.759,5.093-6.609,6.726'
																					+' c-2.852,1.634-6.143,2.45-9.876,2.45h-9.953v12.285H54.511V18.66h9.384L54.626,0h26.87c4.041,0,7.449,0.843,10.223,2.527'
																					+' c2.772,1.685,4.847,3.953,6.221,6.804c1.373,2.851,2.061,6.066,2.061,9.642C100,22.55,99.223,25.765,97.667,28.616z M81.648,14.542'
																					+' c-0.882-1.037-2.229-1.556-4.043-1.556h-6.377v11.819h6.068c1.812,0,3.211-0.518,4.199-1.555c0.981-1.037,1.475-2.462,1.475-4.277'
																					+' C82.971,17.056,82.529,15.579,81.648,14.542z M39.503,18.66h9.175v11.9c0,4.304-1.038,7.984-3.11,11.042'
																					+' c-2.074,3.06-4.938,5.365-8.593,6.921c-3.655,1.555-7.867,2.333-12.636,2.333c-4.77,0-8.981-0.778-12.636-2.333'
																					+' c-3.655-1.556-6.52-3.861-8.592-6.921C1.036,38.544,0,34.863,0,30.56V0h16.719v28.616c0,5.392,2.54,8.087,7.62,8.087'
																					+' s7.621-2.695,7.621-8.087V0h16.719v0.189L39.503,18.66z"/>'
																+'</svg>'
															+'</div>'
															+'<div class="name">it<span>\'</span>s<span>eeze</span> Uploader</div>'
														+'</div>'
													+'</div>'));

				this.slide.append($('<h2>Login Session Expired</h2>'));
				this.slide.append($('<p>You must log back in to ' + this.notice + '.</p>'));

				this.form = $('<form id="login-access-denied" action="/site/re-login" method="post">');
				this.slide.append(this.form);

				var csrf = $('<input name="_csrf" type="hidden">').val(config.token);
				this.form.append(csrf);

				var content = $('<div class="content">'
												+'<div class="form-group">'
													+'<div class="input-addon-group">'
														+'<div class="addon"><span class="icon-profile"></span></div>'
														+'<input id="loginform-username"'
																	+' name="username"'
																	+' placeholder="Account ID"'
																	+' style="background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAZ9JREFUOBGVU7uKwkAUPXmID5AttNyFYBGwsLGwFBUFF/wOhfyE5jPcxkZt/IHFxg+wsZJtrFwS8NWIohZm545xNkp8XcjMnbnnnJk790YyTfPTcZwm+z7whEmSNGWwaqPR+Ca4/AqZCO5BX+STkcBTJ5/gp9HLkb2BR34kEoGu6xewlwQ0TUOxWPQXCIVCIhAMBsEeS6y9MbHpOirNlUoF6XQanU4Hq9UKhmHAsiy0Wq2L2DWZ1i+l4Ccg1et1hwJ0zd1uxzGUwn6/98OLPZbiL1vUxA3OZEI8IhOGlfKdTU3+BrThZ5lMBoVCAev1Gr1eD7PZDIFAALIs80NIRNzAT4DIw+EQm80G2WyWQ1KpFHK5nICr1NvezhIR5iyXSyQSCUSjUSiKgnK5jGQyCVVVEYvF0O12oeTz+R+GJfk3L5n8yWTC+yEej3OxwWCA4/GI7XaLfr/P0/jvlis2VadUKvH+IFK73YZt2yCxcDiM6ZR+SuDuI45GI4zHY8zncxwOB05YLBZ8Pg83BajOjEilummEuVeFmtssvgJurPYHGEKbZ/T0eqIAAAAASUVORK5CYII=&quot;);'
																					+' background-repeat: no-repeat;'
																					+' background-attachment: scroll;'
																					+' background-size: 16px 18px;'
																					+' background-position: 98% 50%;"'
																	+' autocomplete="off"'
																	+' type="text">'
													+'</div>'
													+'<div class="error-message"></div>'
												+'</div>'
												+'<div class="form-group password-group">'
													+'<div class="input-addon-group">'
														+'<div class="addon"><span class="icon-key"></span></div>'
														+'<input id="loginform-password"'
																	+' name="password"'
																	+' placeholder="Password"'
																	+' style="background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAZ9JREFUOBGVU7uKwkAUPXmID5AttNyFYBGwsLGwFBUFF/wOhfyE5jPcxkZt/IHFxg+wsZJtrFwS8NWIohZm545xNkp8XcjMnbnnnJk790YyTfPTcZwm+z7whEmSNGWwaqPR+Ca4/AqZCO5BX+STkcBTJ5/gp9HLkb2BR34kEoGu6xewlwQ0TUOxWPQXCIVCIhAMBsEeS6y9MbHpOirNlUoF6XQanU4Hq9UKhmHAsiy0Wq2L2DWZ1i+l4Ccg1et1hwJ0zd1uxzGUwn6/98OLPZbiL1vUxA3OZEI8IhOGlfKdTU3+BrThZ5lMBoVCAev1Gr1eD7PZDIFAALIs80NIRNzAT4DIw+EQm80G2WyWQ1KpFHK5nICr1NvezhIR5iyXSyQSCUSjUSiKgnK5jGQyCVVVEYvF0O12oeTz+R+GJfk3L5n8yWTC+yEej3OxwWCA4/GI7XaLfr/P0/jvlis2VadUKvH+IFK73YZt2yCxcDiM6ZR+SuDuI45GI4zHY8zncxwOB05YLBZ8Pg83BajOjEilummEuVeFmtssvgJurPYHGEKbZ/T0eqIAAAAASUVORK5CYII=&quot;);'
																					+' background-repeat: no-repeat;'
																					+' background-attachment: scroll;'
																					+' background-size: 16px 18px;'
																					+' background-position: 98% 50%;"'
																	+' autocomplete="off"'
																	+' type="password">'
													+'</div>'
													+'<div class="error-message"></div>'
												+'</div>'
											+'</div>');

				this.form.append(content);

				var button = $('<button class="btn btn-green" type="submit">').text('Login');
				this.form.append(button);

				this.overlay.addClass('show');
				body.append(this.slides);

				this.username = this.form.find('#loginform-username');
				this.password = this.form.find('#loginform-password');

				this.form.on('submit', this.doLogin.bind(this));

			},

			doLogin : function(e)
			{
				e.preventDefault();

				loading.start();

				var url = this.form.attr('action');

				var data = {
					_csrf    : config.token,
					username : this.username.val(),
					password : this.password.val()
				};

				$.ajax({
					type  : 'POST',
					url   : url,
					cache : false,
					data  : data
				}).done(
					this.doneLogin.bind(this)
				);

			},

			doneLogin : function(data)
			{
				loading.stop();

				if (data.token){
					config.token = data.token;
				}

				if (data.success){

					this.slides.remove();
					this.overlay.removeClass('show');

					this.retry();

				}else{

					this.username.val('');
					this.password.val('');

					this.form.find('.password-group .error-message').text(data.error);

				}

			}

		});

		return function(retry, notice)
		{
			var instance = Object.create(prototype);

			instance.retry = retry;
			instance.notice = notice || 'save your changes';
			instance.init();

			return instance;

		};

	})();

	const prototype = {

		init : function()
		{
			page.init();
			iconBar.init();
			forms();

			body.on('submit', '[data-search]', function(e)
			{
				page.search(e);
			});

			body.on('click', '[data-popover]', function(e)
			{
				e.preventDefault();
				popover($(e.currentTarget));
			});

			body.on('click', '[data-content]', function(e)
			{
				e.preventDefault();
				content($(e.currentTarget));
			});

			body.on('change', '[data-radio]', function(e)
			{
				e.preventDefault();
				radio($(e.currentTarget));
			});

			body.on('change', '[data-select]', function(e)
			{
				e.preventDefault();
				select($(e.currentTarget));
			});

			body.on('change', '[data-checkbox]', function(e)
			{
				e.preventDefault();
				checkbox($(e.currentTarget));
			});

			body.on('change', '[data-submit]', function(e)
			{
				e.preventDefault();
				submit($(e.currentTarget));
			});

			body.on('keyup', '[data-selector]', function(e)
			{
				e.preventDefault();
				selector($(e.currentTarget));
			});

			body.on('keyup', '[data-category-search]', function(e)
			{
				e.preventDefault();
				categorySearch($(e.currentTarget));
			});

			body.on('click', '[data-trigger-link]', function(e)
			{
				triggerLink($(e.currentTarget));
			});

			body.on('click', '[data-trigger-ai-generation]', function(e)
			{
				e.preventDefault();
				triggerAiGeneration($(e.currentTarget));
			});

			body.on('click', '[data-trigger-ai-restart]', function(e)
			{
				e.preventDefault();
				triggerAiRestart($(e.currentTarget));
			});

			body.on('click', '[data-trigger-ai-use]', function(e)
			{
				e.preventDefault();
				triggerAiUse($(e.currentTarget));
			});

			body.on('click', '.redactor-link-tooltip-action', function(e)
			{
				return editorSiteLink($(e.currentTarget));
			});

			body.on('click', '[data-trigger-email]', function(data)
			{
				data.preventDefault();
				triggerEmail($(data.currentTarget));
			});

			body.on('click', '[data-trigger-file-edit]', function(data)
			{
				data.preventDefault();
				upload($(data.currentTarget));
			});

			body.on('click', '[data-trigger-draft-create]', function(data)
			{
				data.preventDefault();
				draftProject($(data.currentTarget));
			});

			body.on('click', '[data-trigger-draft-delete]', function(data)
			{
				data.preventDefault();
				draftProject($(data.currentTarget));
			});

			body.on('click', '[data-trigger-draft-import]', function(data)
			{
				data.preventDefault();
				draftProject($(data.currentTarget));
			});

			body.on('click', '[data-trigger-redesign-draft-create]', function(data)
			{
				data.preventDefault();
				draftRedesignProject($(data.currentTarget));
			});

			// Delete draft is the same for both types

			body.on('click', '[data-trigger-redesign-draft-import]', function(data)
			{
				data.preventDefault();
				draftRedesignProject($(data.currentTarget));
			});

			body.on('click', '.franchise_row', function(data)
			{
				data.preventDefault();
				franchiseNote($(data.currentTarget));
			});

			body.on('click', '.gbp_category_row', function(data)
			{
				data.preventDefault();
				gbpCategory($(data.currentTarget));
			});

			body.on('click', '.action_row', function(data)
			{
				data.preventDefault();
				pageAction($(data.currentTarget));
			});

			resize();

			page.refresh();
			loginPage();
		}

	};

	return {
		create : function()
		{
			var instance = Object.create(prototype);
			instance.init();

			return instance;
		}
	};
})();

$(document).ready(function()
{
	uploader.create();
});

}(jQuery));

function nl2br (str, is_xhtml) {
	var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
	return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
}